// AUTO-GENERATED from content/quests/ (h2kdb) — do not edit by hand
/* eslint-disable indent -- generator intentionally emits compact objective literals */
import { CharacterClass, InventoryItem, QuestType } from '../../CharacterTypes';

export interface QuestObjective {
  /** equip: met while the hero wears targetId (live, never consumed; plan 24 D31). */
  type: 'kill' | 'collect' | 'explore' | 'talk' | 'level' | 'equip';
  targetId: string;
  targetCount: number;
  description?: string;
}

/** A map (== zone id) and the world points to mark on it; no points = the whole map. */
export interface QuestGuidanceLocation {
  mapId: string;
  points: Array<{ x: number; y: number }>;
}

/** Compile-time-resolved "where to go" for the quest dialog (plan 02). */
export interface QuestGuidance {
  turnIn: { npcId: string; location: QuestGuidanceLocation };
  objectives: Array<{
    kind: 'kill' | 'collect' | 'explore' | 'talk';
    targetId: string;
    location?: QuestGuidanceLocation;
  }>;
}

export type ContractQuestType = 'main' | 'side' | 'daily' | 'weekly' | 'event' | 'tutorial' | 'kill' | 'fetch' | 'delivery' | 'investigation' | 'story' | 'repeatable' | 'dungeon' | 'raid' | 'pvp' | 'escort' | 'collection' | 'exploration';

export interface QuestDefinition {
  id: string;
  name: string;
  title?: string;
  description: string;
  type: QuestType;
  questType?: ContractQuestType;
  requiredLevel: number;
  requiredClass?: CharacterClass;
  /** Every one must be completed first ("do X and Y first"); authored order. */
  requiredQuests?: string[];
  objectives: QuestObjective[];
  rewards: { xp: number; gold: number; items?: InventoryItem[] };
  startNpc?: string;
  endNpc?: string;
  timeLimit?: number;
  repeatable: boolean;
  /** Featured quest: codex page in the NPC dialog + overworld marker (plan 10). */
  featured?: boolean;
  /** false: no NPC offers it and the server refuses to grant it; saves keep it (plan 24 D28). */
  offered?: boolean;
  /** Why it is not offered — turn it back on when this stops being true. */
  unofferedReason?: string;
  guidance?: QuestGuidance;
  /** Class → ability id taught at turn-in (plan 04); a class with no entry gets none. */
  rewardAbilities?: Record<string, string>;
  /** The quest card shows the taught ability as "?" until turn-in (rewards.ability_hidden). */
  rewardAbilityHidden?: boolean;
  /** Class → one item granted on top of rewards.items (lane AO); see questRewardItemsFor. */
  rewardClassItems?: Record<string, InventoryItem>;
}

export const QUEST_DATABASE: Record<string, QuestDefinition> = {
  'first_hunt': {
    id: 'first_hunt',
    name: 'First Hunt',
    description: 'Tomas asks you to clear the west pasture in First Field, then report to Warden Lark at the east survey post.',
    type: 'kill' as QuestType,
    questType: 'kill',
    requiredLevel: 1,
    objectives: [
    { type: 'kill' as const, targetId: 'pig', targetCount: 8,
      description: 'Hunt 8 pigs in the field beyond the village', },
    ],
    rewards: {
      xp: 100,
      gold: 50,
      items: [
        { id: 'red_potion', name: 'Red Potion', type: 'consumable', quantity: 5, maxStack: 99, description: 'A basic potion that restores 50 HP.', icon: '🧪', stats: { hp: 50 } },
        { id: 'cloth_gloves', name: 'Cloth Gloves', type: 'armor', quantity: 1, maxStack: 1, description: 'Basic cloth gloves.', icon: 'armor_gloves_cloth', stats: { defense: 4, luck: 2 } },
      ],
    },
    startNpc: 'tomas',
    endNpc: 'field_warden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"field_warden","location":{"mapId":"first_field","points":[{"x":14550,"y":1190}]}},"objectives":[{"kind":"kill","targetId":"pig","location":{"mapId":"first_field","points":[{"x":1450,"y":1210},{"x":1700,"y":1210},{"x":1950,"y":1210},{"x":2200,"y":1210},{"x":2450,"y":1210},{"x":2700,"y":1210},{"x":2950,"y":1210},{"x":3200,"y":1210}]}}]}') as QuestGuidance,
    rewardAbilities: {"priest":"brightstep"},
  },
  'pig_feet_collector': {
    id: 'pig_feet_collector',
    name: 'Pig Feet Collector',
    description: 'Naturalist Nessa needs six Pig Feet from the optional shore herd on Brinebristle Strand.',
    type: 'collect' as QuestType,
    questType: 'collection',
    requiredLevel: 2,
    requiredQuests: ['tidewend_welcome'],
    objectives: [
    { type: 'collect' as const, targetId: 'pig_foot', targetCount: 6,
      description: 'Collect 6 Pig Feet from the shore herd on Brinebristle Strand', },
    ],
    rewards: {
      xp: 200,
      gold: 100,
    },
    startNpc: 'beach_naturalist',
    endNpc: 'beach_naturalist',
    repeatable: false,
  },
  'explorer_first_steps': {
    id: 'explorer_first_steps',
    name: 'Explorer\'s First Steps',
    description: 'Visit the scenic Brinebristle Strand. Adventure awaits!',
    type: 'explore' as QuestType,
    questType: 'exploration',
    requiredLevel: 3,
    objectives: [
    { type: 'explore' as const, targetId: 'pig_beach', targetCount: 1,
      description: 'Visit Brinebristle Strand by the strand gate just past Tidewend', },
    ],
    rewards: {
      xp: 150,
      gold: 75,
      items: [
        { id: 'blue_potion', name: 'Blue Potion', type: 'consumable', quantity: 3, maxStack: 99, description: 'Restores 50 MP.', icon: '💙', stats: { mp: 50 } },
      ],
    },
    startNpc: 'sophia',
    endNpc: 'sophia',
    repeatable: false,
  },
  'mighty_warrior': {
    id: 'mighty_warrior',
    name: 'Mighty Warrior',
    description: 'Prove your strength by reaching Level 5.',
    type: 'level' as QuestType,
    questType: 'main',
    requiredLevel: 4,
    objectives: [
    { type: 'level' as const, targetId: 'player_level', targetCount: 5,
      description: 'Reach Level 5', },
    ],
    rewards: {
      xp: 300,
      gold: 150,
      items: [
        { id: 'silver_ring', name: 'Silver Ring', type: 'armor', quantity: 1, maxStack: 1, description: 'A polished silver ring with a faint magical glow.', icon: 'accessory_ring_silver', stats: { luck: 8, hp: 30, mp: 15 } },
      ],
    },
    startNpc: 'captain_elowen',
    endNpc: 'captain_elowen',
    repeatable: false,
  },
  'keep_the_peace': {
    id: 'keep_the_peace',
    name: 'Keep the Peace',
    description: 'The Guard Captain needs help dealing with aggressive slimes near town.',
    type: 'kill' as QuestType,
    questType: 'kill',
    requiredLevel: 3,
    objectives: [
    { type: 'kill' as const, targetId: 'slime', targetCount: 15,
      description: 'Defeat 15 Slimes near town', },
    ],
    rewards: {
      xp: 250,
      gold: 120,
      items: [
        { id: 'red_potion', name: 'Red Potion', type: 'consumable', quantity: 3, maxStack: 99, description: 'A basic potion that restores 50 HP.', icon: '🧪', stats: { hp: 50 } },
      ],
    },
    startNpc: 'guard_captain',
    endNpc: 'guard_captain',
    repeatable: false,
  },
  'slime_samples': {
    id: 'slime_samples',
    name: 'Slime Samples',
    description: 'Sophia needs slime gel for her alchemical research.',
    type: 'collect' as QuestType,
    questType: 'collection',
    requiredLevel: 3,
    requiredQuests: ['first_hunt'],
    objectives: [
    { type: 'collect' as const, targetId: 'slime_gel', targetCount: 15,
      description: 'Collect 15 Slime Gel from defeated slimes', },
    ],
    rewards: {
      xp: 200,
      gold: 100,
      items: [
        { id: 'blue_potion', name: 'Blue Potion', type: 'consumable', quantity: 3, maxStack: 99, description: 'Restores 50 MP.', icon: '💙', stats: { mp: 50 } },
      ],
    },
    startNpc: 'sophia',
    endNpc: 'sophia',
    repeatable: false,
  },
  'mushroom_forager': {
    id: 'mushroom_forager',
    name: 'Mushroom Forager',
    description: 'Gather mushroom spores from the forest floor. They grow near pigs.',
    type: 'collect' as QuestType,
    questType: 'daily',
    requiredLevel: 2,
    objectives: [
    { type: 'collect' as const, targetId: 'mushroom_spore', targetCount: 10,
      description: 'Collect 10 Mushroom Spores', },
    ],
    rewards: {
      xp: 75,
      gold: 30,
    },
    startNpc: 'sophia',
    endNpc: 'sophia',
    repeatable: true,
  },
  'pig_champion': {
    id: 'pig_champion',
    name: 'Pig Champion',
    description: 'The pig population is getting out of hand. Thin the herd.',
    type: 'kill' as QuestType,
    questType: 'daily',
    requiredLevel: 5,
    requiredQuests: ['first_hunt'],
    objectives: [
    { type: 'kill' as const, targetId: 'pig', targetCount: 50,
      description: 'Defeat 50 Pigs', },
    ],
    rewards: {
      xp: 500,
      gold: 200,
    },
    startNpc: 'guard_captain',
    endNpc: 'guard_captain',
    repeatable: true,
  },
  'talk_to_the_guard': {
    id: 'talk_to_the_guard',
    name: 'Talk to the Guard',
    description: 'Captain Elowen says you should speak with the Guard Captain about harbor defense.',
    type: 'talk' as QuestType,
    questType: 'story',
    requiredLevel: 2,
    requiredQuests: ['first_hunt'],
    objectives: [
    { type: 'talk' as const, targetId: 'guard_captain', targetCount: 1,
      description: 'Speak with the Guard Captain', },
    ],
    rewards: {
      xp: 50,
      gold: 25,
    },
    startNpc: 'captain_elowen',
    endNpc: 'guard_captain',
    repeatable: false,
  },
  'learn_to_craft': {
    id: 'learn_to_craft',
    name: 'Learn to Craft',
    description: 'Sophia can teach you the basics of alchemy. Craft a red potion to prove your skill.',
    type: 'collect' as QuestType,
    questType: 'collection',
    requiredLevel: 3,
    objectives: [
    { type: 'collect' as const, targetId: 'red_potion', targetCount: 2,
      description: 'Craft 2 Red Potions using the crafting system', },
    ],
    rewards: {
      xp: 150,
      gold: 50,
      items: [
        { id: 'mushroom_spore', name: 'Mushroom Spore', type: 'material', quantity: 10, maxStack: 99, description: 'Spores from a magical mushroom.', icon: '🍄', stats: {} },
      ],
    },
    startNpc: 'sophia',
    endNpc: 'sophia',
    repeatable: false,
  },
  'elite_slayer': {
    id: 'elite_slayer',
    name: 'Elite Slayer',
    description: 'A powerful elite slime has been spotted. Take it down.',
    type: 'kill' as QuestType,
    questType: 'kill',
    requiredLevel: 5,
    requiredQuests: ['keep_the_peace'],
    objectives: [
    { type: 'kill' as const, targetId: 'elite_slime', targetCount: 1,
      description: 'Defeat the Elite Slime', },
    ],
    rewards: {
      xp: 500,
      gold: 250,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 5, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'guard_captain',
    endNpc: 'guard_captain',
    repeatable: false,
    offered: false,
    unofferedReason: 'Elite Slimes are placed on no map at all; place them somewhere reachable first.',
  },
  'veteran_hunter': {
    id: 'veteran_hunter',
    name: 'Veteran Hunter',
    description: 'Captain Elowen wants proof you can hunt past the harbor. Thin the Orange Mushrooms creeping along the Drowned Road.',
    type: 'kill' as QuestType,
    questType: 'kill',
    requiredLevel: 5,
    requiredQuests: ['first_hunt'],
    objectives: [
    { type: 'kill' as const, targetId: 'mushroom', targetCount: 10,
      description: 'Defeat 10 Orange Mushrooms', },
    ],
    rewards: {
      xp: 400,
      gold: 200,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 1, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'captain_elowen',
    endNpc: 'captain_elowen',
    repeatable: false,
  },
  'explore_wickhaven': {
    id: 'explore_wickhaven',
    name: 'The Ferry to Wickhaven',
    description: 'With the Coil relit, the ferry runs again. Take the dock gate to Tidewend Port, speak to Captain Maris for passage, then follow Wickhaven Port\'s town gate to Lamplighter Isolde by the hearth.',
    type: 'explore' as QuestType,
    questType: 'main',
    requiredLevel: 6,
    requiredQuests: ['beyond_the_coil'],
    objectives: [
    { type: 'explore' as const, targetId: 'wickhaven', targetCount: 1,
      description: 'Sail from Tidewend\'s dock to Wickhaven', },
    ],
    rewards: {
      xp: 300,
      gold: 100,
      items: [
        { id: 'return_scroll', name: 'Return Scroll', type: 'consumable', quantity: 2, maxStack: 99, description: 'Returns you to the last town you visited.', icon: '📜', stats: {} },
      ],
    },
    startNpc: 'old_ferris',
    endNpc: 'wickhaven_lamplighter',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"wickhaven_lamplighter","location":{"mapId":"wickhaven","points":[{"x":940,"y":950}]}},"objectives":[{"kind":"explore","targetId":"wickhaven","location":{"mapId":"wickhaven","points":[]}}]}') as QuestGuidance,
  },
  'supply_run': {
    id: 'supply_run',
    name: 'Supply Run',
    description: 'The guard outpost needs supplies. Deliver potions to the Guard Captain.',
    type: 'collect' as QuestType,
    questType: 'daily',
    requiredLevel: 4,
    requiredQuests: ['talk_to_the_guard'],
    objectives: [
    { type: 'collect' as const, targetId: 'red_potion', targetCount: 5,
      description: 'Deliver 5 Red Potions to the Guard Captain', },
    ],
    rewards: {
      xp: 200,
      gold: 150,
    },
    startNpc: 'guard_captain',
    endNpc: 'guard_captain',
    timeLimit: 300,
    repeatable: true,
  },
  'ready_for_adventure': {
    id: 'ready_for_adventure',
    name: 'Ready for Adventure',
    description: 'Master the basics and reach Level 10. The real adventure begins!',
    type: 'level' as QuestType,
    questType: 'main',
    requiredLevel: 7,
    requiredQuests: ['mighty_warrior'],
    objectives: [
    { type: 'level' as const, targetId: 'player_level', targetCount: 10,
      description: 'Reach Level 10', },
    ],
    rewards: {
      xp: 1000,
      gold: 500,
      items: [
        { id: 'veteran_badge', name: 'Veteran Badge', type: 'material', quantity: 1, maxStack: 1, description: 'Proof of your growth as an adventurer.', icon: '🏅', stats: {} },
      ],
    },
    startNpc: 'captain_elowen',
    endNpc: 'captain_elowen',
    repeatable: false,
  },
  'dark_forest_expedition': {
    id: 'dark_forest_expedition',
    name: 'Lanternwood Expedition',
    description: 'Lanternwood is dangerous after dark. Prove you can handle it by defeating the stumps that walk its paths.',
    type: 'kill' as QuestType,
    questType: 'kill',
    requiredLevel: 5,
    requiredQuests: ['keep_the_peace'],
    objectives: [
    { type: 'kill' as const, targetId: 'stump', targetCount: 10,
      description: 'Defeat 10 Stumps in Lanternwood', },
    ],
    rewards: {
      xp: 400,
      gold: 200,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 5, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'guard_captain',
    endNpc: 'guard_captain',
    repeatable: false,
  },
  'shadow_menace': {
    id: 'shadow_menace',
    name: 'Shadow Menace',
    description: 'Shadow Bats are terrorizing travelers. Clear them out.',
    type: 'kill' as QuestType,
    questType: 'daily',
    requiredLevel: 5,
    objectives: [
    { type: 'kill' as const, targetId: 'shadow_bat', targetCount: 15,
      description: 'Defeat 15 Shadow Bats', },
    ],
    rewards: {
      xp: 350,
      gold: 175,
    },
    startNpc: 'guard_captain',
    endNpc: 'guard_captain',
    repeatable: true,
  },
  'crystal_expedition': {
    id: 'crystal_expedition',
    name: 'Crystal Expedition',
    description: 'Deep beneath the Dark Forest lies the Crystal Caverns. Find the entrance.',
    type: 'explore' as QuestType,
    questType: 'exploration',
    requiredLevel: 8,
    requiredQuests: ['dark_forest_expedition'],
    objectives: [
    { type: 'explore' as const, targetId: 'crystal_caverns', targetCount: 1,
      description: 'Find and enter the Crystal Caverns', },
    ],
    rewards: {
      xp: 500,
      gold: 300,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 2, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'wickhaven_scholar',
    endNpc: 'wickhaven_scholar',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"wickhaven_scholar","location":{"mapId":"wickhaven","points":[{"x":1160,"y":950}]}},"objectives":[{"kind":"explore","targetId":"crystal_caverns","location":{"mapId":"crystal_caverns","points":[]}}]}') as QuestGuidance,
  },
  'golem_threat': {
    id: 'golem_threat',
    name: 'Golem Threat',
    description: 'Stone Golems guard the Crystal Caverns. They must be dealt with.',
    type: 'kill' as QuestType,
    questType: 'kill',
    requiredLevel: 8,
    requiredQuests: ['crystal_expedition'],
    objectives: [
    { type: 'kill' as const, targetId: 'stone_golem', targetCount: 5,
      description: 'Defeat 5 Stone Golems in the Crystal Caverns', },
    ],
    rewards: {
      xp: 600,
      gold: 350,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 10, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'wickhaven_warden',
    endNpc: 'wickhaven_warden',
    repeatable: false,
  },
  'cursed_patrol': {
    id: 'cursed_patrol',
    name: 'Cursed Patrol',
    description: 'Cursed Armor patrols the deepest parts of the caverns. Destroy them.',
    type: 'kill' as QuestType,
    questType: 'kill',
    requiredLevel: 9,
    requiredQuests: ['golem_threat'],
    objectives: [
    { type: 'kill' as const, targetId: 'cursed_armor', targetCount: 3,
      description: 'Defeat 3 Cursed Armor in the Crystal Caverns', },
    ],
    rewards: {
      xp: 800,
      gold: 500,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 3, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'wickhaven_warden',
    endNpc: 'wickhaven_warden',
    repeatable: false,
  },
  'frozen_frontier': {
    id: 'frozen_frontier',
    name: 'Frozen Frontier',
    description: 'The Frozen Lake is treacherous. Defeat the ice drakes that patrol its shores.',
    type: 'kill' as QuestType,
    questType: 'kill',
    requiredLevel: 7,
    objectives: [
    { type: 'kill' as const, targetId: 'ice_drake', targetCount: 8,
      description: 'Defeat 8 Ice Drakes at the Frozen Lake', },
    ],
    rewards: {
      xp: 500,
      gold: 250,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 5, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'wickhaven_warden',
    endNpc: 'wickhaven_warden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"wickhaven_warden","location":{"mapId":"wickhaven","points":[{"x":1380,"y":950}]}},"objectives":[{"kind":"kill","targetId":"ice_drake","location":{"mapId":"frozen_lake","points":[{"x":520,"y":1150},{"x":1200,"y":1150}]}}]}') as QuestGuidance,
  },
  'crystal_hunter': {
    id: 'crystal_hunter',
    name: 'Crystal Hunter',
    description: 'Crystal Spiders have been spotted near the Frozen Lake. Their bodies contain rare materials.',
    type: 'kill' as QuestType,
    questType: 'daily',
    requiredLevel: 10,
    objectives: [
    { type: 'kill' as const, targetId: 'crystal_spider', targetCount: 10,
      description: 'Defeat 10 Crystal Spiders', },
    ],
    rewards: {
      xp: 400,
      gold: 200,
    },
    startNpc: 'wickhaven_scholar',
    endNpc: 'wickhaven_scholar',
    repeatable: true,
    guidance: JSON.parse('{"turnIn":{"npcId":"wickhaven_scholar","location":{"mapId":"wickhaven","points":[{"x":1160,"y":950}]}},"objectives":[{"kind":"kill","targetId":"crystal_spider","location":{"mapId":"frozen_lake","points":[{"x":800,"y":1150}]}}]}') as QuestGuidance,
  },
  'volcano_ascent': {
    id: 'volcano_ascent',
    name: 'Volcano Ascent',
    description: 'The Volcano Summit is the most dangerous place in the land. Only the bravest dare ascend.',
    type: 'explore' as QuestType,
    questType: 'exploration',
    requiredLevel: 12,
    requiredQuests: ['crystal_expedition'],
    objectives: [
    { type: 'explore' as const, targetId: 'volcano_summit', targetCount: 1,
      description: 'Reach the Volcano Summit', },
    ],
    rewards: {
      xp: 800,
      gold: 400,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 5, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'wickhaven_warden',
    endNpc: 'wickhaven_warden',
    repeatable: false,
  },
  'fire_and_fury': {
    id: 'fire_and_fury',
    name: 'Fire and Fury',
    description: 'The Fire Boars at the volcano are more powerful than any you\'ve faced. Prove your strength.',
    type: 'kill' as QuestType,
    questType: 'kill',
    requiredLevel: 12,
    requiredQuests: ['volcano_ascent'],
    objectives: [
    { type: 'kill' as const, targetId: 'fire_boar', targetCount: 15,
      description: 'Defeat 15 Fire Boars at the Volcano Summit', },
    ],
    rewards: {
      xp: 1000,
      gold: 500,
    },
    startNpc: 'wickhaven_warden',
    endNpc: 'wickhaven_warden',
    repeatable: false,
  },
  'void_hunter': {
    id: 'void_hunter',
    name: 'Void Hunter',
    description: 'A Void Wraith has been sighted in the deepest parts of the caverns and volcano. Destroy it.',
    type: 'kill' as QuestType,
    questType: 'kill',
    requiredLevel: 15,
    requiredQuests: ['fire_and_fury'],
    objectives: [
    { type: 'kill' as const, targetId: 'void_wraith', targetCount: 3,
      description: 'Defeat 3 Void Wraiths', },
    ],
    rewards: {
      xp: 2000,
      gold: 1000,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 10, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'wickhaven_warden',
    endNpc: 'wickhaven_warden',
    repeatable: false,
  },
  'daily_volcano_patrol': {
    id: 'daily_volcano_patrol',
    name: 'Volcano Patrol',
    description: 'The volcano creatures are restless. Clear out the threats daily.',
    type: 'kill' as QuestType,
    questType: 'daily',
    requiredLevel: 12,
    objectives: [
    { type: 'kill' as const, targetId: 'lava_slug', targetCount: 10,
      description: 'Defeat 10 Lava Slugs', },
    ],
    rewards: {
      xp: 600,
      gold: 300,
    },
    startNpc: 'wickhaven_warden',
    endNpc: 'wickhaven_warden',
    repeatable: true,
    guidance: JSON.parse('{"turnIn":{"npcId":"wickhaven_warden","location":{"mapId":"wickhaven","points":[{"x":1380,"y":950}]}},"objectives":[{"kind":"kill","targetId":"lava_slug","location":{"mapId":"volcano_summit","points":[{"x":1200,"y":1550}]}}]}') as QuestGuidance,
  },
  'daily_frozen_harvest': {
    id: 'daily_frozen_harvest',
    name: 'Frozen Harvest',
    description: 'Lamplighter Isolde shades Wickhaven\'s lamps with drake scales; the cold cracks glass. Collect drake scales.',
    type: 'collect' as QuestType,
    questType: 'daily',
    requiredLevel: 8,
    objectives: [
    { type: 'collect' as const, targetId: 'drake_scale', targetCount: 5,
      description: 'Collect 5 Drake Scales', },
    ],
    rewards: {
      xp: 400,
      gold: 200,
    },
    startNpc: 'wickhaven_lamplighter',
    endNpc: 'wickhaven_lamplighter',
    repeatable: true,
    guidance: JSON.parse('{"turnIn":{"npcId":"wickhaven_lamplighter","location":{"mapId":"wickhaven","points":[{"x":940,"y":950}]}},"objectives":[{"kind":"collect","targetId":"drake_scale","location":{"mapId":"frozen_lake","points":[{"x":520,"y":1150}]}}]}') as QuestGuidance,
  },
  'daily_elite_bounty': {
    id: 'daily_elite_bounty',
    name: 'Elite Bounty',
    description: 'A bounty has been placed on the Gem Golems. Take them down for a reward.',
    type: 'kill' as QuestType,
    questType: 'daily',
    requiredLevel: 10,
    objectives: [
    { type: 'kill' as const, targetId: 'gem_golem', targetCount: 3,
      description: 'Defeat 3 Gem Golems', },
    ],
    rewards: {
      xp: 800,
      gold: 400,
    },
    startNpc: 'wickhaven_warden',
    endNpc: 'wickhaven_warden',
    repeatable: true,
    guidance: JSON.parse('{"turnIn":{"npcId":"wickhaven_warden","location":{"mapId":"wickhaven","points":[{"x":1380,"y":950}]}},"objectives":[{"kind":"kill","targetId":"gem_golem","location":{"mapId":"crystal_caverns","points":[{"x":2500,"y":1250}]}}]}') as QuestGuidance,
  },
  'champion_of_helix': {
    id: 'champion_of_helix',
    name: 'Champion of Helix',
    description: 'Defeat the Infernal at the Volcano Summit. Only the strongest survive.',
    type: 'kill' as QuestType,
    questType: 'kill',
    requiredLevel: 18,
    requiredQuests: ['void_hunter'],
    objectives: [
    { type: 'kill' as const, targetId: 'infernal', targetCount: 1,
      description: 'Defeat the Infernal Boss', },
    ],
    rewards: {
      xp: 5000,
      gold: 2500,
    },
    startNpc: 'wickhaven_warden',
    endNpc: 'wickhaven_warden',
    repeatable: false,
  },
  'master_alchemist': {
    id: 'master_alchemist',
    name: 'Master Alchemist',
    description: 'Prove your mastery of alchemy by crafting three Power Elixirs.',
    type: 'collect' as QuestType,
    questType: 'collection',
    requiredLevel: 12,
    objectives: [
    { type: 'collect' as const, targetId: 'power_elixir', targetCount: 3,
      description: 'Craft 3 Power Elixirs', },
    ],
    rewards: {
      xp: 1500,
      gold: 800,
    },
    startNpc: 'sophia',
    endNpc: 'sophia',
    repeatable: false,
  },
  'ice_fishing': {
    id: 'ice_fishing',
    name: 'Ice Fishing',
    description: 'The Frozen Lake is full of unique creatures. Help Scholar Merrow study them.',
    type: 'kill' as QuestType,
    questType: 'daily',
    requiredLevel: 7,
    objectives: [
    { type: 'kill' as const, targetId: 'ice_drake', targetCount: 5,
      description: 'Defeat 5 Ice Drakes at the Frozen Lake', },
    ],
    rewards: {
      xp: 350,
      gold: 175,
    },
    startNpc: 'wickhaven_scholar',
    endNpc: 'wickhaven_scholar',
    repeatable: true,
    guidance: JSON.parse('{"turnIn":{"npcId":"wickhaven_scholar","location":{"mapId":"wickhaven","points":[{"x":1160,"y":950}]}},"objectives":[{"kind":"kill","targetId":"ice_drake","location":{"mapId":"frozen_lake","points":[{"x":520,"y":1150},{"x":1200,"y":1150}]}}]}') as QuestGuidance,
  },
  'bee_problem': {
    id: 'bee_problem',
    name: 'The Bee Problem',
    description: 'Giant Bees have infested the Lanternwood canopy. Clear them out.',
    type: 'kill' as QuestType,
    questType: 'daily',
    requiredLevel: 5,
    objectives: [
    { type: 'kill' as const, targetId: 'giant_bee', targetCount: 15,
      description: 'Defeat 15 Giant Bees', },
    ],
    rewards: {
      xp: 250,
      gold: 125,
    },
    startNpc: 'guard_captain',
    endNpc: 'guard_captain',
    repeatable: true,
  },
  'troll_trouble': {
    id: 'troll_trouble',
    name: 'Troll Trouble',
    description: 'Forest Trolls are blocking the path to the deeper forest. Deal with them.',
    type: 'kill' as QuestType,
    questType: 'kill',
    requiredLevel: 7,
    requiredQuests: ['dark_forest_expedition'],
    objectives: [
    { type: 'kill' as const, targetId: 'forest_troll', targetCount: 8,
      description: 'Defeat 8 Forest Trolls', },
    ],
    rewards: {
      xp: 450,
      gold: 225,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 5, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'wickhaven_warden',
    endNpc: 'wickhaven_warden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"wickhaven_warden","location":{"mapId":"wickhaven","points":[{"x":1380,"y":950}]}},"objectives":[{"kind":"kill","targetId":"forest_troll","location":{"mapId":"dark_forest","points":[{"x":1480,"y":1250},{"x":1810,"y":1250},{"x":2140,"y":1250}]}}]}') as QuestGuidance,
  },
  'phoenix_hunt': {
    id: 'phoenix_hunt',
    name: 'Phoenix Hunt',
    description: 'A legendary Phoenix has been spotted at the Volcano Summit. This is the hunt of a lifetime.',
    type: 'kill' as QuestType,
    questType: 'kill',
    requiredLevel: 18,
    requiredQuests: ['fire_and_fury'],
    objectives: [
    { type: 'kill' as const, targetId: 'phoenix', targetCount: 1,
      description: 'Defeat the Phoenix', },
    ],
    rewards: {
      xp: 3000,
      gold: 1500,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 5, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'wickhaven_warden',
    endNpc: 'wickhaven_warden',
    repeatable: false,
  },
  'material_collector': {
    id: 'material_collector',
    name: 'Material Collector',
    description: 'Scholar Merrow needs rare materials from dangerous creatures. Collect what you can.',
    type: 'collect' as QuestType,
    questType: 'daily',
    requiredLevel: 10,
    objectives: [
    { type: 'collect' as const, targetId: 'dark_essence', targetCount: 10,
      description: 'Collect 10 Dark Essence', },
    ],
    rewards: {
      xp: 500,
      gold: 250,
    },
    startNpc: 'wickhaven_scholar',
    endNpc: 'wickhaven_scholar',
    repeatable: true,
    guidance: JSON.parse('{"turnIn":{"npcId":"wickhaven_scholar","location":{"mapId":"wickhaven","points":[{"x":1160,"y":950}]}},"objectives":[{"kind":"collect","targetId":"dark_essence","location":{"mapId":"dark_forest","points":[{"x":1810,"y":1250}]}}]}') as QuestGuidance,
  },
  'sunken_discovery': {
    id: 'sunken_discovery',
    name: 'Sunken Discovery',
    description: 'Ancient ruins have been discovered beneath the Crystal Caverns. Explore them.',
    type: 'explore' as QuestType,
    questType: 'exploration',
    requiredLevel: 15,
    requiredQuests: ['golem_threat'],
    objectives: [
    { type: 'explore' as const, targetId: 'sunken_ruins', targetCount: 1,
      description: 'Enter the Sunken Ruins', },
    ],
    rewards: {
      xp: 1000,
      gold: 500,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 3, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'wickhaven_scholar',
    endNpc: 'wickhaven_scholar',
    repeatable: false,
  },
  'ruin_guardians': {
    id: 'ruin_guardians',
    name: 'Ruin Guardians',
    description: 'Obsidian Sentinels guard the deepest chambers. Clear a path.',
    type: 'kill' as QuestType,
    questType: 'kill',
    requiredLevel: 16,
    requiredQuests: ['sunken_discovery'],
    objectives: [
    { type: 'kill' as const, targetId: 'obsidian_sentinel', targetCount: 5,
      description: 'Defeat 5 Obsidian Sentinels in the Sunken Ruins', },
    ],
    rewards: {
      xp: 1200,
      gold: 600,
    },
    startNpc: 'wickhaven_warden',
    endNpc: 'wickhaven_warden',
    repeatable: false,
  },
  'daily_ruin_sweep': {
    id: 'daily_ruin_sweep',
    name: 'Ruin Sweep',
    description: 'The Sunken Ruins must be kept clear. Return daily to defeat its inhabitants.',
    type: 'kill' as QuestType,
    questType: 'daily',
    requiredLevel: 15,
    objectives: [
    { type: 'kill' as const, targetId: 'cursed_armor', targetCount: 5,
      description: 'Defeat 5 Cursed Armor in the Sunken Ruins', },
    ],
    rewards: {
      xp: 700,
      gold: 350,
    },
    startNpc: 'wickhaven_warden',
    endNpc: 'wickhaven_warden',
    repeatable: true,
    guidance: JSON.parse('{"turnIn":{"npcId":"wickhaven_warden","location":{"mapId":"wickhaven","points":[{"x":1380,"y":950}]}},"objectives":[{"kind":"kill","targetId":"cursed_armor","location":{"mapId":"sunken_ruins","points":[{"x":1000,"y":1550}]}}]}') as QuestGuidance,
  },
  'ancient_power': {
    id: 'ancient_power',
    name: 'Ancient Power',
    description: 'Gem Golems contain crystallized ancient energy. Defeat five and Scholar Merrow will study what is left of them.',
    type: 'kill' as QuestType,
    questType: 'kill',
    requiredLevel: 16,
    objectives: [
    { type: 'kill' as const, targetId: 'gem_golem', targetCount: 5,
      description: 'Defeat 5 Gem Golems', },
    ],
    rewards: {
      xp: 1000,
      gold: 500,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 10, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'wickhaven_scholar',
    endNpc: 'wickhaven_scholar',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"wickhaven_scholar","location":{"mapId":"wickhaven","points":[{"x":1160,"y":950}]}},"objectives":[{"kind":"kill","targetId":"gem_golem","location":{"mapId":"sunken_ruins","points":[{"x":2000,"y":1550}]}}]}') as QuestGuidance,
  },
  'legend_of_helix': {
    id: 'legend_of_helix',
    name: 'Legend of Helix',
    description: 'You\'ve explored every corner of this world. Complete your legend by reaching the ultimate level.',
    type: 'level' as QuestType,
    questType: 'main',
    requiredLevel: 18,
    requiredQuests: ['champion_of_helix'],
    objectives: [
    { type: 'level' as const, targetId: 'player_level', targetCount: 20,
      description: 'Reach Level 20', },
    ],
    rewards: {
      xp: 10000,
      gold: 5000,
    },
    startNpc: 'captain_elowen',
    endNpc: 'captain_elowen',
    repeatable: false,
  },
  'jellyfish_study': {
    id: 'jellyfish_study',
    name: 'Jellyfish Study',
    description: 'Sophia is fascinated by the Jellyfish on Brinebristle Strand. She needs five specimens from the shallows.',
    type: 'kill' as QuestType,
    questType: 'kill',
    requiredLevel: 2,
    objectives: [
    { type: 'kill' as const, targetId: 'jellyfish', targetCount: 5,
      description: 'Defeat 5 Jellyfish on Brinebristle Strand', },
    ],
    rewards: {
      xp: 50,
      gold: 25,
    },
    startNpc: 'sophia',
    endNpc: 'sophia',
    repeatable: false,
  },
  'boar_hunt': {
    id: 'boar_hunt',
    name: 'Boar Hunt',
    description: 'Wild Boars are damaging the forest paths. Help clear them out.',
    type: 'kill' as QuestType,
    questType: 'daily',
    requiredLevel: 6,
    objectives: [
    { type: 'kill' as const, targetId: 'wild_boar', targetCount: 10,
      description: 'Defeat 10 Wild Boars', },
    ],
    rewards: {
      xp: 300,
      gold: 150,
    },
    startNpc: 'guard_captain',
    endNpc: 'guard_captain',
    repeatable: true,
  },
  'crystal_research': {
    id: 'crystal_research',
    name: 'Crystal Research',
    description: 'Crystal Elementals are living gemstones. Study them for Scholar Merrow.',
    type: 'kill' as QuestType,
    questType: 'kill',
    requiredLevel: 11,
    objectives: [
    { type: 'kill' as const, targetId: 'crystal_elemental', targetCount: 5,
      description: 'Defeat 5 Crystal Elementals', },
    ],
    rewards: {
      xp: 600,
      gold: 300,
      items: [
        { id: 'drake_scale', name: 'Drake Scale', type: 'material', quantity: 3, maxStack: 99, description: 'A glittering scale from an ice drake.', icon: 'material_drake_scale', stats: {} },
      ],
    },
    startNpc: 'wickhaven_scholar',
    endNpc: 'wickhaven_scholar',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"wickhaven_scholar","location":{"mapId":"wickhaven","points":[{"x":1160,"y":950}]}},"objectives":[{"kind":"kill","targetId":"crystal_elemental","location":{"mapId":"crystal_caverns","points":[{"x":1600,"y":1650}]}}]}') as QuestGuidance,
  },
  'shadow_investigation': {
    id: 'shadow_investigation',
    name: 'Shadow Investigation',
    description: 'Shadow Stalkers are becoming bolder. Investigate their presence.',
    type: 'kill' as QuestType,
    questType: 'kill',
    requiredLevel: 13,
    objectives: [
    { type: 'kill' as const, targetId: 'shadow_stalker', targetCount: 8,
      description: 'Defeat 8 Shadow Stalkers', },
    ],
    rewards: {
      xp: 700,
      gold: 350,
    },
    startNpc: 'wickhaven_scholar',
    endNpc: 'wickhaven_scholar',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"wickhaven_scholar","location":{"mapId":"wickhaven","points":[{"x":1160,"y":950}]}},"objectives":[{"kind":"kill","targetId":"shadow_stalker","location":{"mapId":"ancient_temple","points":[{"x":1000,"y":1650},{"x":2200,"y":1150}]}}]}') as QuestGuidance,
  },
  'void_containment': {
    id: 'void_containment',
    name: 'Void Containment',
    description: 'Void Walkers are seeping through dimensional cracks. Seal them by force.',
    type: 'kill' as QuestType,
    questType: 'kill',
    requiredLevel: 18,
    requiredQuests: ['fire_and_fury'],
    objectives: [
    { type: 'kill' as const, targetId: 'void_walker', targetCount: 5,
      description: 'Defeat 5 Void Walkers', },
    ],
    rewards: {
      xp: 1500,
      gold: 750,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 3, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'wickhaven_warden',
    endNpc: 'wickhaven_warden',
    repeatable: false,
  },
  'first_armor': {
    id: 'first_armor',
    name: 'First Armor',
    description: 'Put on a Leather Vest and show Blacksmith Erik in Tidewend. He checks the fit and gives you a trail to match — a little light to follow you on the road.',
    type: 'equip' as QuestType,
    questType: 'side',
    requiredLevel: 3,
    objectives: [
    { type: 'equip' as const, targetId: 'leather_vest', targetCount: 1,
      description: 'Equip a Leather Vest', },
    ],
    rewards: {
      xp: 75,
      gold: 50,
      items: [
        { id: 'leather_boots', name: 'Dusk Mote Trail', type: 'armor', quantity: 1, maxStack: 1, description: 'Soft motes the colour of the last hour of daylight. Blacksmith Erik swears they keep a traveller\'s spirits up on long roads.', icon: 'trail_dusk', stats: { defense: 5, dexterity: 3 } },
      ],
    },
    startNpc: 'blacksmith_erik',
    endNpc: 'blacksmith_erik',
    repeatable: false,
  },
  'craft_your_first_ring': {
    id: 'craft_your_first_ring',
    name: 'Craft Your First Ring',
    description: 'Sophia can teach you to craft a Silver Ring from Stone Fragments.',
    type: 'collect' as QuestType,
    questType: 'collection',
    requiredLevel: 5,
    requiredQuests: ['learn_to_craft'],
    objectives: [
    { type: 'collect' as const, targetId: 'silver_ring', targetCount: 1,
      description: 'Craft a Silver Ring', },
    ],
    rewards: {
      xp: 200,
      gold: 100,
    },
    startNpc: 'sophia',
    endNpc: 'sophia',
    repeatable: false,
  },
  'drake_scale_collector': {
    id: 'drake_scale_collector',
    name: 'Drake Scale Collector',
    description: 'Ice Drake scales are valuable crafting materials. Collect them from the Frozen Lake.',
    type: 'collect' as QuestType,
    questType: 'daily',
    requiredLevel: 8,
    objectives: [
    { type: 'collect' as const, targetId: 'drake_scale', targetCount: 10,
      description: 'Collect 10 Drake Scales', },
    ],
    rewards: {
      xp: 400,
      gold: 200,
    },
    startNpc: 'wickhaven_lamplighter',
    endNpc: 'wickhaven_lamplighter',
    repeatable: true,
    guidance: JSON.parse('{"turnIn":{"npcId":"wickhaven_lamplighter","location":{"mapId":"wickhaven","points":[{"x":940,"y":950}]}},"objectives":[{"kind":"collect","targetId":"drake_scale","location":{"mapId":"frozen_lake","points":[{"x":520,"y":1150}]}}]}') as QuestGuidance,
  },
  'daily_material_run': {
    id: 'daily_material_run',
    name: 'Material Run',
    description: 'Sophia\'s alchemy bench always runs short of mushroom spores. Bring her a fresh batch.',
    type: 'collect' as QuestType,
    questType: 'daily',
    requiredLevel: 5,
    objectives: [
    { type: 'collect' as const, targetId: 'mushroom_spore', targetCount: 15,
      description: 'Collect 15 Mushroom Spores', },
    ],
    rewards: {
      xp: 200,
      gold: 100,
    },
    startNpc: 'sophia',
    endNpc: 'sophia',
    repeatable: true,
  },
  'ultimate_crafter': {
    id: 'ultimate_crafter',
    name: 'Ultimate Crafter',
    description: 'Prove your mastery by crafting the legendary Ring of Power.',
    type: 'collect' as QuestType,
    questType: 'collection',
    requiredLevel: 12,
    requiredQuests: ['master_alchemist'],
    objectives: [
    { type: 'collect' as const, targetId: 'ring_of_power', targetCount: 1,
      description: 'Craft a Ring of Power', },
    ],
    rewards: {
      xp: 2000,
      gold: 1000,
    },
    startNpc: 'wickhaven_scholar',
    endNpc: 'wickhaven_scholar',
    repeatable: false,
  },
  'enchanting_basics': {
    id: 'enchanting_basics',
    name: 'Enchanting Basics',
    description: 'Sophia discovered that certain monsters drop enchanted dust. Collect some for her.',
    type: 'collect' as QuestType,
    questType: 'collection',
    requiredLevel: 5,
    objectives: [
    { type: 'collect' as const, targetId: 'enchanted_dust', targetCount: 5,
      description: 'Collect 5 Enchanted Dust', },
    ],
    rewards: {
      xp: 150,
      gold: 75,
    },
    startNpc: 'sophia',
    endNpc: 'sophia',
    repeatable: false,
    offered: false,
    unofferedReason: 'Enchanted Dust drops from nothing and is only crafted; give it a reachable drop or vendor first.',
  },
  'fire_crystal_quest': {
    id: 'fire_crystal_quest',
    name: 'Crystal Flames',
    description: 'Fire Crystals form inside the bodies of fire-attuned creatures. Collect them.',
    type: 'collect' as QuestType,
    questType: 'daily',
    requiredLevel: 10,
    requiredQuests: ['enchanting_basics'],
    objectives: [
    { type: 'collect' as const, targetId: 'fire_crystal', targetCount: 5,
      description: 'Collect 5 Fire Crystals', },
    ],
    rewards: {
      xp: 500,
      gold: 250,
    },
    startNpc: 'wickhaven_scholar',
    endNpc: 'wickhaven_scholar',
    repeatable: true,
    offered: false,
    unofferedReason: 'Fire Crystals drop only in the Sunken Ruins and on the Volcano Summit, over the sea past Wickhaven (plan 28: by the Tidewend ferry after The Hollow Keeper); it also follows Enchanting Basics.',
  },
  'frost_shard_quest': {
    id: 'frost_shard_quest',
    name: 'Frozen Power',
    description: 'Frost Shards from the Frozen Lake contain incredible cold energy.',
    type: 'collect' as QuestType,
    questType: 'daily',
    requiredLevel: 8,
    requiredQuests: ['enchanting_basics'],
    objectives: [
    { type: 'collect' as const, targetId: 'frost_shard', targetCount: 5,
      description: 'Collect 5 Frost Shards', },
    ],
    rewards: {
      xp: 400,
      gold: 200,
    },
    startNpc: 'wickhaven_scholar',
    endNpc: 'wickhaven_scholar',
    repeatable: true,
    offered: false,
    unofferedReason: 'Frost Shards drop only on the Frozen Lake, over the sea past Wickhaven (plan 28: by the Tidewend ferry after The Hollow Keeper); it also follows Enchanting Basics.',
  },
  'void_essence_quest': {
    id: 'void_essence_quest',
    name: 'Void Essence',
    description: 'Void Fragments are the rarest materials in existence. Even one would be invaluable.',
    type: 'collect' as QuestType,
    questType: 'collection',
    requiredLevel: 15,
    requiredQuests: ['fire_crystal_quest'],
    objectives: [
    { type: 'collect' as const, targetId: 'void_fragment', targetCount: 3,
      description: 'Collect 3 Void Fragments from Void Wraiths', },
    ],
    rewards: {
      xp: 1500,
      gold: 750,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 5, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'wickhaven_scholar',
    endNpc: 'wickhaven_scholar',
    repeatable: false,
    offered: false,
    unofferedReason: 'Void Fragments drop only in the zones over the sea past Wickhaven (Crystal Caverns, Sunken Ruins, Volcano Summit; plan 28: by the Tidewend ferry after The Hollow Keeper); it also follows Fire Crystal.',
  },
  'phoenix_feather_quest': {
    id: 'phoenix_feather_quest',
    name: 'Feather of Rebirth',
    description: 'The Phoenix Feather is said to grant its wielder a second chance at life. Obtain one.',
    type: 'collect' as QuestType,
    questType: 'collection',
    requiredLevel: 18,
    requiredQuests: ['phoenix_hunt'],
    objectives: [
    { type: 'collect' as const, targetId: 'phoenix_feather', targetCount: 1,
      description: 'Obtain a Phoenix Feather', },
    ],
    rewards: {
      xp: 3000,
      gold: 2000,
    },
    startNpc: 'wickhaven_lamplighter',
    endNpc: 'wickhaven_lamplighter',
    repeatable: false,
  },
  'temple_discovery': {
    id: 'temple_discovery',
    name: 'Temple Discovery',
    description: 'An ancient temple has been found in the Dark Forest. Explore its chambers.',
    type: 'explore' as QuestType,
    questType: 'exploration',
    requiredLevel: 10,
    objectives: [
    { type: 'explore' as const, targetId: 'ancient_temple', targetCount: 1,
      description: 'Enter the Ancient Temple', },
    ],
    rewards: {
      xp: 800,
      gold: 400,
    },
    startNpc: 'wickhaven_scholar',
    endNpc: 'wickhaven_scholar',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"wickhaven_scholar","location":{"mapId":"wickhaven","points":[{"x":1160,"y":950}]}},"objectives":[{"kind":"explore","targetId":"ancient_temple","location":{"mapId":"ancient_temple","points":[]}}]}') as QuestGuidance,
  },
  'temple_guardians': {
    id: 'temple_guardians',
    name: 'Temple Guardians',
    description: 'War Golems guard the temple\'s inner chambers. Clear a path to the altar.',
    type: 'kill' as QuestType,
    questType: 'kill',
    requiredLevel: 11,
    requiredQuests: ['temple_discovery'],
    objectives: [
    { type: 'kill' as const, targetId: 'war_golem', targetCount: 3,
      description: 'Defeat 3 War Golems in the Ancient Temple', },
    ],
    rewards: {
      xp: 1000,
      gold: 500,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 10, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'wickhaven_warden',
    endNpc: 'wickhaven_warden',
    repeatable: false,
  },
  'daily_temple_clear': {
    id: 'daily_temple_clear',
    name: 'Temple Clear',
    description: 'The temple creatures keep returning. Clear them out daily.',
    type: 'kill' as QuestType,
    questType: 'daily',
    requiredLevel: 10,
    objectives: [
    { type: 'kill' as const, targetId: 'shadow_stalker', targetCount: 10,
      description: 'Defeat 10 Shadow Stalkers', },
    ],
    rewards: {
      xp: 600,
      gold: 300,
    },
    startNpc: 'wickhaven_warden',
    endNpc: 'wickhaven_warden',
    repeatable: true,
    guidance: JSON.parse('{"turnIn":{"npcId":"wickhaven_warden","location":{"mapId":"wickhaven","points":[{"x":1380,"y":950}]}},"objectives":[{"kind":"kill","targetId":"shadow_stalker","location":{"mapId":"ancient_temple","points":[{"x":1000,"y":1650},{"x":2200,"y":1150}]}}]}') as QuestGuidance,
  },
  'altar_mystery': {
    id: 'altar_mystery',
    name: 'The Altar Mystery',
    description: 'The altar at the temple\'s center radiates ancient power. Investigate it.',
    type: 'explore' as QuestType,
    questType: 'exploration',
    requiredLevel: 12,
    requiredQuests: ['temple_guardians'],
    objectives: [
    { type: 'explore' as const, targetId: 'ancient_temple', targetCount: 1,
      description: 'Reach the Altar Platform', },
    ],
    rewards: {
      xp: 1200,
      gold: 600,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 3, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'wickhaven_scholar',
    endNpc: 'wickhaven_scholar',
    repeatable: false,
  },
  'temple_treasures': {
    id: 'temple_treasures',
    name: 'Temple Treasures',
    description: 'Ancient Treants guard the temple\'s treasure room. Defeat them to claim the rewards.',
    type: 'kill' as QuestType,
    questType: 'kill',
    requiredLevel: 13,
    requiredQuests: ['altar_mystery'],
    objectives: [
    { type: 'kill' as const, targetId: 'ancient_treant', targetCount: 5,
      description: 'Defeat 5 Ancient Treants', },
    ],
    rewards: {
      xp: 1500,
      gold: 800,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 5, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'wickhaven_warden',
    endNpc: 'wickhaven_warden',
    repeatable: false,
  },
  'weapon_training': {
    id: 'weapon_training',
    name: 'Weapon Training',
    description: 'Sophia has a weapon upgrade for you, but you need to prove your strength first.',
    type: 'kill' as QuestType,
    questType: 'kill',
    requiredLevel: 4,
    requiredQuests: ['first_hunt'],
    objectives: [
    { type: 'kill' as const, targetId: 'mushroom', targetCount: 15,
      description: 'Defeat 15 Orange Mushrooms on the Drowned Road or in Lanternwood', },
    ],
    rewards: {
      xp: 200,
      gold: 100,
    },
    startNpc: 'sophia',
    endNpc: 'sophia',
    repeatable: false,
    rewardClassItems: {
      druid: { id: 'thornwood_crook', name: 'Thornwood Crook', type: 'weapon', quantity: 1, maxStack: 1, description: 'A shepherd\'s crook grown, not carved, from a living thorn hedge.', icon: 'weapon_staff_thornwood', stats: { magicAttack: 22, intelligence: 4, dexterity: 3, mp: 20 } },
      hunter: { id: 'composite_bow', name: 'Composite Bow', type: 'weapon', quantity: 1, maxStack: 1, description: 'A powerful bow crafted from layered materials.', icon: 'weapon_bow_composite', stats: { attack: 22, dexterity: 8 } },
      mage: { id: 'oak_staff', name: 'Oak Staff', type: 'weapon', quantity: 1, maxStack: 1, description: 'A gnarled oak staff humming with latent energy.', icon: 'weapon_staff_oak', stats: { magicAttack: 25, intelligence: 5, mp: 30 } },
      paladin: { id: 'blessed_warhammer', name: 'Blessed Warhammer', type: 'weapon', quantity: 1, maxStack: 1, description: 'A warhammer blessed by the light. Strikes with divine force.', icon: 'weapon_hammer_blessed', stats: { attack: 20, strength: 4, intelligence: 3 } },
      priest: { id: 'vesper_staff', name: 'Vesper Staff', type: 'weapon', quantity: 1, maxStack: 1, description: 'A pale ashwood staff capped with a lamp of white glass. Its glow steadies a healer\'s hands.', icon: 'weapon_staff_vesper', stats: { magicAttack: 22, intelligence: 5, mp: 40 } },
      rogue: { id: 'shadow_dagger', name: 'Shadow Dagger', type: 'weapon', quantity: 1, maxStack: 1, description: 'A dagger infused with shadow essence. Strikes from the dark.', icon: 'weapon_dagger_shadow', stats: { attack: 18, dexterity: 6, luck: 4 } },
      shaman: { id: 'stormroot_totem', name: 'Stormroot Totem', type: 'weapon', quantity: 1, maxStack: 1, description: 'A carved root-post bound in copper wire. It hums before every storm.', icon: 'weapon_totem_stormroot', stats: { magicAttack: 21, intelligence: 4, strength: 3 } },
      warlock: { id: 'cinder_rod', name: 'Cinder Rod', type: 'weapon', quantity: 1, maxStack: 1, description: 'A blackened iron rod that stays warm long after the fire has gone out.', icon: 'weapon_wand_cinder', stats: { magicAttack: 25, intelligence: 6 } },
      warrior: { id: 'steel_longsword', name: 'Steel Longsword', type: 'weapon', quantity: 1, maxStack: 1, description: 'A well-forged steel blade. Reliable in battle.', icon: 'weapon_sword_steel', stats: { attack: 25, strength: 5 } },
    },
  },
  'potion_apprentice': {
    id: 'potion_apprentice',
    name: 'Potion Apprentice',
    description: 'Sophia needs you to gather ingredients for a special potion.',
    type: 'collect' as QuestType,
    questType: 'collection',
    requiredLevel: 4,
    requiredQuests: ['weapon_training'],
    objectives: [
    { type: 'collect' as const, targetId: 'mushroom_spore', targetCount: 10,
      description: 'Collect 10 Mushroom Spores', },
    { type: 'collect' as const, targetId: 'slime_gel', targetCount: 10,
      description: 'Collect 10 Slime Gel', },
    ],
    rewards: {
      xp: 250,
      gold: 120,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 10, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'sophia',
    endNpc: 'sophia',
    repeatable: false,
  },
  'forest_patrol': {
    id: 'forest_patrol',
    name: 'Forest Patrol',
    description: 'The Lanternwood paths need regular patrols. Clear the threats.',
    type: 'kill' as QuestType,
    questType: 'kill',
    requiredLevel: 5,
    requiredQuests: ['potion_apprentice'],
    objectives: [
    { type: 'kill' as const, targetId: 'stump', targetCount: 10,
      description: 'Defeat 10 Stumps', },
    { type: 'kill' as const, targetId: 'wild_boar', targetCount: 5,
      description: 'Defeat 5 Wild Boars', },
    ],
    rewards: {
      xp: 350,
      gold: 180,
    },
    startNpc: 'guard_captain',
    endNpc: 'guard_captain',
    repeatable: false,
  },
  'gear_up': {
    id: 'gear_up',
    name: 'Gear Up',
    description: 'Captain Elowen offers new martial armor to those who complete her trial.',
    type: 'kill' as QuestType,
    questType: 'kill',
    requiredLevel: 5,
    requiredQuests: ['forest_patrol'],
    objectives: [
    { type: 'kill' as const, targetId: 'shadow_bat', targetCount: 12,
      description: 'Defeat 12 Shadow Bats', },
    ],
    rewards: {
      xp: 400,
      gold: 200,
      items: [
        { id: 'iron_helm', name: 'Iron Helm', type: 'armor', quantity: 1, maxStack: 1, description: 'A sturdy iron helmet.', icon: 'armor_helm_iron', stats: { defense: 12, hp: 30 } },
      ],
    },
    startNpc: 'captain_elowen',
    endNpc: 'captain_elowen',
    repeatable: false,
  },
  'elite_slime_threat': {
    id: 'elite_slime_threat',
    name: 'Elite Slime Threat',
    description: 'An Elite Slime has appeared in the Dark Forest. It\'s stronger than the others.',
    type: 'kill' as QuestType,
    questType: 'kill',
    requiredLevel: 6,
    requiredQuests: ['gear_up'],
    objectives: [
    { type: 'kill' as const, targetId: 'elite_slime', targetCount: 3,
      description: 'Defeat 3 Elite Slimes', },
    ],
    rewards: {
      xp: 500,
      gold: 250,
      items: [
        { id: 'silver_ring', name: 'Silver Ring', type: 'armor', quantity: 1, maxStack: 1, description: 'A polished silver ring with a faint magical glow.', icon: 'accessory_ring_silver', stats: { luck: 8, hp: 30, mp: 15 } },
      ],
    },
    startNpc: 'guard_captain',
    endNpc: 'guard_captain',
    repeatable: false,
    offered: false,
    unofferedReason: 'Elite Slimes are placed on no map at all; place them somewhere reachable first.',
  },
  'frozen_frontier_prep': {
    id: 'frozen_frontier_prep',
    name: 'Frozen Frontier Preparation',
    description: 'The Frozen Lake is dangerous. Sophia wants you to prepare before heading there.',
    type: 'collect' as QuestType,
    questType: 'collection',
    requiredLevel: 7,
    requiredQuests: ['elite_slime_threat'],
    objectives: [
    { type: 'collect' as const, targetId: 'red_potion', targetCount: 10,
      description: 'Have 10 Red Potions ready', },
    { type: 'collect' as const, targetId: 'blue_potion', targetCount: 5,
      description: 'Have 5 Blue Potions ready', },
    ],
    rewards: {
      xp: 350,
      gold: 150,
      items: [
        { id: 'boots_of_swiftness', name: 'Swiftwind Trail', type: 'armor', quantity: 1, maxStack: 1, description: 'A streak of cool wind made visible. The motes lie flat behind you, as if they can barely keep up.', icon: 'trail_swiftwind', stats: { defense: 10, dexterity: 10, hp: 30 } },
      ],
    },
    startNpc: 'sophia',
    endNpc: 'sophia',
    repeatable: false,
  },
  'ice_drake_menace': {
    id: 'ice_drake_menace',
    name: 'Ice Drake Menace',
    description: 'The ice drakes at the Frozen Lake are becoming aggressive. Thin their numbers.',
    type: 'kill' as QuestType,
    questType: 'kill',
    requiredLevel: 7,
    requiredQuests: ['frozen_frontier_prep'],
    objectives: [
    { type: 'kill' as const, targetId: 'ice_drake', targetCount: 10,
      description: 'Defeat 10 Ice Drakes', },
    ],
    rewards: {
      xp: 600,
      gold: 300,
    },
    startNpc: 'wickhaven_warden',
    endNpc: 'wickhaven_warden',
    repeatable: false,
  },
  'scale_collector': {
    id: 'scale_collector',
    name: 'Scale Collector',
    description: 'Drake scales hold a flame like nothing else. Lamplighter Isolde will pay well for them.',
    type: 'collect' as QuestType,
    questType: 'daily',
    requiredLevel: 8,
    requiredQuests: ['ice_drake_menace'],
    objectives: [
    { type: 'collect' as const, targetId: 'drake_scale', targetCount: 10,
      description: 'Collect 10 Drake Scales', },
    ],
    rewards: {
      xp: 500,
      gold: 400,
    },
    startNpc: 'wickhaven_lamplighter',
    endNpc: 'wickhaven_lamplighter',
    repeatable: true,
  },
  'cavern_expedition_prep': {
    id: 'cavern_expedition_prep',
    name: 'Cavern Expedition',
    description: 'Follow the forest road through the Deep Woods and Abandoned Camp to the Old Grove. The Crystal Caverns open beyond its eastern road. Are you ready for the challenge?',
    type: 'kill' as QuestType,
    questType: 'kill',
    requiredLevel: 8,
    requiredQuests: ['scale_collector'],
    objectives: [
    { type: 'kill' as const, targetId: 'cave_bat', targetCount: 10,
      description: 'Defeat 10 Cave Bats in the Crystal Caverns', },
    { type: 'kill' as const, targetId: 'crystal_spider', targetCount: 5,
      description: 'Defeat 5 Crystal Spiders', },
    ],
    rewards: {
      xp: 700,
      gold: 350,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 15, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'wickhaven_warden',
    endNpc: 'wickhaven_warden',
    repeatable: false,
  },
  'welcome_to_helix': {
    id: 'welcome_to_helix',
    name: 'Welcome to Helix',
    description: 'Guide Rafael has a message for you. Speak with him to begin your journey.',
    type: 'talk' as QuestType,
    questType: 'story',
    requiredLevel: 1,
    objectives: [
    { type: 'talk' as const, targetId: 'guide_rafael', targetCount: 1,
      description: 'Speak with Guide Rafael', },
    ],
    rewards: {
      xp: 25,
      gold: 10,
    },
    startNpc: 'guide_rafael',
    endNpc: 'guide_rafael',
    repeatable: false,
  },
  'learn_to_fight': {
    id: 'learn_to_fight',
    name: 'Learn to Fight',
    description: 'Rafael wants you to practice your abilities. Defeat some pigs on Brinebristle Strand.',
    type: 'kill' as QuestType,
    questType: 'kill',
    requiredLevel: 1,
    requiredQuests: ['welcome_to_helix'],
    objectives: [
    { type: 'kill' as const, targetId: 'pig', targetCount: 3,
      description: 'Defeat 3 Pigs on Brinebristle Strand', },
    ],
    rewards: {
      xp: 50,
      gold: 20,
      items: [
        { id: 'red_potion', name: 'Red Potion', type: 'consumable', quantity: 5, maxStack: 99, description: 'A basic potion that restores 50 HP.', icon: '🧪', stats: { hp: 50 } },
      ],
    },
    startNpc: 'guide_rafael',
    endNpc: 'guide_rafael',
    repeatable: false,
  },
  'visit_the_merchant': {
    id: 'visit_the_merchant',
    name: 'Visit the Merchant',
    description: 'Rafael suggests visiting Merchant Maria to learn about shops.',
    type: 'talk' as QuestType,
    questType: 'story',
    requiredLevel: 1,
    requiredQuests: ['learn_to_fight'],
    objectives: [
    { type: 'talk' as const, targetId: 'merchant_maria', targetCount: 1,
      description: 'Speak with Merchant Maria', },
    ],
    rewards: {
      xp: 25,
      gold: 50,
    },
    startNpc: 'guide_rafael',
    endNpc: 'merchant_maria',
    repeatable: false,
  },
  'equipped_for_adventure': {
    id: 'equipped_for_adventure',
    name: 'Equipped for Adventure',
    description: 'Visit Blacksmith Erik to see what armor is available.',
    type: 'talk' as QuestType,
    questType: 'story',
    requiredLevel: 2,
    objectives: [
    { type: 'talk' as const, targetId: 'blacksmith_erik', targetCount: 1,
      description: 'Speak with Blacksmith Erik', },
    ],
    rewards: {
      xp: 25,
      gold: 30,
      items: [
        { id: 'leather_vest', name: 'Leather Vest', type: 'armor', quantity: 1, maxStack: 1, description: 'A simple leather vest offering basic protection.', icon: 'armor_vest_leather', stats: { defense: 8, hp: 20 } },
      ],
    },
    startNpc: 'merchant_maria',
    endNpc: 'blacksmith_erik',
    repeatable: false,
  },
  'prove_yourself': {
    id: 'prove_yourself',
    name: 'Prove Yourself',
    description: 'Defeat monsters to prove your combat readiness in your new armor.',
    type: 'kill' as QuestType,
    questType: 'kill',
    requiredLevel: 2,
    requiredQuests: ['equipped_for_adventure'],
    objectives: [
    { type: 'kill' as const, targetId: 'slime', targetCount: 5,
      description: 'Defeat 5 Slimes', },
    { type: 'kill' as const, targetId: 'snail', targetCount: 5,
      description: 'Defeat 5 Snails', },
    ],
    rewards: {
      xp: 100,
      gold: 50,
      items: [
        { id: 'leather_boots', name: 'Dusk Mote Trail', type: 'armor', quantity: 1, maxStack: 1, description: 'Soft motes the colour of the last hour of daylight. Blacksmith Erik swears they keep a traveller\'s spirits up on long roads.', icon: 'trail_dusk', stats: { defense: 5, dexterity: 3 } },
      ],
    },
    startNpc: 'blacksmith_erik',
    endNpc: 'blacksmith_erik',
    repeatable: false,
  },
  'corruption_spreads_1': {
    id: 'corruption_spreads_1',
    name: 'The Corruption Spreads',
    description: 'Warden Rowan warns that dark energy is seeping from the forest. Speak with him to learn what lies ahead.',
    type: 'talk' as QuestType,
    questType: 'main',
    requiredLevel: 6,
    requiredQuests: ['beyond_the_coil'],
    objectives: [
    { type: 'talk' as const, targetId: 'warden_rowan', targetCount: 1,
      description: 'Speak with Warden Rowan about the dark energy', },
    ],
    rewards: {
      xp: 100,
      gold: 25,
    },
    startNpc: 'warden_rowan',
    endNpc: 'warden_rowan',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"warden_rowan","location":{"mapId":"tidewend","points":[{"x":3200,"y":950}]}},"objectives":[]}') as QuestGuidance,
  },
  'corruption_spreads_2': {
    id: 'corruption_spreads_2',
    name: 'Corrupted Trolls',
    description: 'Corrupted forest trolls roam the Dark Forest, at the end of the forest road from Wickhaven\'s gate. Thin their numbers before the corruption spreads further.',
    type: 'kill' as QuestType,
    questType: 'main',
    requiredLevel: 6,
    requiredQuests: ['corruption_spreads_1'],
    objectives: [
    { type: 'kill' as const, targetId: 'forest_troll', targetCount: 8,
      description: 'Defeat 8 Forest Trolls in the Dark Forest', },
    ],
    rewards: {
      xp: 300,
      gold: 75,
      items: [
        { id: 'red_potion', name: 'Red Potion', type: 'consumable', quantity: 3, maxStack: 99, description: 'A basic potion that restores 50 HP.', icon: '🧪', stats: { hp: 50 } },
      ],
    },
    startNpc: 'wickhaven_warden',
    endNpc: 'wickhaven_warden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"wickhaven_warden","location":{"mapId":"wickhaven","points":[{"x":1380,"y":950}]}},"objectives":[{"kind":"kill","targetId":"forest_troll","location":{"mapId":"dark_forest","points":[{"x":1480,"y":1250},{"x":1810,"y":1250},{"x":2140,"y":1250}]}}]}') as QuestGuidance,
  },
  'corruption_spreads_3': {
    id: 'corruption_spreads_3',
    name: 'Dark Crystals',
    description: 'The corruption crystallizes in dark shards. Collect them for Scholar Merrow to study.',
    type: 'collect' as QuestType,
    questType: 'main',
    requiredLevel: 7,
    requiredQuests: ['corruption_spreads_2'],
    objectives: [
    { type: 'collect' as const, targetId: 'dark_essence', targetCount: 5,
      description: 'Collect 5 Dark Crystals from corrupted creatures', },
    ],
    rewards: {
      xp: 350,
      gold: 100,
    },
    startNpc: 'wickhaven_warden',
    endNpc: 'wickhaven_warden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"wickhaven_warden","location":{"mapId":"wickhaven","points":[{"x":1380,"y":950}]}},"objectives":[{"kind":"collect","targetId":"dark_essence","location":{"mapId":"dark_forest","points":[{"x":1810,"y":1250}]}}]}') as QuestGuidance,
  },
  'corruption_spreads_4': {
    id: 'corruption_spreads_4',
    name: 'The Scholar\'s Reading',
    description: 'Discuss the dark crystals with Scholar Merrow by the well; Halden has already sent him the samples.',
    type: 'delivery' as QuestType,
    questType: 'main',
    requiredLevel: 7,
    requiredQuests: ['corruption_spreads_3'],
    objectives: [
    { type: 'talk' as const, targetId: 'wickhaven_scholar', targetCount: 1,
      description: 'Discuss Halden\'s samples with Scholar Merrow', },
    ],
    rewards: {
      xp: 200,
      gold: 50,
    },
    startNpc: 'wickhaven_warden',
    endNpc: 'wickhaven_scholar',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"wickhaven_scholar","location":{"mapId":"wickhaven","points":[{"x":1160,"y":950}]}},"objectives":[]}') as QuestGuidance,
  },
  'corruption_spreads_5': {
    id: 'corruption_spreads_5',
    name: 'The Alpha',
    description: 'Blightroot, the oldest of the Dark Stumps, guards the heart of the corruption. Defeat it to cleanse the forest.',
    type: 'kill' as QuestType,
    questType: 'main',
    requiredLevel: 8,
    requiredQuests: ['corruption_spreads_4', 'keepers_journal'],
    objectives: [
    { type: 'kill' as const, targetId: 'blightroot_alpha', targetCount: 1,
      description: 'Defeat Blightroot, the Alpha, in the Dark Forest', },
    ],
    rewards: {
      xp: 500,
      gold: 200,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 2, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'wickhaven_warden',
    endNpc: 'wickhaven_warden',
    repeatable: false,
    featured: true,
    guidance: JSON.parse('{"turnIn":{"npcId":"wickhaven_warden","location":{"mapId":"wickhaven","points":[{"x":1380,"y":950}]}},"objectives":[{"kind":"kill","targetId":"blightroot_alpha","location":{"mapId":"dark_forest","points":[{"x":2510,"y":1204}]}}]}') as QuestGuidance,
  },
  'missing_supplies_1': {
    id: 'missing_supplies_1',
    name: 'Missing Merchant',
    description: 'A merchant\'s supply shipment never arrived at Brinebristle Strand. Investigate.',
    type: 'talk' as QuestType,
    questType: 'side',
    requiredLevel: 8,
    objectives: [
    { type: 'talk' as const, targetId: 'merchant_maria', targetCount: 1,
      description: 'Hear Merchant Maria out about the lost shipment', },
    ],
    rewards: {
      xp: 150,
      gold: 30,
    },
    startNpc: 'merchant_maria',
    endNpc: 'merchant_maria',
    repeatable: false,
  },
  'missing_supplies_2': {
    id: 'missing_supplies_2',
    name: 'Lost on the Ice',
    description: 'Search the Frozen Lake for the lost supply crates.',
    type: 'exploration' as QuestType,
    questType: 'side',
    requiredLevel: 9,
    requiredQuests: ['missing_supplies_1'],
    objectives: [
    { type: 'explore' as const, targetId: 'frozen_lake', targetCount: 1,
      description: 'Search the Frozen Lake for supply crates', },
    ],
    rewards: {
      xp: 250,
      gold: 60,
    },
    startNpc: 'wickhaven_grocer',
    endNpc: 'wickhaven_grocer',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"wickhaven_grocer","location":{"mapId":"wickhaven","points":[{"x":470,"y":950}]}},"objectives":[{"kind":"explore","targetId":"frozen_lake","location":{"mapId":"frozen_lake","points":[]}}]}') as QuestGuidance,
  },
  'missing_supplies_3': {
    id: 'missing_supplies_3',
    name: 'Clear the Path',
    description: 'Hostile creatures guard the supply crates. Clear them out.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 10,
    requiredQuests: ['missing_supplies_2'],
    objectives: [
    { type: 'kill' as const, targetId: 'crystal_spider', targetCount: 10,
      description: 'Defeat 10 Crystal Spiders guarding the crates', },
    ],
    rewards: {
      xp: 400,
      gold: 120,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 5, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'wickhaven_grocer',
    endNpc: 'wickhaven_grocer',
    repeatable: false,
  },
  'missing_supplies_4': {
    id: 'missing_supplies_4',
    name: 'Supplies Recovered',
    description: 'Take the recovered supplies home to Merchant Maria in The First Hearth.',
    type: 'delivery' as QuestType,
    questType: 'side',
    requiredLevel: 10,
    requiredQuests: ['missing_supplies_3'],
    objectives: [
    { type: 'talk' as const, targetId: 'merchant_maria', targetCount: 1,
      description: 'Return the supplies to Merchant Maria', },
    ],
    rewards: {
      xp: 300,
      gold: 200,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 1, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'wickhaven_grocer',
    endNpc: 'merchant_maria',
    repeatable: false,
  },
  'crystal_expedition_1': {
    id: 'crystal_expedition_1',
    name: 'Crystal Mining',
    description: 'The Crystal Caverns hold rare minerals. Bring Scholar Merrow pieces of them.',
    type: 'collect' as QuestType,
    questType: 'side',
    requiredLevel: 11,
    objectives: [
    { type: 'collect' as const, targetId: 'stone_fragment', targetCount: 8,
      description: 'Collect 8 Stone Fragments from the cavern nodes', },
    ],
    rewards: {
      xp: 350,
      gold: 100,
    },
    startNpc: 'wickhaven_scholar',
    endNpc: 'wickhaven_scholar',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"wickhaven_scholar","location":{"mapId":"wickhaven","points":[{"x":1160,"y":950}]}},"objectives":[{"kind":"collect","targetId":"stone_fragment","location":{"mapId":"crystal_caverns","points":[{"x":1600,"y":1650}]}}]}') as QuestGuidance,
  },
  'crystal_expedition_2': {
    id: 'crystal_expedition_2',
    name: 'Crystal Guardians',
    description: 'Crystal Elementals have become aggressive. Defeat them to secure the mine.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 11,
    requiredQuests: ['crystal_expedition_1'],
    objectives: [
    { type: 'kill' as const, targetId: 'crystal_elemental', targetCount: 6,
      description: 'Defeat 6 Crystal Elementals', },
    ],
    rewards: {
      xp: 450,
      gold: 150,
    },
    startNpc: 'wickhaven_scholar',
    endNpc: 'wickhaven_scholar',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"wickhaven_scholar","location":{"mapId":"wickhaven","points":[{"x":1160,"y":950}]}},"objectives":[{"kind":"kill","targetId":"crystal_elemental","location":{"mapId":"crystal_caverns","points":[{"x":1600,"y":1650}]}}]}') as QuestGuidance,
  },
  'crystal_expedition_3': {
    id: 'crystal_expedition_3',
    name: 'The Crystal Guardian',
    description: 'A massive Gem Golem guards the deepest chamber. Defeat it to secure the caverns.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 12,
    requiredQuests: ['crystal_expedition_2'],
    objectives: [
    { type: 'kill' as const, targetId: 'gem_golem', targetCount: 1,
      description: 'Defeat the Gem Golem boss', },
    ],
    rewards: {
      xp: 600,
      gold: 250,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 3, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'wickhaven_scholar',
    endNpc: 'wickhaven_scholar',
    repeatable: false,
  },
  'crystal_expedition_4': {
    id: 'crystal_expedition_4',
    name: 'The Scholar\'s Reward',
    description: 'Return the crystals to Scholar Merrow, who may unlock new recipes for you.',
    type: 'delivery' as QuestType,
    questType: 'side',
    requiredLevel: 12,
    requiredQuests: ['crystal_expedition_3'],
    objectives: [
    { type: 'talk' as const, targetId: 'wickhaven_scholar', targetCount: 1,
      description: 'Deliver the crystals to Scholar Merrow', },
    ],
    rewards: {
      xp: 400,
      gold: 200,
    },
    startNpc: 'wickhaven_scholar',
    endNpc: 'wickhaven_scholar',
    repeatable: false,
  },
  'ancient_temple_1': {
    id: 'ancient_temple_1',
    name: 'Ancient Runes',
    description: 'Strange runes glow on the temple walls. Decipher them to unlock its secrets.',
    type: 'investigation' as QuestType,
    questType: 'main',
    requiredLevel: 10,
    objectives: [
    { type: 'explore' as const, targetId: 'ancient_temple', targetCount: 1,
      description: 'Explore the Ancient Temple and decipher the runes', },
    ],
    rewards: {
      xp: 300,
      gold: 80,
    },
    startNpc: 'wickhaven_scholar',
    endNpc: 'wickhaven_scholar',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"wickhaven_scholar","location":{"mapId":"wickhaven","points":[{"x":1160,"y":950}]}},"objectives":[{"kind":"explore","targetId":"ancient_temple","location":{"mapId":"ancient_temple","points":[]}}]}') as QuestGuidance,
  },
  'ancient_temple_2': {
    id: 'ancient_temple_2',
    name: 'Temple Guardians',
    description: 'Undead guardians patrol the temple halls. Clear a path to the inner sanctum.',
    type: 'kill' as QuestType,
    questType: 'main',
    requiredLevel: 11,
    requiredQuests: ['ancient_temple_1'],
    objectives: [
    { type: 'kill' as const, targetId: 'cursed_armor', targetCount: 8,
      description: 'Defeat 8 Cursed Armors in the Ancient Temple', },
    ],
    rewards: {
      xp: 500,
      gold: 150,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 5, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'wickhaven_scholar',
    endNpc: 'wickhaven_scholar',
    repeatable: false,
  },
  'ancient_temple_3': {
    id: 'ancient_temple_3',
    name: 'The Altar Puzzle',
    description: 'An ancient altar blocks the path. Interact with it to solve the puzzle.',
    type: 'investigation' as QuestType,
    questType: 'main',
    requiredLevel: 12,
    requiredQuests: ['ancient_temple_2'],
    objectives: [
    { type: 'explore' as const, targetId: 'ancient_temple', targetCount: 1,
      description: 'Solve the altar puzzle in the Ancient Temple', },
    ],
    rewards: {
      xp: 350,
      gold: 100,
    },
    startNpc: 'wickhaven_scholar',
    endNpc: 'wickhaven_scholar',
    repeatable: false,
  },
  'ancient_temple_4': {
    id: 'ancient_temple_4',
    name: 'The Temple Keeper',
    description: 'A powerful guardian protects the artifact. Defeat the Void Wraith to claim it.',
    type: 'kill' as QuestType,
    questType: 'main',
    requiredLevel: 15,
    requiredQuests: ['ancient_temple_3'],
    objectives: [
    { type: 'kill' as const, targetId: 'void_wraith', targetCount: 1,
      description: 'Defeat the Void Wraith guardian', },
    ],
    rewards: {
      xp: 800,
      gold: 400,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 3, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'wickhaven_scholar',
    endNpc: 'wickhaven_scholar',
    repeatable: false,
  },
  'ancient_temple_5': {
    id: 'ancient_temple_5',
    name: 'The Ancient Artifact',
    description: 'Claim the artifact and bring it to Scholar Merrow in Wickhaven. Its power could turn the tide.',
    type: 'delivery' as QuestType,
    questType: 'main',
    requiredLevel: 15,
    requiredQuests: ['ancient_temple_4'],
    objectives: [
    { type: 'talk' as const, targetId: 'wickhaven_scholar', targetCount: 1,
      description: 'Bring the artifact to Scholar Merrow', },
    ],
    rewards: {
      xp: 500,
      gold: 300,
    },
    startNpc: 'wickhaven_scholar',
    endNpc: 'wickhaven_scholar',
    repeatable: false,
  },
  'frozen_mystery_1': {
    id: 'frozen_mystery_1',
    name: 'Frozen Bodies',
    description: 'Frozen adventurer remains dot the lake shore. Investigate what happened.',
    type: 'investigation' as QuestType,
    questType: 'side',
    requiredLevel: 6,
    objectives: [
    { type: 'explore' as const, targetId: 'frozen_lake', targetCount: 1,
      description: 'Investigate the frozen remains at the lake', },
    ],
    rewards: {
      xp: 200,
      gold: 50,
    },
    startNpc: 'wickhaven_warden',
    endNpc: 'wickhaven_warden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"wickhaven_warden","location":{"mapId":"wickhaven","points":[{"x":1380,"y":950}]}},"objectives":[{"kind":"explore","targetId":"frozen_lake","location":{"mapId":"frozen_lake","points":[]}}]}') as QuestGuidance,
  },
  'frozen_mystery_2': {
    id: 'frozen_mystery_2',
    name: 'Ice Elementals',
    description: 'Ice Elementals roam the frozen shore. Defeat them to collect ice shards for analysis.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 7,
    requiredQuests: ['frozen_mystery_1'],
    objectives: [
    { type: 'kill' as const, targetId: 'snow_wolf', targetCount: 8,
      description: 'Defeat 8 Snow Wolves on the Frozen Lake', },
    ],
    rewards: {
      xp: 350,
      gold: 100,
      items: [
        { id: 'blue_potion', name: 'Blue Potion', type: 'consumable', quantity: 3, maxStack: 99, description: 'Restores 50 MP.', icon: '💙', stats: { mp: 50 } },
      ],
    },
    startNpc: 'wickhaven_warden',
    endNpc: 'wickhaven_warden',
    repeatable: false,
  },
  'frozen_mystery_3': {
    id: 'frozen_mystery_3',
    name: 'Follow the Tracks',
    description: 'Strange tracks lead deeper into the frozen wasteland. Follow them.',
    type: 'exploration' as QuestType,
    questType: 'side',
    requiredLevel: 9,
    requiredQuests: ['frozen_mystery_2'],
    objectives: [
    { type: 'explore' as const, targetId: 'frozen_lake', targetCount: 1,
      description: 'Follow the tracks to the ice cave', },
    ],
    rewards: {
      xp: 300,
      gold: 80,
    },
    startNpc: 'wickhaven_warden',
    endNpc: 'wickhaven_warden',
    repeatable: false,
  },
  'frozen_mystery_4': {
    id: 'frozen_mystery_4',
    name: 'The Frost Elemental',
    description: 'A massive Frost Elemental guards the heart of the frozen lake. End its reign.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 11,
    requiredQuests: ['frozen_mystery_3'],
    objectives: [
    { type: 'kill' as const, targetId: 'frost_elemental', targetCount: 1,
      description: 'Defeat the Frost Elemental boss', },
    ],
    rewards: {
      xp: 600,
      gold: 250,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 2, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'wickhaven_warden',
    endNpc: 'wickhaven_warden',
    repeatable: false,
  },
  'tidewend_welcome': {
    id: 'tidewend_welcome',
    name: 'The Eastbound Road',
    description: 'Warden Lark has opened the east gate. Carry the field report to Elder Wynn in Tidewend.',
    type: 'talk' as QuestType,
    questType: 'story',
    requiredLevel: 2,
    requiredQuests: ['first_hunt'],
    objectives: [
    { type: 'talk' as const, targetId: 'elder_wynn', targetCount: 1,
      description: 'Speak with Elder Wynn in Tidewend', },
    ],
    rewards: {
      xp: 75,
      gold: 30,
    },
    startNpc: 'field_warden',
    endNpc: 'elder_wynn',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"elder_wynn","location":{"mapId":"tidewend","points":[{"x":1160,"y":950}]}},"objectives":[]}') as QuestGuidance,
  },
  'strayed_pigs': {
    id: 'strayed_pigs',
    name: 'The Spooked Herd',
    description: 'Since the fog came in, blue snails have crept up out of the saltgrass and slicked the pastures past the windmill. The east-gate herd won\'t graze on it and keeps bolting for the flooded road. Clear the snails out so the herd can settle.',
    type: 'kill' as QuestType,
    questType: 'kill',
    requiredLevel: 2,
    requiredQuests: ['tidewend_welcome'],
    objectives: [
    { type: 'kill' as const, targetId: 'snail', targetCount: 6,
      description: 'Clear 6 Blue Snails from the pastures past the windmill in Tidewend Outskirts', },
    ],
    rewards: {
      xp: 120,
      gold: 50,
      items: [
        { id: 'red_potion', name: 'Red Potion', type: 'consumable', quantity: 5, maxStack: 99, description: 'A basic potion that restores 50 HP.', icon: '🧪', stats: { hp: 50 } },
      ],
    },
    startNpc: 'elder_wynn',
    endNpc: 'elder_wynn',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"elder_wynn","location":{"mapId":"tidewend","points":[{"x":1160,"y":950}]}},"objectives":[{"kind":"kill","targetId":"snail","location":{"mapId":"tidewend_outskirts","points":[{"x":7700,"y":1530},{"x":8100,"y":1530},{"x":8500,"y":1610},{"x":8900,"y":1610},{"x":11600,"y":1520},{"x":12200,"y":1520},{"x":12800,"y":1520}]}}]}') as QuestGuidance,
  },
  'lantern_oil': {
    id: 'lantern_oil',
    name: 'Lantern Oil',
    description: 'Maren keeps the village lanterns burning after dark — and lately she\'s burning a lot of oil. The slimes pooling out past the pastures and along the Drowned Road carry gel that renders into a fine fuel.',
    type: 'collect' as QuestType,
    questType: 'collection',
    requiredLevel: 3,
    requiredQuests: ['strayed_pigs'],
    objectives: [
    { type: 'collect' as const, targetId: 'slime_gel', targetCount: 12,
      description: 'Collect 12 Slime Gel from slimes in Tidewend Outskirts or on the Drowned Road', },
    ],
    rewards: {
      xp: 150,
      gold: 70,
      items: [
        { id: 'blue_potion', name: 'Blue Potion', type: 'consumable', quantity: 3, maxStack: 99, description: 'Restores 50 MP.', icon: '💙', stats: { mp: 50 } },
      ],
    },
    startNpc: 'maren',
    endNpc: 'maren',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"maren","location":{"mapId":"tidewend","points":[{"x":1510,"y":950}]}},"objectives":[{"kind":"collect","targetId":"slime_gel","location":{"mapId":"tidewend_outskirts","points":[]}}]}') as QuestGuidance,
  },
  'the_fog_inland': {
    id: 'the_fog_inland',
    name: 'The Fog Inland',
    description: 'Sophia has been watching the fog roll down from the old lighthouse. Follow the Drowned Road through Lanternwood and find Ranger Cole, who\'s holding the Brackenmoor gate.',
    type: 'talk' as QuestType,
    questType: 'main',
    requiredLevel: 3,
    requiredQuests: ['lantern_oil'],
    objectives: [
    { type: 'talk' as const, targetId: 'ranger_cole', targetCount: 1,
      description: 'Cross Lanternwood and find Ranger Cole at Brackenmoor', },
    ],
    rewards: {
      xp: 150,
      gold: 60,
    },
    startNpc: 'sophia',
    endNpc: 'ranger_cole',
    repeatable: false,
    featured: true,
    guidance: JSON.parse('{"turnIn":{"npcId":"ranger_cole","location":{"mapId":"brackenmoor","points":[{"x":820,"y":1000}]}},"objectives":[]}') as QuestGuidance,
  },
  'clear_the_brambleway': {
    id: 'clear_the_brambleway',
    name: 'Clear the Brambleway',
    description: 'Boars and swarming bees have run wild on the path inland, like something spooked them out of the deep wood. Clear a way through.',
    type: 'kill' as QuestType,
    questType: 'kill',
    requiredLevel: 4,
    requiredQuests: ['the_fog_inland'],
    objectives: [
    { type: 'kill' as const, targetId: 'wild_boar', targetCount: 6,
      description: 'Drive off 6 Wild Boars on the brambleway', },
    { type: 'kill' as const, targetId: 'giant_bee', targetCount: 8,
      description: 'Scatter 8 Giant Bees', },
    ],
    rewards: {
      xp: 250,
      gold: 120,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 5, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'ranger_cole',
    endNpc: 'ranger_cole',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"ranger_cole","location":{"mapId":"brackenmoor","points":[{"x":820,"y":1000}]}},"objectives":[{"kind":"kill","targetId":"wild_boar","location":{"mapId":"brackenmoor","points":[{"x":1400,"y":940},{"x":1900,"y":940},{"x":2400,"y":940},{"x":2900,"y":940}]}},{"kind":"kill","targetId":"giant_bee","location":{"mapId":"brackenmoor","points":[{"x":1500,"y":860},{"x":1800,"y":770},{"x":2000,"y":770},{"x":2250,"y":680},{"x":2450,"y":680}]}}]}') as QuestGuidance,
  },
  'whats_in_the_mist': {
    id: 'whats_in_the_mist',
    name: 'What\'s in the Mist',
    description: 'Things move in the fog now — bats that aren\'t bats, eyes with no face. Cole wants them thinned before anyone goes deeper.',
    type: 'kill' as QuestType,
    questType: 'kill',
    requiredLevel: 5,
    requiredQuests: ['clear_the_brambleway'],
    objectives: [
    { type: 'kill' as const, targetId: 'shadow_bat', targetCount: 10,
      description: 'Destroy 10 Shadow Bats in the mist', },
    { type: 'kill' as const, targetId: 'evil_eye', targetCount: 5,
      description: 'Banish 5 Evil Eyes', },
    ],
    rewards: {
      xp: 350,
      gold: 175,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 2, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'ranger_cole',
    endNpc: 'ranger_cole',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"ranger_cole","location":{"mapId":"brackenmoor","points":[{"x":820,"y":1000}]}},"objectives":[{"kind":"kill","targetId":"shadow_bat","location":{"mapId":"brackenmoor","points":[{"x":3450,"y":925},{"x":3780,"y":815},{"x":4200,"y":725},{"x":4640,"y":855},{"x":10600,"y":955},{"x":10930,"y":845},{"x":11350,"y":755},{"x":11780,"y":885}]}},{"kind":"kill","targetId":"evil_eye","location":{"mapId":"brackenmoor","points":[{"x":7200,"y":1060},{"x":8000,"y":1150},{"x":9000,"y":1060},{"x":9900,"y":980}]}}]}') as QuestGuidance,
  },
  'the_hollow_keeper': {
    id: 'the_hollow_keeper',
    name: 'The Hollow Keeper',
    description: 'The lighthouse keeper never left — he\'s down in the Undercroft, hollowed out and wearing his own armor like a shell, pulling the fog in. Lay him to rest.',
    type: 'kill' as QuestType,
    questType: 'kill',
    requiredLevel: 6,
    requiredQuests: ['whats_in_the_mist'],
    objectives: [
    { type: 'kill' as const, targetId: 'hollow_keeper', targetCount: 1,
      description: 'Defeat the Hollow Keeper in the Coil Undercroft', },
    ],
    rewards: {
      xp: 600,
      gold: 300,
      items: [
        { id: 'return_scroll', name: 'Return Scroll', type: 'consumable', quantity: 3, maxStack: 99, description: 'Returns you to the last town you visited.', icon: '📜', stats: {} },
        { id: 'veteran_badge', name: 'Veteran Badge', type: 'material', quantity: 1, maxStack: 1, description: 'Proof of your growth as an adventurer.', icon: '🏅', stats: {} },
      ],
    },
    startNpc: 'ranger_cole',
    endNpc: 'ranger_cole',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"ranger_cole","location":{"mapId":"brackenmoor","points":[{"x":820,"y":1000}]}},"objectives":[{"kind":"kill","targetId":"hollow_keeper","location":{"mapId":"coil_undercroft","points":[{"x":240,"y":1290}]}}]}') as QuestGuidance,
  },
  'relight_the_coil': {
    id: 'relight_the_coil',
    name: 'Relight the Coil',
    description: 'With the Keeper at rest, the Coil Light can burn again. Bring the word back to Elder Wynn — and ready yourself for the mainland.',
    type: 'talk' as QuestType,
    questType: 'story',
    requiredLevel: 6,
    requiredQuests: ['the_hollow_keeper'],
    objectives: [
    { type: 'talk' as const, targetId: 'elder_wynn', targetCount: 1,
      description: 'Bring word to Elder Wynn that the island is saved', },
    ],
    rewards: {
      xp: 500,
      gold: 250,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 3, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'ranger_cole',
    endNpc: 'elder_wynn',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"elder_wynn","location":{"mapId":"tidewend","points":[{"x":1160,"y":950}]}},"objectives":[]}') as QuestGuidance,
  },
  'beyond_the_coil': {
    id: 'beyond_the_coil',
    name: 'Beyond the Coil',
    description: 'The Hollow Coil is restored, but dark omens stir across the water. Journey to Tidewend and report to Warden Rowan.',
    type: 'talk' as QuestType,
    questType: 'main',
    requiredLevel: 6,
    requiredQuests: ['relight_the_coil'],
    objectives: [
    { type: 'talk' as const, targetId: 'warden_rowan', targetCount: 1,
      description: 'Speak with Warden Rowan in Tidewend', },
    ],
    rewards: {
      xp: 500,
      gold: 100,
      items: [
        { id: 'red_potion', name: 'Red Potion', type: 'consumable', quantity: 5, maxStack: 99, description: 'A basic potion that restores 50 HP.', icon: '🧪', stats: { hp: 50 } },
      ],
    },
    startNpc: 'elder_wynn',
    endNpc: 'warden_rowan',
    repeatable: false,
    featured: true,
    guidance: JSON.parse('{"turnIn":{"npcId":"warden_rowan","location":{"mapId":"tidewend","points":[{"x":3200,"y":950}]}},"objectives":[]}') as QuestGuidance,
  },
  'relic_collector': {
    id: 'relic_collector',
    name: 'Relic Collector',
    description: 'Ancient stones matching the Old Vault have surfaced ahead in First Field. Elder Aislin asks you to recover three for her courier.',
    type: 'collect' as QuestType,
    questType: 'collection',
    requiredLevel: 1,
    objectives: [
    { type: 'collect' as const, targetId: 'ancient_relic', targetCount: 3,
      description: 'Recover 3 ancient relics along First Field\'s lower road and highroad', },
    ],
    rewards: {
      xp: 80,
      gold: 40,
      items: [
        { id: 'blue_potion', name: 'Blue Potion', type: 'consumable', quantity: 2, maxStack: 99, description: 'Restores 50 MP.', icon: '💙', stats: { mp: 50 } },
      ],
    },
    startNpc: 'village_elder',
    endNpc: 'field_warden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"field_warden","location":{"mapId":"first_field","points":[{"x":14550,"y":1190}]}},"objectives":[{"kind":"collect","targetId":"ancient_relic","location":{"mapId":"first_field","points":[{"x":3500,"y":1336},{"x":6000,"y":756},{"x":7300,"y":596}]}}]}') as QuestGuidance,
  },
  'a_qualified_soul': {
    id: 'a_qualified_soul',
    name: 'A Qualified Soul',
    description: 'I can see you are a qualified soul. There are fewer of those every season. A friend of mine keeps watch at the top of Moonfall Hollow: climb the old road in the middle of the field to the gate at the top, and tell Maelis I sent you.',
    type: 'talk' as QuestType,
    questType: 'story',
    requiredLevel: 1,
    requiredQuests: ['first_hunt'],
    objectives: [
    { type: 'talk' as const, targetId: 'rim_keeper', targetCount: 1,
      description: 'Speak with Maelis on the rim of Moonfall Hollow', },
    ],
    rewards: {
      xp: 100,
      gold: 40,
    },
    startNpc: 'field_warden',
    endNpc: 'rim_keeper',
    repeatable: false,
    featured: true,
    guidance: JSON.parse('{"turnIn":{"npcId":"rim_keeper","location":{"mapId":"moonfall_hollow","points":[{"x":560,"y":650}]}},"objectives":[]}') as QuestGuidance,
  },
  'never_where_it_lands': {
    id: 'never_where_it_lands',
    name: 'Never Where It Lands',
    description: 'Words are cheap on a rim. Down in the hollow, by the old observatory, a stone guardian still walks its rounds. It has no soul to read, only weight. When it raises its fists the ground will break, so be in the air. When it hurls stone, be somewhere else. Bring it down, then climb back up and tell me what your feet learned.',
    type: 'kill' as QuestType,
    questType: 'kill',
    requiredLevel: 3,
    requiredQuests: ['a_qualified_soul'],
    objectives: [
    { type: 'kill' as const, targetId: 'moonfall_stone_golem', targetCount: 1,
      description: 'Defeat the Stone Golem Guardian by the observatory in Moonfall Hollow', },
    ],
    rewards: {
      xp: 250,
      gold: 100,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 3, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'rim_keeper',
    endNpc: 'rim_keeper',
    repeatable: false,
    featured: true,
    guidance: JSON.parse('{"turnIn":{"npcId":"rim_keeper","location":{"mapId":"moonfall_hollow","points":[{"x":560,"y":650}]}},"objectives":[{"kind":"kill","targetId":"moonfall_stone_golem","location":{"mapId":"moonfall_hollow","points":[{"x":7800,"y":1434}]}}]}') as QuestGuidance,
    rewardAbilities: {"druid":"harebound","hunter":"tetherline","mage":"blink","paladin":"divine_steed","priest":"lightfall","rogue":"shadow_step","shaman":"stormstride","warlock":"pact_door","warrior":"heroic_leap"},
  },
  'fresh_catch': {
    id: 'fresh_catch',
    name: 'Fresh Catch',
    description: 'Maren could use a proper catch for the village. The dock\'s been quiet since the fog came — the fish sense something, she says. Bring her what you can and she\'ll see you fed.',
    type: 'collect' as QuestType,
    questType: 'collection',
    requiredLevel: 2,
    requiredQuests: ['tidewend_welcome'],
    objectives: [
    { type: 'collect' as const, targetId: 'fresh_fish', targetCount: 5,
      description: 'Bring Maren 5 fresh fish from the Tidewend dock', },
    ],
    rewards: {
      xp: 100,
      gold: 50,
      items: [
        { id: 'red_potion', name: 'Red Potion', type: 'consumable', quantity: 3, maxStack: 99, description: 'A basic potion that restores 50 HP.', icon: '🧪', stats: { hp: 50 } },
      ],
    },
    startNpc: 'maren',
    endNpc: 'maren',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"maren","location":{"mapId":"tidewend","points":[{"x":1510,"y":950}]}},"objectives":[{"kind":"collect","targetId":"fresh_fish","location":{"mapId":"tidewend","points":[{"x":3560,"y":976},{"x":3750,"y":976},{"x":3930,"y":976},{"x":4240,"y":976},{"x":4030,"y":656}]}}]}') as QuestGuidance,
  },
  'keepers_legend': {
    id: 'keepers_legend',
    name: 'The Keeper\'s Legend',
    description: 'There\'s an old story about the lighthouse — the Coil Light, they call it. Old Ferris, the salt who keeps to the dock loft, sailed under that Light for forty years and knew the keeper in the bright years. Climb up and ask him what really happened.',
    type: 'talk' as QuestType,
    questType: 'story',
    requiredLevel: 2,
    requiredQuests: ['tidewend_welcome'],
    objectives: [
    { type: 'talk' as const, targetId: 'old_ferris', targetCount: 1,
      description: 'Climb to the dock loft and ask Old Ferris about the legend of the Coil Light', },
    ],
    rewards: {
      xp: 80,
      gold: 30,
    },
    startNpc: 'old_ferris',
    endNpc: 'old_ferris',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"old_ferris","location":{"mapId":"tidewend","points":[{"x":4100,"y":630}]}},"objectives":[]}') as QuestGuidance,
  },
  'keepers_journal': {
    id: 'keepers_journal',
    name: 'The Keeper\'s Journal',
    description: 'Ranger Cole mentioned pages of a journal, scattered through the brackenmoor — the keeper\'s own hand, carried out by the wind or something else. If you find them, bring them to him. The dead deserve their story told.',
    type: 'collect' as QuestType,
    questType: 'collection',
    requiredLevel: 4,
    requiredQuests: ['the_fog_inland'],
    objectives: [
    { type: 'collect' as const, targetId: 'keepers_journal_page', targetCount: 3,
      description: 'Find 3 scattered pages of the Keeper\'s Journal in Brackenmoor', },
    ],
    rewards: {
      xp: 300,
      gold: 150,
    },
    startNpc: 'ranger_cole',
    endNpc: 'ranger_cole',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"ranger_cole","location":{"mapId":"brackenmoor","points":[{"x":820,"y":1000}]}},"objectives":[{"kind":"collect","targetId":"keepers_journal_page","location":{"mapId":"brackenmoor","points":[{"x":1500,"y":876},{"x":3450,"y":936},{"x":10600,"y":966}]}}]}') as QuestGuidance,
  },
  'keep_the_coil_lit': {
    id: 'keep_the_coil_lit',
    name: 'Keep the Coil Lit',
    description: 'The fog never truly stops pressing. Shadow bats still drift up from the undercroft, testing the Light. Keep them thinned — the island stays yours as long as someone keeps watch.',
    type: 'kill' as QuestType,
    questType: 'daily',
    requiredLevel: 6,
    requiredQuests: ['relight_the_coil'],
    objectives: [
    { type: 'kill' as const, targetId: 'shadow_bat', targetCount: 8,
      description: 'Cull 8 Shadow Bats near the Coil Light', },
    ],
    rewards: {
      xp: 200,
      gold: 100,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 1, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'ranger_cole',
    endNpc: 'ranger_cole',
    repeatable: true,
    guidance: JSON.parse('{"turnIn":{"npcId":"ranger_cole","location":{"mapId":"brackenmoor","points":[{"x":820,"y":1000}]}},"objectives":[{"kind":"kill","targetId":"shadow_bat","location":{"mapId":"coil_undercroft","points":[{"x":1210,"y":705},{"x":1460,"y":705},{"x":1710,"y":705},{"x":1230,"y":1125},{"x":1420,"y":1125},{"x":1610,"y":1125},{"x":1800,"y":1125}]}}]}') as QuestGuidance,
  },
  'somewhere_the_road_is_quiet': {
    id: 'somewhere_the_road_is_quiet',
    name: 'Somewhere the Road Is Quiet',
    description: 'Pip\'s friend Mallow has a hiding place beneath the Drowned Road: an old boathouse gone green under the broken stone arch. Look for a little lantern with three round windows and a crooked blue ribbon hanging by its door, behind the reeds.',
    type: 'explore' as QuestType,
    questType: 'exploration',
    requiredLevel: 1,
    objectives: [
    { type: 'explore' as const, targetId: 'drowned_road_hush_nook', targetCount: 1,
      description: 'Find Mallow\'s hiding place on the Drowned Road', },
    { type: 'talk' as const, targetId: 'mallow_wick', targetCount: 1,
      description: 'Speak with Mallow in the hiding place', },
    ],
    rewards: {
      xp: 150,
      gold: 50,
    },
    startNpc: 'pip_reedwhistle',
    endNpc: 'mallow_wick',
    repeatable: false,
    rewardAbilities: {"druid":"lanternskip","hunter":"lanternskip","mage":"lanternskip","paladin":"lanternskip","priest":"lanternskip","rogue":"lanternskip","shaman":"lanternskip","warlock":"lanternskip","warrior":"lanternskip"},
    rewardAbilityHidden: true,
  },
  'glowspore_light_that_lasts': {
    id: 'glowspore_light_that_lasts',
    name: 'The Light That Lasts',
    description: 'Mycologist Orla can grow a lantern from the grotto\'s living light. Recover her western-canopy notes, defeat the Rootbound Glowcap Keeper in the far hollow, and bring back a Living Heartseed from the high crown.',
    type: 'collect' as QuestType,
    questType: 'side',
    requiredLevel: 4,
    objectives: [
    { type: 'collect' as const, targetId: 'glowspore_field_notes', targetCount: 1,
      description: 'Recover Orla\'s field notes from the western canopy', },
    { type: 'kill' as const, targetId: 'glowspore_keeper', targetCount: 1,
      description: 'Defeat the Rootbound Glowcap Keeper in the far hollow', },
    { type: 'collect' as const, targetId: 'glowspore_heartseed', targetCount: 1,
      description: 'Gather a Living Heartseed from the high crown', },
    ],
    rewards: {
      xp: 250,
      gold: 80,
      items: [
        { id: 'glowspore_lantern', name: 'Sporeglass Lantern', type: 'armor', quantity: 1, maxStack: 1, description: 'A living glow from the grotto, sealed in a field researcher\'s glass. It sways beside your shoulder and refuses to go dark.', icon: 'lantern_tidelight', stats: { mp: 5 } },
      ],
    },
    startNpc: 'glowspore_orla',
    endNpc: 'glowspore_orla',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"glowspore_orla","location":{"mapId":"glowspore_grotto","points":[{"x":250,"y":1250}]}},"objectives":[{"kind":"collect","targetId":"glowspore_field_notes","location":{"mapId":"glowspore_grotto","points":[{"x":950,"y":876}]}},{"kind":"kill","targetId":"glowspore_keeper","location":{"mapId":"glowspore_grotto","points":[{"x":2620,"y":1016}]}},{"kind":"collect","targetId":"glowspore_heartseed","location":{"mapId":"glowspore_grotto","points":[{"x":2640,"y":826}]}}]}') as QuestGuidance,
  },
  'moonfen_last_lantern': {
    id: 'moonfen_last_lantern',
    name: 'The Last Lantern of Moonfen',
    description: 'Reedwarden Tamsin asks you to follow three records through the flooded pasture: the tally at Reedwater, the ledger in the grange loft, and the last letter at the far beacon. Bring all three to Bellkeeper Orren on the watchtower below the crow nest. He keeps a Fenwatch Lantern for whoever carries the story through.',
    type: 'collect' as QuestType,
    questType: 'side',
    requiredLevel: 2,
    objectives: [
    { type: 'collect' as const, targetId: 'moonfen_reedwater_tally', targetCount: 1,
      description: 'Recover the Reedwater Tally by the raised stilt walkway', },
    { type: 'collect' as const, targetId: 'moonfen_grange_ledger', targetCount: 1,
      description: 'Recover the Herdkeeper\'s Ledger in the high grange loft', },
    { type: 'collect' as const, targetId: 'moonfen_last_watch_letter', targetCount: 1,
      description: 'Recover the Last Watch Letter at the far beacon\'s crow nest', },
    ],
    rewards: {
      xp: 180,
      gold: 60,
      items: [
        { id: 'fenwatch_lantern', name: 'Fenwatch Lantern', type: 'armor', quantity: 1, maxStack: 1, description: 'Orren\'s gift for carrying the pasture\'s story to its last watchtower. A green-gold light moves beside your shoulder, warm as a window seen across dark water.', icon: 'lantern_hearth', stats: { luck: 1 } },
        { id: 'red_potion', name: 'Red Potion', type: 'consumable', quantity: 2, maxStack: 99, description: 'A basic potion that restores 50 HP.', icon: '🧪', stats: { hp: 50 } },
      ],
    },
    startNpc: 'moonfen_reedwarden',
    endNpc: 'moonfen_beacon_keeper',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"moonfen_beacon_keeper","location":{"mapId":"moonfen_pasture","points":[{"x":9560,"y":1240}]}},"objectives":[{"kind":"collect","targetId":"moonfen_reedwater_tally","location":{"mapId":"moonfen_pasture","points":[{"x":2600,"y":1406}]}},{"kind":"collect","targetId":"moonfen_grange_ledger","location":{"mapId":"moonfen_pasture","points":[{"x":4780,"y":1346}]}},{"kind":"collect","targetId":"moonfen_last_watch_letter","location":{"mapId":"moonfen_pasture","points":[{"x":9900,"y":1146}]}}]}') as QuestGuidance,
  },
  'forest_road_dispatch': {
    id: 'forest_road_dispatch',
    name: 'The Foresters\' Road',
    description: 'Warden Halden has heard nothing from the old timber camp. Follow Wickhaven\'s road through the Dark Forest into the Deep Woods and speak to Scout Iven at the western lookout. Iven has supplies and news of the workers who stayed behind.',
    type: 'talk' as QuestType,
    questType: 'side',
    requiredLevel: 6,
    objectives: [
    { type: 'talk' as const, targetId: 'forest_scout_iven', targetCount: 1,
      description: 'Speak to Scout Iven at the western lookout in the Deep Woods', },
    ],
    rewards: {
      xp: 250,
      gold: 50,
      items: [
        { id: 'red_potion', name: 'Red Potion', type: 'consumable', quantity: 5, maxStack: 99, description: 'A basic potion that restores 50 HP.', icon: '🧪', stats: { hp: 50 } },
        { id: 'blue_potion', name: 'Blue Potion', type: 'consumable', quantity: 2, maxStack: 99, description: 'Restores 50 MP.', icon: '💙', stats: { mp: 50 } },
      ],
    },
    startNpc: 'wickhaven_warden',
    endNpc: 'forest_scout_iven',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"forest_scout_iven","location":{"mapId":"deep_woods","points":[{"x":384,"y":1614}]}},"objectives":[]}') as QuestGuidance,
  },
  'forest_camp_recovery': {
    id: 'forest_camp_recovery',
    name: 'What the Camp Left Behind',
    description: 'Clear two Forest Trolls from the workers\' road; Iven points to the separated posts at the Deep Woods root crossing. Continue into the Abandoned Camp and recover Hetta\'s tool roll from the store loft above the loaded handcart. Bring it to Sawkeeper Hetta in the salvage yard just beyond the loft.',
    type: 'collect' as QuestType,
    questType: 'side',
    requiredLevel: 6,
    requiredQuests: ['forest_road_dispatch'],
    objectives: [
    { type: 'kill' as const, targetId: 'forest_troll', targetCount: 2,
      description: 'Defeat 2 Forest Trolls; Iven marks the Deep Woods root crossing', },
    { type: 'collect' as const, targetId: 'forest_tool_roll', targetCount: 1,
      description: 'Recover Hetta\'s tool roll from the camp store loft above the loaded handcart', },
    ],
    rewards: {
      xp: 600,
      gold: 125,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 5, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
        { id: 'blue_potion', name: 'Blue Potion', type: 'consumable', quantity: 3, maxStack: 99, description: 'Restores 50 MP.', icon: '💙', stats: { mp: 50 } },
      ],
    },
    startNpc: 'forest_scout_iven',
    endNpc: 'forest_sawkeeper_hetta',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"forest_sawkeeper_hetta","location":{"mapId":"abandoned_camp","points":[{"x":7168,"y":1678}]}},"objectives":[{"kind":"kill","targetId":"forest_troll"},{"kind":"collect","targetId":"forest_tool_roll","location":{"mapId":"abandoned_camp","points":[{"x":6848,"y":1320}]}}]}') as QuestGuidance,
  },
  'forest_old_root': {
    id: 'forest_old_root',
    name: 'The Old Root\'s Debt',
    description: 'The Hollow Crown has rooted itself in the Old Grove\'s heart court. Defeat this named guardian, then follow the eastern road to Grovekeeper Senn. He keeps a forester\'s mantle for whoever gives the grove a breathing space.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 8,
    requiredQuests: ['forest_camp_recovery'],
    objectives: [
    { type: 'kill' as const, targetId: 'forest_hollow_crown', targetCount: 1,
      description: 'Defeat the Hollow Crown in the Old Grove\'s heart court', },
    ],
    rewards: {
      xp: 500,
      gold: 175,
      items: [
        { id: 'foresters_mantle', name: 'Forester\'s Mantle', type: 'armor', quantity: 1, maxStack: 1, description: 'A moss-green mantle with a warm, weathered lining. Senn gives it to the traveller who answered the old grove\'s keepers. Its brass clasp bears a leaf wrapped around a pruning blade.', icon: 'armor_cape_travelers', stats: { defense: 8, hp: 20 } },
        { id: 'return_scroll', name: 'Return Scroll', type: 'consumable', quantity: 2, maxStack: 99, description: 'Returns you to the last town you visited.', icon: '📜', stats: {} },
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 3, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'forest_sawkeeper_hetta',
    endNpc: 'forest_grovekeeper_senn',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"forest_grovekeeper_senn","location":{"mapId":"old_grove","points":[{"x":7360,"y":1614}]}},"objectives":[{"kind":"kill","targetId":"forest_hollow_crown","location":{"mapId":"old_grove","points":[{"x":6208,"y":1648}]}}]}') as QuestGuidance,
  },
  'savanna_longleg_hunt': {
    id: 'savanna_longleg_hunt',
    name: 'Long Legs on the Road',
    description: 'Longleg Striders graze right beside the Wickhaven road and kick at anything that walks past. Outrider Kestrel wants the road clear enough for wagons.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 3,
    objectives: [
    { type: 'kill' as const, targetId: 'longleg_strider', targetCount: 6,
      description: 'Drive off Longleg Striders near the road', },
    ],
    rewards: {
      xp: 150,
      gold: 40,
      items: [
        { id: 'red_potion', name: 'Red Potion', type: 'consumable', quantity: 3, maxStack: 99, description: 'A basic potion that restores 50 HP.', icon: '🧪', stats: { hp: 50 } },
      ],
    },
    startNpc: 'savanna_outrider',
    endNpc: 'savanna_outrider',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"savanna_outrider","location":{"mapId":"goldengrass_savanna","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"longleg_strider","location":{"mapId":"goldengrass_savanna","points":[{"x":900,"y":1250}]}}]}') as QuestGuidance,
  },
  'savanna_strider_feathers': {
    id: 'savanna_strider_feathers',
    name: 'Feathers for the Fletchers',
    description: 'Wickhaven\'s fletchers pay well for strider feathers, and Kestrel has promised them a bundle. The striders by the road drop them.',
    type: 'collect' as QuestType,
    questType: 'side',
    requiredLevel: 3,
    objectives: [
    { type: 'collect' as const, targetId: 'light_feather', targetCount: 6,
      description: 'Collect Light Feathers from Longleg Striders', },
    ],
    rewards: {
      xp: 180,
      gold: 60,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 2, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'savanna_outrider',
    endNpc: 'savanna_outrider',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"savanna_outrider","location":{"mapId":"goldengrass_savanna","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"collect","targetId":"light_feather","location":{"mapId":"goldengrass_savanna","points":[]}}]}') as QuestGuidance,
  },
  'savanna_tuskmire_camp': {
    id: 'savanna_tuskmire_camp',
    name: 'The Tuskmire Camp',
    description: 'The Tuskmire tribe has camped across the middle of the plain, right where the road should run. Kestrel needs the raiders thinned before a wagon can pass, including the lookout on the termite mound.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 8,
    objectives: [
    { type: 'kill' as const, targetId: 'tuskmire_raider', targetCount: 6,
      description: 'Defeat Tuskmire Raiders at their camp', },
    ],
    rewards: {
      xp: 420,
      gold: 180,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 4, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'savanna_outrider',
    endNpc: 'savanna_outrider',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"savanna_outrider","location":{"mapId":"goldengrass_savanna","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"tuskmire_raider","location":{"mapId":"goldengrass_savanna","points":[{"x":1500,"y":1250},{"x":2100,"y":1115}]}}]}') as QuestGuidance,
  },
  'savanna_stripe_runners': {
    id: 'savanna_stripe_runners',
    name: 'Stripes in the Tall Grass',
    description: 'Past the Tuskmire camp, Stripe-runner herds charge anything that crosses the eastern grass. Kestrel wants the last stretch of the road safe.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 9,
    requiredQuests: ['savanna_tuskmire_camp'],
    objectives: [
    { type: 'kill' as const, targetId: 'stripe_runner', targetCount: 5,
      description: 'Defeat Stripe-runners in the eastern grass', },
    ],
    rewards: {
      xp: 480,
      gold: 220,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 5, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'savanna_outrider',
    endNpc: 'savanna_outrider',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"savanna_outrider","location":{"mapId":"goldengrass_savanna","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"stripe_runner","location":{"mapId":"goldengrass_savanna","points":[{"x":2700,"y":1250}]}}]}') as QuestGuidance,
  },
  'savanna_tuskmire_warchief': {
    id: 'savanna_tuskmire_warchief',
    name: 'The Warchief',
    description: 'Scattering the raiders only made their chief angry. Warchief Gorrak holds the middle of the plain under a totem of horned skulls, and the Tuskmire will keep coming as long as he stands. Outrider Kestrel wants the road through the camp open for good.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 10,
    requiredQuests: ['savanna_tuskmire_camp'],
    objectives: [
    { type: 'kill' as const, targetId: 'tuskmire_warchief', targetCount: 1,
      description: 'Defeat Warchief Gorrak in the middle of the Tuskmire camp', },
    ],
    rewards: {
      xp: 700,
      gold: 300,
      items: [
        { id: 'power_elixir', name: 'Power Elixir', type: 'consumable', quantity: 1, maxStack: 99, description: 'Fully restores HP and MP.', icon: '⚡', stats: { hp: 9999, mp: 9999 } },
      ],
    },
    startNpc: 'savanna_outrider',
    endNpc: 'savanna_outrider',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"savanna_outrider","location":{"mapId":"goldengrass_savanna","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"tuskmire_warchief","location":{"mapId":"goldengrass_savanna","points":[{"x":1700,"y":1084}]}}]}') as QuestGuidance,
  },
  'swamp_gilling_camp': {
    id: 'swamp_gilling_camp',
    name: 'The Gilling Camp',
    description: 'Gillings have built a camp of reed huts on the cypress roots just past the savanna road, and they pull travellers off the boardwalk at dusk. Bogwarden Tilly can\'t leave her post. Break up the camp.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 11,
    objectives: [
    { type: 'kill' as const, targetId: 'gilling_coastrunner', targetCount: 8,
      description: 'Defeat Gilling Coastrunners at their camp', },
    ],
    rewards: {
      xp: 700,
      gold: 160,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 4, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'swamp_bogwarden',
    endNpc: 'swamp_bogwarden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"swamp_bogwarden","location":{"mapId":"murkwater_swamp","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"gilling_coastrunner","location":{"mapId":"murkwater_swamp","points":[{"x":1400,"y":1235},{"x":1250,"y":995},{"x":1850,"y":1235}]}}]}') as QuestGuidance,
  },
  'swamp_gilling_raids': {
    id: 'swamp_gilling_raids',
    name: 'Nets and Shiny Things',
    description: 'The Gillings come back every day. They raid the fishing nets, gurgle their war-cry across the water all night and carry off anything that shines. Tilly pays to keep their numbers down.',
    type: 'kill' as QuestType,
    questType: 'daily',
    requiredLevel: 11,
    requiredQuests: ['swamp_gilling_camp'],
    objectives: [
    { type: 'kill' as const, targetId: 'gilling_coastrunner', targetCount: 15,
      description: 'Defeat 15 Gilling Coastrunners', },
    ],
    rewards: {
      xp: 1050,
      gold: 48,
    },
    startNpc: 'swamp_bogwarden',
    endNpc: 'swamp_bogwarden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"swamp_bogwarden","location":{"mapId":"murkwater_swamp","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"gilling_coastrunner","location":{"mapId":"murkwater_swamp","points":[{"x":1400,"y":1235},{"x":1250,"y":995},{"x":1850,"y":1235}]}}]}') as QuestGuidance,
  },
  'swamp_snapjaw_road': {
    id: 'swamp_snapjaw_road',
    name: 'Snapjaws on the Boardwalk',
    description: 'Past the Gilling camp, Murkwater Snapjaws lie across the old boardwalk looking like logs. Wagons can\'t pass, and Tilly lost a good pair of boots to one. Clear the boardwalk, and watch the puddles.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 14,
    requiredQuests: ['swamp_gilling_camp'],
    objectives: [
    { type: 'kill' as const, targetId: 'murkwater_snapjaw', targetCount: 8,
      description: 'Clear Murkwater Snapjaws from the boardwalk', },
    ],
    rewards: {
      xp: 1100,
      gold: 345,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 5, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'swamp_bogwarden',
    endNpc: 'swamp_bogwarden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"swamp_bogwarden","location":{"mapId":"murkwater_swamp","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"murkwater_snapjaw","location":{"mapId":"murkwater_swamp","points":[{"x":2500,"y":1260},{"x":2100,"y":910}]}}]}') as QuestGuidance,
  },
  'swamp_toadstool_creepers': {
    id: 'swamp_toadstool_creepers',
    name: 'Creepers on the Toadstools',
    description: 'The giant toadstools past the boardwalk used to be a fine place to dry nets. Now Moss Lurkers sit on the near one pretending to be moss, and spiders have strung the far one with webs. Tilly wants both cleared before the road goes on to the sea.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 14,
    requiredQuests: ['swamp_gilling_camp'],
    objectives: [
    { type: 'kill' as const, targetId: 'moss_lurker', targetCount: 6,
      description: 'Defeat 6 Moss Lurkers on the near toadstool', },
    { type: 'kill' as const, targetId: 'forest_spider', targetCount: 6,
      description: 'Defeat 6 Forest Spiders on the far toadstool', },
    ],
    rewards: {
      xp: 1200,
      gold: 360,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 5, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'swamp_bogwarden',
    endNpc: 'swamp_bogwarden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"swamp_bogwarden","location":{"mapId":"murkwater_swamp","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"moss_lurker","location":{"mapId":"murkwater_swamp","points":[{"x":2450,"y":1022}]}},{"kind":"kill","targetId":"forest_spider","location":{"mapId":"murkwater_swamp","points":[{"x":2770,"y":1133}]}}]}') as QuestGuidance,
  },
  'swamp_bogchief': {
    id: 'swamp_bogchief',
    name: 'The Bogchief',
    description: 'Every raid on Tilly\'s nets is sent from the back of the Gilling camp, where Bogchief Sloughmaw sits under a crown of shells with a trident taller than he is. Scattering his raiders won\'t stop the raids. He has to go.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 16,
    requiredQuests: ['swamp_gilling_raids'],
    objectives: [
    { type: 'kill' as const, targetId: 'gilling_bogchief', targetCount: 1,
      description: 'Defeat Bogchief Sloughmaw at the back of the Gilling camp', },
    ],
    rewards: {
      xp: 1500,
      gold: 420,
      items: [
        { id: 'power_elixir', name: 'Power Elixir', type: 'consumable', quantity: 1, maxStack: 99, description: 'Fully restores HP and MP.', icon: '⚡', stats: { hp: 9999, mp: 9999 } },
      ],
    },
    startNpc: 'swamp_bogwarden',
    endNpc: 'swamp_bogwarden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"swamp_bogwarden","location":{"mapId":"murkwater_swamp","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"gilling_bogchief","location":{"mapId":"murkwater_swamp","points":[{"x":2100,"y":1210}]}}]}') as QuestGuidance,
  },
  'shore_sandstinger_nests': {
    id: 'shore_sandstinger_nests',
    name: 'Stingers in the Sand',
    description: 'Sandstingers dig their nests in the warm sand above the tide line, and they come up stinging when anyone walks the beach. Tidewatcher Marlo can\'t keep the shore road open while they breed. Thin the nests.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 16,
    objectives: [
    { type: 'kill' as const, targetId: 'sandstinger', targetCount: 8,
      description: 'Defeat Sandstingers on the beach', },
    ],
    rewards: {
      xp: 1300,
      gold: 400,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 5, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'shore_tidewatcher',
    endNpc: 'shore_tidewatcher',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"shore_tidewatcher","location":{"mapId":"sunkissed_shore","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"sandstinger","location":{"mapId":"sunkissed_shore","points":[{"x":1400,"y":1256},{"x":1700,"y":1136},{"x":1950,"y":1256}]}}]}') as QuestGuidance,
  },
  'shore_sandstinger_sweep': {
    id: 'shore_sandstinger_sweep',
    name: 'Sweep the Beach',
    description: 'A Sandstinger nest is never really empty. Every morning there are new tracks above the tide line, and Marlo pays to keep them down before the fishing boats come in.',
    type: 'kill' as QuestType,
    questType: 'daily',
    requiredLevel: 16,
    requiredQuests: ['shore_sandstinger_nests'],
    objectives: [
    { type: 'kill' as const, targetId: 'sandstinger', targetCount: 15,
      description: 'Defeat 15 Sandstingers', },
    ],
    rewards: {
      xp: 1400,
      gold: 56,
    },
    startNpc: 'shore_tidewatcher',
    endNpc: 'shore_tidewatcher',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"shore_tidewatcher","location":{"mapId":"sunkissed_shore","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"sandstinger","location":{"mapId":"sunkissed_shore","points":[{"x":1400,"y":1256},{"x":1700,"y":1136},{"x":1950,"y":1256}]}}]}') as QuestGuidance,
  },
  'shore_basilisk_rocks': {
    id: 'shore_basilisk_rocks',
    name: 'Stone-Eyes on the Rocks',
    description: 'Basilisks bask on the warm rocks past the tide pools. Anything that meets their gaze for too long goes stiff and grey, and Marlo has a beach full of stone gulls to prove it. Drive them off the rocks.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 18,
    requiredQuests: ['shore_sandstinger_nests'],
    objectives: [
    { type: 'kill' as const, targetId: 'basilisk', targetCount: 6,
      description: 'Defeat Basilisks on the eastern rocks', },
    ],
    rewards: {
      xp: 1700,
      gold: 450,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 5, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'shore_tidewatcher',
    endNpc: 'shore_tidewatcher',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"shore_tidewatcher","location":{"mapId":"sunkissed_shore","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"basilisk","location":{"mapId":"sunkissed_shore","points":[{"x":2300,"y":1256},{"x":2400,"y":1136},{"x":2450,"y":876},{"x":2750,"y":876}]}}]}') as QuestGuidance,
  },
  'shore_basilisk_brood': {
    id: 'shore_basilisk_brood',
    name: 'Don\'t Meet Their Eyes',
    description: 'The biggest Basilisks have climbed to the driftwood above the tide pools, where they can stare down the whole beach. Marlo wants them gone before the shore road opens to wagons. Look at their feet, not their eyes.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 20,
    requiredQuests: ['shore_basilisk_rocks'],
    objectives: [
    { type: 'kill' as const, targetId: 'basilisk', targetCount: 10,
      description: 'Defeat 10 Basilisks, high and low', },
    ],
    rewards: {
      xp: 2100,
      gold: 520,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 6, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'shore_tidewatcher',
    endNpc: 'shore_tidewatcher',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"shore_tidewatcher","location":{"mapId":"sunkissed_shore","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"basilisk","location":{"mapId":"sunkissed_shore","points":[{"x":2300,"y":1256},{"x":2400,"y":1136},{"x":2450,"y":876},{"x":2750,"y":876}]}}]}') as QuestGuidance,
  },
  'shore_siren_song': {
    id: 'shore_siren_song',
    name: 'Song from the Driftwood',
    description: 'Sailors coming in to the shore hear singing from the high driftwood and steer straight for the rocks. Marlo has lost two boats to it. The singers are Naga Sirens, and Marlo would like the song to stop.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 20,
    requiredQuests: ['shore_basilisk_rocks'],
    objectives: [
    { type: 'kill' as const, targetId: 'naga_siren', targetCount: 6,
      description: 'Silence 6 Naga Sirens on the high driftwood', },
    ],
    rewards: {
      xp: 2000,
      gold: 500,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 6, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'shore_tidewatcher',
    endNpc: 'shore_tidewatcher',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"shore_tidewatcher","location":{"mapId":"sunkissed_shore","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"naga_siren","location":{"mapId":"sunkissed_shore","points":[{"x":2420,"y":725}]}}]}') as QuestGuidance,
  },
  'shore_leviathan': {
    id: 'shore_leviathan',
    name: 'What the Tide Brings',
    description: 'With the Basilisks gone from the driftwood, something bigger has come up into the eastern surf: the Leviathan of the Deep, rearing out of the water by the road to the Smoldering Wastes. Nothing passes it. Marlo says the road isn\'t open until it is gone.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 21,
    requiredQuests: ['shore_basilisk_brood'],
    objectives: [
    { type: 'kill' as const, targetId: 'leviathan', targetCount: 1,
      description: 'Defeat the Leviathan of the Deep in the eastern surf', },
    ],
    rewards: {
      xp: 2600,
      gold: 700,
      items: [
        { id: 'power_elixir', name: 'Power Elixir', type: 'consumable', quantity: 1, maxStack: 99, description: 'Fully restores HP and MP.', icon: '⚡', stats: { hp: 9999, mp: 9999 } },
      ],
    },
    startNpc: 'shore_tidewatcher',
    endNpc: 'shore_tidewatcher',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"shore_tidewatcher","location":{"mapId":"sunkissed_shore","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"leviathan","location":{"mapId":"sunkissed_shore","points":[{"x":2760,"y":1158}]}}]}') as QuestGuidance,
  },
  'moor_cutpurse_road': {
    id: 'moor_cutpurse_road',
    name: 'Cutpurses on the Heath',
    description: 'Travellers on the north road keep arriving at Wickhaven with empty purses and a story about a hooded stranger who asked the time. Moorwarden Brannock knows the stranger: the Windmoor Brigands\' cutpurses work the heath by the road. Run them off it.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 6,
    objectives: [
    { type: 'kill' as const, targetId: 'brigand_cutpurse', targetCount: 8,
      description: 'Defeat Brigand Cutpurses on the heath', },
    ],
    rewards: {
      xp: 300,
      gold: 90,
      items: [
        { id: 'red_potion', name: 'Red Potion', type: 'consumable', quantity: 3, maxStack: 99, description: 'A basic potion that restores 50 HP.', icon: '🧪', stats: { hp: 50 } },
      ],
    },
    startNpc: 'moor_warden',
    endNpc: 'moor_warden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"moor_warden","location":{"mapId":"windswept_moor","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"brigand_cutpurse","location":{"mapId":"windswept_moor","points":[{"x":1250,"y":1235},{"x":1050,"y":985}]}}]}') as QuestGuidance,
  },
  'moor_footpad_patrol': {
    id: 'moor_footpad_patrol',
    name: 'Keep the Road Open',
    description: 'The Brigands send new footpads up onto the stone outcrops every day to watch the road. Brannock pays anyone who keeps their numbers down so the carts can cross.',
    type: 'kill' as QuestType,
    questType: 'daily',
    requiredLevel: 7,
    requiredQuests: ['moor_cutpurse_road'],
    objectives: [
    { type: 'kill' as const, targetId: 'brigand_footpad', targetCount: 12,
      description: 'Defeat 12 Brigand Footpads', },
    ],
    rewards: {
      xp: 420,
      gold: 24,
    },
    startNpc: 'moor_warden',
    endNpc: 'moor_warden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"moor_warden","location":{"mapId":"windswept_moor","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"brigand_footpad","location":{"mapId":"windswept_moor","points":[{"x":1500,"y":985}]}}]}') as QuestGuidance,
  },
  'moor_thug_camp': {
    id: 'moor_thug_camp',
    name: 'The Thugs\' Fire',
    description: 'Past the outcrops the Brigands keep a camp of hard men around a peat fire, and nobody passes it without paying. Brannock would rather nobody paid. Put the fire out.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 8,
    requiredQuests: ['moor_cutpurse_road'],
    objectives: [
    { type: 'kill' as const, targetId: 'brigand_thug', targetCount: 8,
      description: 'Defeat Brigand Thugs at their camp', },
    ],
    rewards: {
      xp: 520,
      gold: 140,
      items: [
        { id: 'red_potion', name: 'Red Potion', type: 'consumable', quantity: 4, maxStack: 99, description: 'A basic potion that restores 50 HP.', icon: '🧪', stats: { hp: 50 } },
      ],
    },
    startNpc: 'moor_warden',
    endNpc: 'moor_warden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"moor_warden","location":{"mapId":"windswept_moor","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"brigand_thug","location":{"mapId":"windswept_moor","points":[{"x":1700,"y":1235}]}}]}') as QuestGuidance,
  },
  'moor_grix_the_cunning': {
    id: 'moor_grix_the_cunning',
    name: 'Grix the Cunning',
    description: 'The list in the ashes names every wagon that will cross the moor this month, and the hand that wrote it belongs to Grix the Cunning, who plans the gang\'s robberies from the top of the high outcrop. Grix is quick and rarely there. Be there when Grix is.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 9,
    requiredQuests: ['moor_thug_camp'],
    objectives: [
    { type: 'kill' as const, targetId: 'bandit_leader_grix', targetCount: 1,
      description: 'Defeat Grix the Cunning on the high outcrop', },
    ],
    rewards: {
      xp: 800,
      gold: 220,
      items: [
        { id: 'power_elixir', name: 'Power Elixir', type: 'consumable', quantity: 1, maxStack: 99, description: 'Fully restores HP and MP.', icon: '⚡', stats: { hp: 9999, mp: 9999 } },
      ],
    },
    startNpc: 'moor_warden',
    endNpc: 'moor_warden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"moor_warden","location":{"mapId":"windswept_moor","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"bandit_leader_grix","location":{"mapId":"windswept_moor","points":[{"x":1250,"y":855}]}}]}') as QuestGuidance,
  },
  'moor_raiders': {
    id: 'moor_raiders',
    name: 'Raiders in Kettle Helms',
    description: 'The Brigands\' raiders, in their dented kettle helms, hit the wagons Grix picked out. With Grix gone they are guessing, but they are still dangerous. Brannock wants them broken before they guess right.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 10,
    requiredQuests: ['moor_thug_camp'],
    objectives: [
    { type: 'kill' as const, targetId: 'brigand_raider', targetCount: 8,
      description: 'Defeat Brigand Raiders on the moor', },
    ],
    rewards: {
      xp: 620,
      gold: 170,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 3, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'moor_warden',
    endNpc: 'moor_warden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"moor_warden","location":{"mapId":"windswept_moor","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"brigand_raider","location":{"mapId":"windswept_moor","points":[{"x":2300,"y":1115},{"x":2200,"y":1235}]}}]}') as QuestGuidance,
  },
  'moor_smugglers': {
    id: 'moor_smugglers',
    name: 'Lanterns in the Peat',
    description: 'At night, shuttered lanterns move along the peat cuttings: the Brigands\' smugglers, carrying stolen goods to buyers off the moor. Brannock wants the goods back and the lanterns out.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 11,
    requiredQuests: ['moor_raiders'],
    objectives: [
    { type: 'kill' as const, targetId: 'brigand_smuggler', targetCount: 8,
      description: 'Defeat Brigand Smugglers at the peat cuttings', },
    ],
    rewards: {
      xp: 700,
      gold: 190,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 4, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'moor_warden',
    endNpc: 'moor_warden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"moor_warden","location":{"mapId":"windswept_moor","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"brigand_smuggler","location":{"mapId":"windswept_moor","points":[{"x":1950,"y":1115},{"x":1900,"y":985}]}}]}') as QuestGuidance,
  },
  'moor_lieutenants': {
    id: 'moor_lieutenants',
    name: 'The Captain\'s Lieutenants',
    description: 'Captain Morrow Vane keeps lieutenants in iron at the east end of the moor, and they keep the rest of the gang in line. Without them the Captain stands alone.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 12,
    requiredQuests: ['moor_smugglers'],
    objectives: [
    { type: 'kill' as const, targetId: 'brigand_lieutenant', targetCount: 3,
      description: 'Defeat Brigand Lieutenants on the east ridge', },
    ],
    rewards: {
      xp: 900,
      gold: 240,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 4, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'moor_warden',
    endNpc: 'moor_warden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"moor_warden","location":{"mapId":"windswept_moor","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"brigand_lieutenant","location":{"mapId":"windswept_moor","points":[{"x":2550,"y":965},{"x":2650,"y":1215}]}}]}') as QuestGuidance,
  },
  'moor_captain_vane': {
    id: 'moor_captain_vane',
    name: 'Captain Morrow Vane',
    description: 'Captain Morrow Vane runs the Windmoor Brigands from the far end of the moor in a gold-trimmed coat, and has never once been caught. Brannock has spent years on this road waiting for someone who could change that. End the Brigands\' hold on the moor.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 13,
    requiredQuests: ['moor_lieutenants'],
    objectives: [
    { type: 'kill' as const, targetId: 'captain_morrow_vane', targetCount: 1,
      description: 'Defeat Captain Morrow Vane at the east end of the moor', },
    ],
    rewards: {
      xp: 1500,
      gold: 400,
      items: [
        { id: 'power_elixir', name: 'Power Elixir', type: 'consumable', quantity: 2, maxStack: 99, description: 'Fully restores HP and MP.', icon: '⚡', stats: { hp: 9999, mp: 9999 } },
      ],
    },
    startNpc: 'moor_warden',
    endNpc: 'moor_warden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"moor_warden","location":{"mapId":"windswept_moor","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"captain_morrow_vane","location":{"mapId":"windswept_moor","points":[{"x":2950,"y":1215}]}}]}') as QuestGuidance,
  },
  'cliffs_drake_scree': {
    id: 'cliffs_drake_scree',
    name: 'Drakes on the Scree',
    description: 'Stone Drakes bask on the warm scree at the foot of the cliffs and snap at anything that climbs past. Beaconkeeper Rook needs the path to the beacon clear before the storm season. Drive them off the scree.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 13,
    objectives: [
    { type: 'kill' as const, targetId: 'stone_drake', targetCount: 10,
      description: 'Defeat Stone Drakes on the scree', },
    ],
    rewards: {
      xp: 950,
      gold: 260,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 4, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'cliffs_beaconkeeper',
    endNpc: 'cliffs_beaconkeeper',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"cliffs_beaconkeeper","location":{"mapId":"stormbreak_cliffs","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"stone_drake","location":{"mapId":"stormbreak_cliffs","points":[{"x":1300,"y":1245},{"x":1850,"y":1245},{"x":2400,"y":1245}]}}]}') as QuestGuidance,
  },
  'cliffs_windcallers': {
    id: 'cliffs_windcallers',
    name: 'Windcallers on the Crag',
    description: 'Harpy Windcallers sing up gusts from the high crag, and every gust blows the beacon out. Rook has relit it four times this week. Silence the singers.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 14,
    requiredQuests: ['cliffs_drake_scree'],
    objectives: [
    { type: 'kill' as const, targetId: 'harpy_windcaller', targetCount: 8,
      description: 'Defeat Harpy Windcallers on the high crag', },
    ],
    rewards: {
      xp: 1050,
      gold: 300,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 4, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'cliffs_beaconkeeper',
    endNpc: 'cliffs_beaconkeeper',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"cliffs_beaconkeeper","location":{"mapId":"stormbreak_cliffs","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"harpy_windcaller","location":{"mapId":"stormbreak_cliffs","points":[{"x":1300,"y":988},{"x":1750,"y":988}]}}]}') as QuestGuidance,
  },
  'cliffs_wyvern_roosts': {
    id: 'cliffs_wyvern_roosts',
    name: 'Wyverns in the Roosts',
    description: 'Stormbreak Wyverns nest on the ledges above the waves and dive on anything that moves on the cliff road. Rook wants the roosts cleared so the road can run past the beacon to the peaks.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 16,
    requiredQuests: ['cliffs_windcallers'],
    objectives: [
    { type: 'kill' as const, targetId: 'stormbreak_wyvern', targetCount: 8,
      description: 'Defeat Stormbreak Wyverns on the ledges', },
    ],
    rewards: {
      xp: 1300,
      gold: 380,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 5, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'cliffs_beaconkeeper',
    endNpc: 'cliffs_beaconkeeper',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"cliffs_beaconkeeper","location":{"mapId":"stormbreak_cliffs","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"stormbreak_wyvern","location":{"mapId":"stormbreak_cliffs","points":[{"x":2100,"y":835},{"x":2350,"y":705},{"x":2600,"y":835},{"x":2650,"y":975}]}}]}') as QuestGuidance,
  },
  'cliffs_wyvern_cull': {
    id: 'cliffs_wyvern_cull',
    name: 'Keep the Ledges Clear',
    description: 'Wyverns come back to an empty roost within a day. Rook pays to keep them off the ledges above the road.',
    type: 'kill' as QuestType,
    questType: 'daily',
    requiredLevel: 16,
    requiredQuests: ['cliffs_wyvern_roosts'],
    objectives: [
    { type: 'kill' as const, targetId: 'stormbreak_wyvern', targetCount: 12,
      description: 'Defeat 12 Stormbreak Wyverns', },
    ],
    rewards: {
      xp: 1400,
      gold: 56,
    },
    startNpc: 'cliffs_beaconkeeper',
    endNpc: 'cliffs_beaconkeeper',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"cliffs_beaconkeeper","location":{"mapId":"stormbreak_cliffs","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"stormbreak_wyvern","location":{"mapId":"stormbreak_cliffs","points":[{"x":2100,"y":835},{"x":2350,"y":705},{"x":2600,"y":835},{"x":2650,"y":975}]}}]}') as QuestGuidance,
  },
  'cliffs_harpy_matriarch': {
    id: 'cliffs_harpy_matriarch',
    name: 'The Matriarch Falls',
    description: 'The Harpy Matriarch nests on top of the sea stack, where she can see the whole coast and call her flock down on it. While she lives the windcallers come back. Climb the stack and end it.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 17,
    requiredQuests: ['cliffs_windcallers'],
    objectives: [
    { type: 'kill' as const, targetId: 'harpy_matriarch', targetCount: 1,
      description: 'Defeat the Harpy Matriarch on the sea stack', },
    ],
    rewards: {
      xp: 1600,
      gold: 450,
      items: [
        { id: 'hunters_longbow', name: 'Longbow', type: 'weapon', quantity: 1, maxStack: 1, description: 'A tall bow with excellent range.', icon: 'sprites/items/hunters_longbow.png', stats: { attack: 22, dexterity: 5 } },
      ],
    },
    startNpc: 'cliffs_beaconkeeper',
    endNpc: 'cliffs_beaconkeeper',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"cliffs_beaconkeeper","location":{"mapId":"stormbreak_cliffs","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"harpy_matriarch","location":{"mapId":"stormbreak_cliffs","points":[{"x":2400,"y":409}]}}]}') as QuestGuidance,
  },
  'peaks_rimecrest_camp': {
    id: 'peaks_rimecrest_camp',
    name: 'The Rimecrest Camp',
    description: 'The Rimecrest trolls have pitched their hide tents across the lower snowfield, right on the road to the summit. Summitwarden Isk counts more tusks every morning. Break the camp before it becomes a village.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 19,
    objectives: [
    { type: 'kill' as const, targetId: 'rimecrest_troll', targetCount: 10,
      description: 'Defeat Rimecrest Trolls on the lower snowfield', },
    ],
    rewards: {
      xp: 1600,
      gold: 460,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 5, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'peaks_summitwarden',
    endNpc: 'peaks_summitwarden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"peaks_summitwarden","location":{"mapId":"frostspire_peaks","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"rimecrest_troll","location":{"mapId":"frostspire_peaks","points":[{"x":1300,"y":1210},{"x":1850,"y":1210},{"x":2400,"y":1210}]}}]}') as QuestGuidance,
  },
  'peaks_wendigos': {
    id: 'peaks_wendigos',
    name: 'Something in the Snow',
    description: 'Climbers on the rock ledges hear something breathing behind them, and when they turn there is only snow. Isk knows what it is: wendigos, hunting along the cliff path. Hunt them first.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 20,
    requiredQuests: ['peaks_rimecrest_camp'],
    objectives: [
    { type: 'kill' as const, targetId: 'wendigo', targetCount: 6,
      description: 'Defeat Wendigos on the rock ledges', },
    ],
    rewards: {
      xp: 1700,
      gold: 480,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 5, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'peaks_summitwarden',
    endNpc: 'peaks_summitwarden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"peaks_summitwarden","location":{"mapId":"frostspire_peaks","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"wendigo","location":{"mapId":"frostspire_peaks","points":[{"x":900,"y":874},{"x":2550,"y":994},{"x":2800,"y":1114}]}}]}') as QuestGuidance,
  },
  'peaks_ice_wraiths': {
    id: 'peaks_ice_wraiths',
    name: 'Frozen Souls',
    description: 'Ice wraiths drift out of the high shelves, the cold shapes of climbers the mountain kept. They do not rest, and they do not let the living pass. Isk asks you to put them down gently, and permanently.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 21,
    requiredQuests: ['peaks_rimecrest_camp'],
    objectives: [
    { type: 'kill' as const, targetId: 'ice_wraith', targetCount: 8,
      description: 'Defeat Ice Wraiths on the ice shelves', },
    ],
    rewards: {
      xp: 1800,
      gold: 500,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 5, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'peaks_summitwarden',
    endNpc: 'peaks_summitwarden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"peaks_summitwarden","location":{"mapId":"frostspire_peaks","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"ice_wraith","location":{"mapId":"frostspire_peaks","points":[{"x":1100,"y":758},{"x":1300,"y":638},{"x":2280,"y":878}]}}]}') as QuestGuidance,
  },
  'peaks_wraith_vigil': {
    id: 'peaks_wraith_vigil',
    name: 'The Long Vigil',
    description: 'The mountain keeps making new wraiths out of the cold. Isk keeps a vigil against them and pays anyone who stands it for a day.',
    type: 'kill' as QuestType,
    questType: 'daily',
    requiredLevel: 21,
    requiredQuests: ['peaks_ice_wraiths'],
    objectives: [
    { type: 'kill' as const, targetId: 'ice_wraith', targetCount: 12,
      description: 'Defeat 12 Ice Wraiths', },
    ],
    rewards: {
      xp: 1800,
      gold: 72,
    },
    startNpc: 'peaks_summitwarden',
    endNpc: 'peaks_summitwarden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"peaks_summitwarden","location":{"mapId":"frostspire_peaks","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"ice_wraith","location":{"mapId":"frostspire_peaks","points":[{"x":1100,"y":758},{"x":1300,"y":638},{"x":2280,"y":878}]}}]}') as QuestGuidance,
  },
  'peaks_rimecrest_hexers': {
    id: 'peaks_rimecrest_hexers',
    name: 'Hexers on the Caps',
    description: 'The Rimecrest Hexers chant on the snow caps above the summit, and the mountain listens: every chant brings snow down on the road. Their mountain-troll guards are twice the size of any troll on the snowfield. Silence the chanting.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 22,
    requiredQuests: ['peaks_wendigos'],
    objectives: [
    { type: 'kill' as const, targetId: 'voodoo_troll', targetCount: 6,
      description: 'Defeat Rimecrest Hexers on the snow caps', },
    ],
    rewards: {
      xp: 2000,
      gold: 540,
      items: [
        { id: 'power_elixir', name: 'Power Elixir', type: 'consumable', quantity: 1, maxStack: 99, description: 'Fully restores HP and MP.', icon: '⚡', stats: { hp: 9999, mp: 9999 } },
      ],
    },
    startNpc: 'peaks_summitwarden',
    endNpc: 'peaks_summitwarden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"peaks_summitwarden","location":{"mapId":"frostspire_peaks","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"voodoo_troll","location":{"mapId":"frostspire_peaks","points":[{"x":1850,"y":618},{"x":2050,"y":738}]}}]}') as QuestGuidance,
  },
  'peaks_avalanche_golem': {
    id: 'peaks_avalanche_golem',
    name: 'Avalanche',
    description: 'The hexers\' last chant woke the Avalanche Golem, a mass of packed snow and stone that now sits on the summit and blocks the pass beyond it. With it gone the Highlands road runs from Wickhaven to the top of the world. Clear the summit.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 23,
    requiredQuests: ['peaks_rimecrest_hexers'],
    objectives: [
    { type: 'kill' as const, targetId: 'avalanche_golem', targetCount: 1,
      description: 'Defeat the Avalanche Golem on the summit', },
    ],
    rewards: {
      xp: 2600,
      gold: 700,
      items: [
        { id: 'power_elixir', name: 'Power Elixir', type: 'consumable', quantity: 2, maxStack: 99, description: 'Fully restores HP and MP.', icon: '⚡', stats: { hp: 9999, mp: 9999 } },
      ],
    },
    startNpc: 'peaks_summitwarden',
    endNpc: 'peaks_summitwarden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"peaks_summitwarden","location":{"mapId":"frostspire_peaks","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"avalanche_golem","location":{"mapId":"frostspire_peaks","points":[{"x":1580,"y":459}]}}]}') as QuestGuidance,
  },
  'dusk_wolf_road': {
    id: 'dusk_wolf_road',
    name: 'Wolves on the Moor Road',
    description: 'Wolves come down into the vale at dusk and take whatever walks the road from the moor. Lampwarden Orrin keeps the lamps lit on that road, and the wolves are learning to ignore them. Thin the packs on the vale floor.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 10,
    objectives: [
    { type: 'kill' as const, targetId: 'wolf', targetCount: 8,
      description: 'Defeat Wolves on the vale floor', },
    ],
    rewards: {
      xp: 900,
      gold: 240,
      items: [
        { id: 'red_potion', name: 'Red Potion', type: 'consumable', quantity: 4, maxStack: 99, description: 'A basic potion that restores 50 HP.', icon: '🧪', stats: { hp: 50 } },
      ],
    },
    startNpc: 'dusk_lampwarden',
    endNpc: 'dusk_lampwarden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"dusk_lampwarden","location":{"mapId":"duskfall_vale","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"wolf","location":{"mapId":"duskfall_vale","points":[{"x":1300,"y":1240},{"x":1750,"y":1240}]}}]}') as QuestGuidance,
  },
  'dusk_wolf_pelts': {
    id: 'dusk_wolf_pelts',
    name: 'Meat for the Lamps',
    description: 'Orrin burns rendered fat in the vale\'s lamps, and the wolves that come for the travellers are the cheapest supply there is. Bring back wolf meat; Orrin will do the rest.',
    type: 'collect' as QuestType,
    questType: 'side',
    requiredLevel: 10,
    objectives: [
    { type: 'collect' as const, targetId: 'wolf_meat', targetCount: 8,
      description: 'Collect Wolf Meat from the vale\'s wolves', },
    ],
    rewards: {
      xp: 850,
      gold: 220,
      items: [
        { id: 'red_potion', name: 'Red Potion', type: 'consumable', quantity: 3, maxStack: 99, description: 'A basic potion that restores 50 HP.', icon: '🧪', stats: { hp: 50 } },
      ],
    },
    startNpc: 'dusk_lampwarden',
    endNpc: 'dusk_lampwarden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"dusk_lampwarden","location":{"mapId":"duskfall_vale","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"collect","targetId":"wolf_meat","location":{"mapId":"duskfall_vale","points":[]}}]}') as QuestGuidance,
  },
  'dusk_wolf_cull': {
    id: 'dusk_wolf_cull',
    name: 'The Pack Grows',
    description: 'The packs are bigger every night, and some of the wolves running with them foam at the mouth. Orrin wants both kinds kept down before the sickness spreads through the vale.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 11,
    requiredQuests: ['dusk_wolf_road'],
    objectives: [
    { type: 'kill' as const, targetId: 'wolf', targetCount: 10,
      description: 'Defeat Wolves', },
    { type: 'kill' as const, targetId: 'rabid_wolf', targetCount: 3,
      description: 'Defeat Rabid Wolves', },
    ],
    rewards: {
      xp: 1050,
      gold: 280,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 3, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'dusk_lampwarden',
    endNpc: 'dusk_lampwarden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"dusk_lampwarden","location":{"mapId":"duskfall_vale","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"wolf","location":{"mapId":"duskfall_vale","points":[{"x":1300,"y":1240},{"x":1750,"y":1240}]}},{"kind":"kill","targetId":"rabid_wolf","location":{"mapId":"duskfall_vale","points":[{"x":1350,"y":886},{"x":2200,"y":1246}]}}]}') as QuestGuidance,
  },
  'dusk_thin_the_pack': {
    id: 'dusk_thin_the_pack',
    name: 'Thin the Pack',
    description: 'A pack thinned is a pack that comes back. Orrin pays every day to keep the numbers down.',
    type: 'kill' as QuestType,
    questType: 'daily',
    requiredLevel: 11,
    requiredQuests: ['dusk_wolf_road'],
    objectives: [
    { type: 'kill' as const, targetId: 'wolf', targetCount: 12,
      description: 'Defeat 12 Wolves', },
    ],
    rewards: {
      xp: 1000,
      gold: 40,
    },
    startNpc: 'dusk_lampwarden',
    endNpc: 'dusk_lampwarden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"dusk_lampwarden","location":{"mapId":"duskfall_vale","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"wolf","location":{"mapId":"duskfall_vale","points":[{"x":1300,"y":1240},{"x":1750,"y":1240}]}}]}') as QuestGuidance,
  },
  'dusk_rabid_alphas': {
    id: 'dusk_rabid_alphas',
    name: 'The Foaming Alphas',
    description: 'The rabid wolves follow alphas that hunt from the outcrops, and the sickness travels with them. Put down the sick wolves wherever they run, outcrop or floor.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 12,
    requiredQuests: ['dusk_wolf_cull'],
    objectives: [
    { type: 'kill' as const, targetId: 'rabid_wolf', targetCount: 6,
      description: 'Defeat Rabid Wolves', },
    ],
    rewards: {
      xp: 1150,
      gold: 300,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 3, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'dusk_lampwarden',
    endNpc: 'dusk_lampwarden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"dusk_lampwarden","location":{"mapId":"duskfall_vale","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"rabid_wolf","location":{"mapId":"duskfall_vale","points":[{"x":1350,"y":886},{"x":2200,"y":1246}]}}]}') as QuestGuidance,
  },
  'dusk_dire_alpha': {
    id: 'dusk_dire_alpha',
    name: 'Dire Wolves in the Hollow',
    description: 'Dire wolves den in the gloaming hollow, and they are bigger than anything else in the vale. Orrin has heard them hunting in the hollow every night for a month. End it.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 13,
    requiredQuests: ['dusk_rabid_alphas'],
    objectives: [
    { type: 'kill' as const, targetId: 'dire_wolf', targetCount: 6,
      description: 'Defeat Dire Wolves in the gloaming hollow', },
    ],
    rewards: {
      xp: 1300,
      gold: 340,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 4, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'dusk_lampwarden',
    endNpc: 'dusk_lampwarden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"dusk_lampwarden","location":{"mapId":"duskfall_vale","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"dire_wolf","location":{"mapId":"duskfall_vale","points":[{"x":1600,"y":992}]}}]}') as QuestGuidance,
  },
  'dusk_moonhowlers': {
    id: 'dusk_moonhowlers',
    name: 'The Moonhowlers',
    description: 'The wolves were never the real danger. Up on the star blooms live the Moonhowlers, folk caught by an old moon curse who turn wolfish after dark. Orrin has tried talking to them. It does not work after sundown. Drive them back.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 15,
    requiredQuests: ['dusk_dire_alpha'],
    objectives: [
    { type: 'kill' as const, targetId: 'moonhowler_lurker', targetCount: 8,
      description: 'Defeat Moonhowler Lurkers', },
    ],
    rewards: {
      xp: 1500,
      gold: 400,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 5, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'dusk_lampwarden',
    endNpc: 'dusk_lampwarden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"dusk_lampwarden","location":{"mapId":"duskfall_vale","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"moonhowler_lurker","location":{"mapId":"duskfall_vale","points":[{"x":1950,"y":871},{"x":2200,"y":751},{"x":2700,"y":991},{"x":2760,"y":1231}]}}]}') as QuestGuidance,
  },
  'dusk_grimfang': {
    id: 'dusk_grimfang',
    name: 'Grimfang the Ravenous',
    description: 'Grimfang leads the Moonhowlers from the twilight outcrop, bigger and hungrier than the rest, and the curse sits heaviest on him. While Grimfang hunts, the vale is not safe even in daylight. Climb the outcrop and finish it.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 16,
    requiredQuests: ['dusk_moonhowlers'],
    objectives: [
    { type: 'kill' as const, targetId: 'grimfang_the_ravenous', targetCount: 1,
      description: 'Defeat Grimfang the Ravenous on the twilight outcrop', },
    ],
    rewards: {
      xp: 2000,
      gold: 520,
      items: [
        { id: 'power_elixir', name: 'Power Elixir', type: 'consumable', quantity: 1, maxStack: 99, description: 'Fully restores HP and MP.', icon: '⚡', stats: { hp: 9999, mp: 9999 } },
      ],
    },
    startNpc: 'dusk_lampwarden',
    endNpc: 'dusk_lampwarden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"dusk_lampwarden","location":{"mapId":"duskfall_vale","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"grimfang_the_ravenous","location":{"mapId":"duskfall_vale","points":[{"x":1100,"y":724}]}}]}') as QuestGuidance,
  },
  'blood_risen_dead': {
    id: 'blood_risen_dead',
    name: 'The Risen Dead',
    description: 'The dead of Bloodmoon Reach will not stay buried. They shamble along the valley floor with no mind left in them, and Gravewatch Mira is tired of digging the same graves twice. Put them down.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 16,
    objectives: [
    { type: 'kill' as const, targetId: 'mindless_zombie', targetCount: 10,
      description: 'Defeat Mindless Zombies on the reach\'s floor', },
    ],
    rewards: {
      xp: 1300,
      gold: 400,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 4, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'blood_gravewatch',
    endNpc: 'blood_gravewatch',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"blood_gravewatch","location":{"mapId":"bloodmoon_reach","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"mindless_zombie","location":{"mapId":"bloodmoon_reach","points":[{"x":1650,"y":1238},{"x":2100,"y":1238}]}}]}') as QuestGuidance,
  },
  'blood_plague_rats': {
    id: 'blood_plague_rats',
    name: 'Rat Infestation',
    description: 'The rats of the reach feed on what the dead leave behind, and they carry the sickness that raised them. Mira wants them thinned before they reach the vale.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 16,
    objectives: [
    { type: 'kill' as const, targetId: 'plague_rat', targetCount: 10,
      description: 'Defeat Plague Rats on the floor and the low ledge', },
    ],
    rewards: {
      xp: 1300,
      gold: 400,
      items: [
        { id: 'cooked_wolf_meat', name: 'Cooked Wolf Meat', type: 'consumable', quantity: 3, maxStack: 20, description: 'Restores 200 health while eating.', icon: 'sprites/items/cooked_wolf_meat.png', stats: {} },
      ],
    },
    startNpc: 'blood_gravewatch',
    endNpc: 'blood_gravewatch',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"blood_gravewatch","location":{"mapId":"bloodmoon_reach","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"plague_rat","location":{"mapId":"bloodmoon_reach","points":[{"x":1900,"y":1264},{"x":2150,"y":1124}]}}]}') as QuestGuidance,
  },
  'blood_zealots': {
    id: 'blood_zealots',
    name: 'The Ember Vigil',
    description: 'The Ember Vigil came to the reach to burn out the dead. Now they see corruption in everyone who walks it, and they cut down the living as readily as the risen. Mira will not bury anyone else they kill. Break their camp.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 17,
    requiredQuests: ['blood_risen_dead'],
    objectives: [
    { type: 'kill' as const, targetId: 'ember_vigil_zealot', targetCount: 8,
      description: 'Defeat Ember Vigil Zealots at their camp', },
    ],
    rewards: {
      xp: 1400,
      gold: 420,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 4, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'blood_gravewatch',
    endNpc: 'blood_gravewatch',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"blood_gravewatch","location":{"mapId":"bloodmoon_reach","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"ember_vigil_zealot","location":{"mapId":"bloodmoon_reach","points":[{"x":1300,"y":1235},{"x":1350,"y":835}]}}]}') as QuestGuidance,
  },
  'blood_bone_wall': {
    id: 'blood_bone_wall',
    name: 'The Bone Wall',
    description: 'Skeletal warriors hold the ledges above the floor in ranks, the way they held them when they were the reach\'s garrison. They still guard it, against everyone. Break their line.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 19,
    objectives: [
    { type: 'kill' as const, targetId: 'skeletal_warrior', targetCount: 8,
      description: 'Defeat Skeletal Warriors on the ledges and in the hollow', },
    ],
    rewards: {
      xp: 1600,
      gold: 460,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 5, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'blood_gravewatch',
    endNpc: 'blood_gravewatch',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"blood_gravewatch","location":{"mapId":"bloodmoon_reach","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"skeletal_warrior","location":{"mapId":"bloodmoon_reach","points":[{"x":1700,"y":705},{"x":2150,"y":835}]}}]}') as QuestGuidance,
  },
  'blood_cauldrons': {
    id: 'blood_cauldrons',
    name: 'The Bone Casters',
    description: 'Skeletal mages keep the red fog over the reach, chanting over it from the high steps. While they stand, the dead keep rising. Silence them.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 20,
    requiredQuests: ['blood_bone_wall'],
    objectives: [
    { type: 'kill' as const, targetId: 'skeletal_mage', targetCount: 6,
      description: 'Defeat Skeletal Mages on the steps and ledges', },
    ],
    rewards: {
      xp: 1700,
      gold: 480,
      items: [
        { id: 'power_elixir', name: 'Power Elixir', type: 'consumable', quantity: 1, maxStack: 99, description: 'Fully restores HP and MP.', icon: '⚡', stats: { hp: 9999, mp: 9999 } },
      ],
    },
    startNpc: 'blood_gravewatch',
    endNpc: 'blood_gravewatch',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"blood_gravewatch","location":{"mapId":"bloodmoon_reach","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"skeletal_mage","location":{"mapId":"bloodmoon_reach","points":[{"x":2480,"y":965},{"x":1900,"y":705},{"x":1330,"y":705}]}}]}') as QuestGuidance,
  },
  'blood_malakar': {
    id: 'blood_malakar',
    name: 'The Arch-Lich',
    description: 'Arch-Lich Malakar stands on the reach\'s highest ledge, and every corpse in the valley answers to him. Mira has buried his work for years. End him, and the dead out there will finally just be dead.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 22,
    requiredQuests: ['blood_cauldrons'],
    objectives: [
    { type: 'kill' as const, targetId: 'arch_lich_malakar', targetCount: 1,
      description: 'Defeat Arch-Lich Malakar on the highest ledge', },
    ],
    rewards: {
      xp: 2900,
      gold: 760,
      items: [
        { id: 'power_elixir', name: 'Power Elixir', type: 'consumable', quantity: 2, maxStack: 99, description: 'Fully restores HP and MP.', icon: '⚡', stats: { hp: 9999, mp: 9999 } },
      ],
    },
    startNpc: 'blood_gravewatch',
    endNpc: 'blood_gravewatch',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"blood_gravewatch","location":{"mapId":"bloodmoon_reach","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"arch_lich_malakar","location":{"mapId":"bloodmoon_reach","points":[{"x":1580,"y":530}]}}]}') as QuestGuidance,
  },
  'amber_gearwright_loggers': {
    id: 'amber_gearwright_loggers',
    name: 'Red Paint',
    description: 'The Gearwright Company has moved into Amber Grove with saws and ledgers, marking the oldest trees for felling. Grovekeeper Fenn can\'t stop them alone. Drive their loggers out of the clearing.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 9,
    objectives: [
    { type: 'kill' as const, targetId: 'gearwright_logger', targetCount: 10,
      description: 'Defeat Gearwright Loggers in the clearing', },
    ],
    rewards: {
      xp: 850,
      gold: 220,
      items: [
        { id: 'red_potion', name: 'Red Potion', type: 'consumable', quantity: 4, maxStack: 99, description: 'A basic potion that restores 50 HP.', icon: '🧪', stats: { hp: 50 } },
      ],
    },
    startNpc: 'amber_grovekeeper',
    endNpc: 'amber_grovekeeper',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"amber_grovekeeper","location":{"mapId":"amber_grove","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"gearwright_logger","location":{"mapId":"amber_grove","points":[{"x":1300,"y":1235},{"x":1700,"y":1235}]}}]}') as QuestGuidance,
  },
  'amber_blighted_treants': {
    id: 'amber_blighted_treants',
    name: 'Blighted Growth',
    description: 'The darkwood treants woke angry when the cutting began, and the blight in their bark makes them strike at anything that walks the grove. Fenn asks you to put the worst of them to rest before they reach the savanna road.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 10,
    objectives: [
    { type: 'kill' as const, targetId: 'darkwood_treant', targetCount: 6,
      description: 'Defeat Darkwood Treants on the amber ledges and the leaf piles', },
    ],
    rewards: {
      xp: 900,
      gold: 240,
      items: [
        { id: 'red_potion', name: 'Red Potion', type: 'consumable', quantity: 4, maxStack: 99, description: 'A basic potion that restores 50 HP.', icon: '🧪', stats: { hp: 50 } },
      ],
    },
    startNpc: 'amber_grovekeeper',
    endNpc: 'amber_grovekeeper',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"amber_grovekeeper","location":{"mapId":"amber_grove","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"darkwood_treant","location":{"mapId":"amber_grove","points":[{"x":1560,"y":638},{"x":2160,"y":688}]}}]}') as QuestGuidance,
  },
  'amber_scarecrows': {
    id: 'amber_scarecrows',
    name: 'The Walking Field',
    description: 'East of the clearing, the old farmstead\'s scarecrows have climbed down from their posts and walk the rows. Nobody planted them there to fight, but they fight anyway. Fenn wants the farm road open again.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 11,
    objectives: [
    { type: 'kill' as const, targetId: 'scarecrow_golem', targetCount: 8,
      description: 'Defeat Scarecrow Golems on the farmstead floor', },
    ],
    rewards: {
      xp: 1050,
      gold: 280,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 3, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'amber_grovekeeper',
    endNpc: 'amber_grovekeeper',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"amber_grovekeeper","location":{"mapId":"amber_grove","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"scarecrow_golem","location":{"mapId":"amber_grove","points":[{"x":2250,"y":1235},{"x":2600,"y":1235}]}}]}') as QuestGuidance,
  },
  'amber_duchess': {
    id: 'amber_duchess',
    name: 'The Duchess',
    description: 'The one who woke the scarecrows has a title, or says she does. The Duchess holds court at the end of the farm road in a ruined ball gown and a tin tiara, and she does not take kindly to visitors. Fenn would like her gone.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 12,
    requiredQuests: ['amber_scarecrows'],
    objectives: [
    { type: 'kill' as const, targetId: 'duchess', targetCount: 1,
      description: 'Defeat the Duchess at the east end of the farm', },
    ],
    rewards: {
      xp: 1300,
      gold: 340,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 3, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'amber_grovekeeper',
    endNpc: 'amber_grovekeeper',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"amber_grovekeeper","location":{"mapId":"amber_grove","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"duchess","location":{"mapId":"amber_grove","points":[{"x":2960,"y":1235}]}}]}') as QuestGuidance,
  },
  'amber_elder_treant': {
    id: 'amber_elder_treant',
    name: 'The Elder',
    description: 'The oldest tree in the grove has walked out onto the hollow log, and the blight that took the darkwood treants has taken it too. Fenn has known the Elder all their life. They ask you to end it cleanly.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 13,
    requiredQuests: ['amber_blighted_treants'],
    objectives: [
    { type: 'kill' as const, targetId: 'elder_treant', targetCount: 1,
      description: 'Defeat the Elder Treant on the hollow log', },
    ],
    rewards: {
      xp: 1600,
      gold: 420,
      items: [
        { id: 'power_elixir', name: 'Power Elixir', type: 'consumable', quantity: 1, maxStack: 99, description: 'Fully restores HP and MP.', icon: '⚡', stats: { hp: 9999, mp: 9999 } },
      ],
    },
    startNpc: 'amber_grovekeeper',
    endNpc: 'amber_grovekeeper',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"amber_grovekeeper","location":{"mapId":"amber_grove","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"elder_treant","location":{"mapId":"amber_grove","points":[{"x":1870,"y":552}]}}]}') as QuestGuidance,
  },
  'canopy_thornpaw': {
    id: 'canopy_thornpaw',
    name: 'The Keepers',
    description: 'The Thornpaw are bear-folk who keep the deep canopy, and they have stopped telling travellers apart. Their pathfinders turn back anyone who climbs in, with claws. Canopy Ranger Ilse needs the trail open; thin their patrols on the canopy floor.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 15,
    objectives: [
    { type: 'kill' as const, targetId: 'thornpaw_pathfinder', targetCount: 8,
      description: 'Defeat Thornpaw Pathfinders on the canopy floor', },
    ],
    rewards: {
      xp: 1250,
      gold: 380,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 4, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'canopy_ranger',
    endNpc: 'canopy_ranger',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"canopy_ranger","location":{"mapId":"verdant_canopy","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"thornpaw_pathfinder","location":{"mapId":"verdant_canopy","points":[{"x":1700,"y":1235},{"x":2100,"y":1235}]}}]}') as QuestGuidance,
  },
  'canopy_spider_silk': {
    id: 'canopy_spider_silk',
    name: 'Weaver Silk',
    description: 'The Canopy Weavers string the high ledges with silk strong enough to hold a ranger\'s weight. Ilse\'s ropes are fraying. Bring back silk from the Weavers on the mossy ledge and the fungal shelf.',
    type: 'collect' as QuestType,
    questType: 'side',
    requiredLevel: 15,
    objectives: [
    { type: 'collect' as const, targetId: 'spider_silk_thread', targetCount: 8,
      description: 'Collect Spider Silk from the Canopy Weavers', },
    ],
    rewards: {
      xp: 1250,
      gold: 380,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 4, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'canopy_ranger',
    endNpc: 'canopy_ranger',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"canopy_ranger","location":{"mapId":"verdant_canopy","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"collect","targetId":"spider_silk_thread","location":{"mapId":"verdant_canopy","points":[]}}]}') as QuestGuidance,
  },
  'canopy_bears': {
    id: 'canopy_bears',
    name: 'Up From the Caves',
    description: 'Something drove the cave bears up into the canopy, and they are hungry enough to charge anything that moves. Ilse wants the eastern floor safe to cross again.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 16,
    objectives: [
    { type: 'kill' as const, targetId: 'cave_bear', targetCount: 6,
      description: 'Defeat Cave Bears on the eastern floor', },
    ],
    rewards: {
      xp: 1300,
      gold: 400,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 4, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'canopy_ranger',
    endNpc: 'canopy_ranger',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"canopy_ranger","location":{"mapId":"verdant_canopy","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"cave_bear","location":{"mapId":"verdant_canopy","points":[{"x":2550,"y":1240}]}}]}') as QuestGuidance,
  },
  'canopy_ursula': {
    id: 'canopy_ursula',
    name: 'The Maneater',
    description: 'It was Ursula that drove the bears up: a she-bear the size of a cart, scarred and dark-furred, who hunts the far end of the canopy floor. The rangers have a name for her and no one left who has seen her twice. Ilse asks you to end it.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 18,
    requiredQuests: ['canopy_bears'],
    objectives: [
    { type: 'kill' as const, targetId: 'darkwood_bear_elite', targetCount: 1,
      description: 'Defeat Ursula the Maneater at the east end of the floor', },
    ],
    rewards: {
      xp: 1900,
      gold: 520,
      items: [
        { id: 'power_elixir', name: 'Power Elixir', type: 'consumable', quantity: 1, maxStack: 99, description: 'Fully restores HP and MP.', icon: '⚡', stats: { hp: 9999, mp: 9999 } },
      ],
    },
    startNpc: 'canopy_ranger',
    endNpc: 'canopy_ranger',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"canopy_ranger","location":{"mapId":"verdant_canopy","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"darkwood_bear_elite","location":{"mapId":"verdant_canopy","points":[{"x":2950,"y":1228}]}}]}') as QuestGuidance,
  },
  'canopy_venomancer': {
    id: 'canopy_venomancer',
    name: 'The Fern Hollow',
    description: 'The Weavers spin for something. In the fern hollow above the floor nests the Venomancer, a red-backed spider grown huge on what its weavers bring it. Ilse\'s ropes are ready now, and so, she says, are you.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 19,
    requiredQuests: ['canopy_spider_silk'],
    objectives: [
    { type: 'kill' as const, targetId: 'venomous_spider_elite', targetCount: 1,
      description: 'Defeat the Venomancer in the fern hollow', },
    ],
    rewards: {
      xp: 2300,
      gold: 600,
      items: [
        { id: 'power_elixir', name: 'Power Elixir', type: 'consumable', quantity: 2, maxStack: 99, description: 'Fully restores HP and MP.', icon: '⚡', stats: { hp: 9999, mp: 9999 } },
      ],
    },
    startNpc: 'canopy_ranger',
    endNpc: 'canopy_ranger',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"canopy_ranger","location":{"mapId":"verdant_canopy","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"venomous_spider_elite","location":{"mapId":"verdant_canopy","points":[{"x":1960,"y":699}]}}]}') as QuestGuidance,
  },
  'deep_kobold_raiders': {
    id: 'deep_kobold_raiders',
    name: 'Diggers at the Door',
    description: 'Kobolds have tunnelled up from the deep and dig wherever they please, the cave mouth included. Delver Bram can\'t map a cave that keeps changing shape. Drive the workers back from the floor.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 12,
    objectives: [
    { type: 'kill' as const, targetId: 'kobold_worker', targetCount: 10,
      description: 'Defeat Kobold Workers on the cave floor', },
    ],
    rewards: {
      xp: 1000,
      gold: 280,
      items: [
        { id: 'red_potion', name: 'Red Potion', type: 'consumable', quantity: 4, maxStack: 99, description: 'A basic potion that restores 50 HP.', icon: '🧪', stats: { hp: 50 } },
      ],
    },
    startNpc: 'deep_delver',
    endNpc: 'deep_delver',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"deep_delver","location":{"mapId":"sunless_deep","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"kobold_worker","location":{"mapId":"sunless_deep","points":[{"x":1300,"y":1248},{"x":1650,"y":1248}]}}]}') as QuestGuidance,
  },
  'deep_tunnelers': {
    id: 'deep_tunnelers',
    name: 'The Tunnelers',
    description: 'The tunnelers dig the new passages, and every passage they dig is one more Bram has to walk. They work the stone shelf above the floor and the far end of the cave. Put a stop to the digging.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 13,
    objectives: [
    { type: 'kill' as const, targetId: 'kobold_tunneler', targetCount: 12,
      description: 'Defeat Kobold Tunnelers on the shelf and the far floor', },
    ],
    rewards: {
      xp: 1100,
      gold: 300,
      items: [
        { id: 'red_potion', name: 'Red Potion', type: 'consumable', quantity: 4, maxStack: 99, description: 'A basic potion that restores 50 HP.', icon: '🧪', stats: { hp: 50 } },
      ],
    },
    startNpc: 'deep_delver',
    endNpc: 'deep_delver',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"deep_delver","location":{"mapId":"sunless_deep","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"kobold_tunneler","location":{"mapId":"sunless_deep","points":[{"x":1220,"y":838},{"x":2000,"y":1248}]}}]}') as QuestGuidance,
  },
  'deep_kobold_miners': {
    id: 'deep_kobold_miners',
    name: 'Ore Thieves',
    description: 'The kobold miners strip the deep alcove of ore and haul it somewhere further down. Bram wants to know where, but first wants them gone from the alcove.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 14,
    objectives: [
    { type: 'kill' as const, targetId: 'kobold_miner', targetCount: 8,
      description: 'Defeat Kobold Miners in the deep alcove', },
    ],
    rewards: {
      xp: 1150,
      gold: 320,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 3, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'deep_delver',
    endNpc: 'deep_delver',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"deep_delver","location":{"mapId":"sunless_deep","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"kobold_miner","location":{"mapId":"sunless_deep","points":[{"x":1600,"y":967}]}}]}') as QuestGuidance,
  },
  'deep_kobold_shaman': {
    id: 'deep_kobold_shaman',
    name: 'Silence the Shaman',
    description: 'The tracks lead to the glowstone steps, where a kobold shaman chants the diggers on. Without the shaman, Bram thinks, the rest will scatter.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 15,
    requiredQuests: ['deep_kobold_miners'],
    objectives: [
    { type: 'kill' as const, targetId: 'kobold_shaman', targetCount: 1,
      description: 'Defeat the Kobold Shaman on the glowstone steps', },
    ],
    rewards: {
      xp: 1300,
      gold: 360,
    },
    startNpc: 'deep_delver',
    endNpc: 'deep_delver',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"deep_delver","location":{"mapId":"sunless_deep","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"kobold_shaman","location":{"mapId":"sunless_deep","points":[{"x":2270,"y":1107}]}}]}') as QuestGuidance,
    rewardClassItems: {
      druid: { id: 'thornwood_crook', name: 'Thornwood Crook', type: 'weapon', quantity: 1, maxStack: 1, description: 'A shepherd\'s crook grown, not carved, from a living thorn hedge.', icon: 'weapon_staff_thornwood', stats: { magicAttack: 22, intelligence: 4, dexterity: 3, mp: 20 } },
      hunter: { id: 'composite_bow', name: 'Composite Bow', type: 'weapon', quantity: 1, maxStack: 1, description: 'A powerful bow crafted from layered materials.', icon: 'weapon_bow_composite', stats: { attack: 22, dexterity: 8 } },
      mage: { id: 'oak_staff', name: 'Oak Staff', type: 'weapon', quantity: 1, maxStack: 1, description: 'A gnarled oak staff humming with latent energy.', icon: 'weapon_staff_oak', stats: { magicAttack: 25, intelligence: 5, mp: 30 } },
      paladin: { id: 'blessed_warhammer', name: 'Blessed Warhammer', type: 'weapon', quantity: 1, maxStack: 1, description: 'A warhammer blessed by the light. Strikes with divine force.', icon: 'weapon_hammer_blessed', stats: { attack: 20, strength: 4, intelligence: 3 } },
      priest: { id: 'vesper_staff', name: 'Vesper Staff', type: 'weapon', quantity: 1, maxStack: 1, description: 'A pale ashwood staff capped with a lamp of white glass. Its glow steadies a healer\'s hands.', icon: 'weapon_staff_vesper', stats: { magicAttack: 22, intelligence: 5, mp: 40 } },
      rogue: { id: 'shadow_dagger', name: 'Shadow Dagger', type: 'weapon', quantity: 1, maxStack: 1, description: 'A dagger infused with shadow essence. Strikes from the dark.', icon: 'weapon_dagger_shadow', stats: { attack: 18, dexterity: 6, luck: 4 } },
      shaman: { id: 'stormroot_totem', name: 'Stormroot Totem', type: 'weapon', quantity: 1, maxStack: 1, description: 'A carved root-post bound in copper wire. It hums before every storm.', icon: 'weapon_totem_stormroot', stats: { magicAttack: 21, intelligence: 4, strength: 3 } },
      warlock: { id: 'cinder_rod', name: 'Cinder Rod', type: 'weapon', quantity: 1, maxStack: 1, description: 'A blackened iron rod that stays warm long after the fire has gone out.', icon: 'weapon_wand_cinder', stats: { magicAttack: 25, intelligence: 6 } },
      warrior: { id: 'steel_longsword', name: 'Steel Longsword', type: 'weapon', quantity: 1, maxStack: 1, description: 'A well-forged steel blade. Reliable in battle.', icon: 'weapon_sword_steel', stats: { attack: 25, strength: 5 } },
    },
  },
  'deep_clodkin': {
    id: 'deep_clodkin',
    name: 'Stone Eaters',
    description: 'The Clodkin are stone-skinned burrowers who chew through the crystal seams, and they treat anything that walks their floor as one more rock to break. Bram needs the eastern floor clear to reach the deepest chamber.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 15,
    objectives: [
    { type: 'kill' as const, targetId: 'clodkin_stonecutter', targetCount: 8,
      description: 'Defeat Clodkin Stonecutters on the eastern floor', },
    ],
    rewards: {
      xp: 1250,
      gold: 340,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 3, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'deep_delver',
    endNpc: 'deep_delver',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"deep_delver","location":{"mapId":"sunless_deep","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"clodkin_stonecutter","location":{"mapId":"sunless_deep","points":[{"x":2350,"y":1247},{"x":2700,"y":1247}]}}]}') as QuestGuidance,
  },
  'deep_deepglow_ooze': {
    id: 'deep_deepglow_ooze',
    name: 'The Glow Below',
    description: 'The Deepglow Ooze lights the deep caves and dissolves whatever it touches, Bram\'s supply crates included. It pools on the glowstone steps and the hollow shelf. Clear it out.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 16,
    objectives: [
    { type: 'kill' as const, targetId: 'deepglow_ooze', targetCount: 6,
      description: 'Defeat Deepglow Oozes on the glowstone steps and the hollow shelf', },
    ],
    rewards: {
      xp: 1350,
      gold: 380,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 4, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'deep_delver',
    endNpc: 'deep_delver',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"deep_delver","location":{"mapId":"sunless_deep","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"deepglow_ooze","location":{"mapId":"sunless_deep","points":[{"x":1990,"y":1108},{"x":2450,"y":968}]}}]}') as QuestGuidance,
  },
  'deep_crystal_king': {
    id: 'deep_crystal_king',
    name: 'The Crystal King',
    description: 'At the far end of the deep, where the crystal grows thickest, something has grown a crown. The Clodkin bring it crystal, the kobolds dig for it, and the ooze lights its hall. Bram has mapped everything but this. End its reign.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 18,
    requiredQuests: ['deep_deepglow_ooze'],
    objectives: [
    { type: 'kill' as const, targetId: 'crystal_king', targetCount: 1,
      description: 'Defeat the Crystal King at the far end of the deep', },
    ],
    rewards: {
      xp: 2600,
      gold: 700,
      items: [
        { id: 'power_elixir', name: 'Power Elixir', type: 'consumable', quantity: 2, maxStack: 99, description: 'Fully restores HP and MP.', icon: '⚡', stats: { hp: 9999, mp: 9999 } },
      ],
    },
    startNpc: 'deep_delver',
    endNpc: 'deep_delver',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"deep_delver","location":{"mapId":"sunless_deep","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"crystal_king","location":{"mapId":"sunless_deep","points":[{"x":2980,"y":1210}]}}]}') as QuestGuidance,
  },
  'wastes_imps_and_slugs': {
    id: 'wastes_imps_and_slugs',
    name: 'Fire From Below',
    description: 'Flame imps and lava slugs crawl up out of the cracks in the ash, and every one that reaches the shore road sets something alight. Ashwarden Kael wants them pushed back from the western ruins.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 14,
    objectives: [
    { type: 'kill' as const, targetId: 'flame_imp', targetCount: 8,
      description: 'Defeat Flame Imps on the ruin shelves', },
    { type: 'kill' as const, targetId: 'lava_slug', targetCount: 3,
      description: 'Defeat Lava Slugs on the ash floor', },
    ],
    rewards: {
      xp: 1200,
      gold: 340,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 3, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'wastes_ashwarden',
    endNpc: 'wastes_ashwarden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"wastes_ashwarden","location":{"mapId":"smoldering_wastes","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"flame_imp","location":{"mapId":"smoldering_wastes","points":[{"x":1150,"y":880},{"x":1560,"y":1000},{"x":1700,"y":1250}]}},{"kind":"kill","targetId":"lava_slug","location":{"mapId":"smoldering_wastes","points":[{"x":1300,"y":1260}]}}]}') as QuestGuidance,
  },
  'wastes_flame_imps': {
    id: 'wastes_flame_imps',
    name: 'Keep the Imps Down',
    description: 'The imps never stop coming. Kael asks for the shelves to be cleared again, every day, before they gather into something worse.',
    type: 'kill' as QuestType,
    questType: 'daily',
    requiredLevel: 15,
    requiredQuests: ['wastes_imps_and_slugs'],
    objectives: [
    { type: 'kill' as const, targetId: 'flame_imp', targetCount: 12,
      description: 'Defeat Flame Imps across the wastes', },
    ],
    rewards: {
      xp: 1300,
      gold: 52,
    },
    startNpc: 'wastes_ashwarden',
    endNpc: 'wastes_ashwarden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"wastes_ashwarden","location":{"mapId":"smoldering_wastes","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"flame_imp","location":{"mapId":"smoldering_wastes","points":[{"x":1150,"y":880},{"x":1560,"y":1000},{"x":1700,"y":1250}]}}]}') as QuestGuidance,
  },
  'wastes_drake_brood': {
    id: 'wastes_drake_brood',
    name: 'The Cinder Brood',
    description: 'Fire drakes nest in the cinders, and this season\'s brood has hatched. They are young and still small, which is the only time to deal with them. Kael wants the brood thinned on the floor and the cinder mound.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 17,
    objectives: [
    { type: 'kill' as const, targetId: 'young_fire_drake', targetCount: 8,
      description: 'Defeat Young Fire Drakes on the floor and the cinder mound', },
    ],
    rewards: {
      xp: 1450,
      gold: 400,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 4, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'wastes_ashwarden',
    endNpc: 'wastes_ashwarden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"wastes_ashwarden","location":{"mapId":"smoldering_wastes","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"young_fire_drake","location":{"mapId":"smoldering_wastes","points":[{"x":2050,"y":1248},{"x":2310,"y":998}]}}]}') as QuestGuidance,
  },
  'wastes_magma_golem': {
    id: 'wastes_magma_golem',
    name: 'The Walking Furnace',
    description: 'A magma golem paces the high ash step, molten at the joints, and the heat off it cracks the stone beneath. Nothing gets east past it. Kael asks you to bring it down.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 17,
    requiredQuests: ['wastes_drake_brood'],
    objectives: [
    { type: 'kill' as const, targetId: 'magma_golem', targetCount: 1,
      description: 'Defeat the Magma Golem on the high ash step', },
    ],
    rewards: {
      xp: 1800,
      gold: 500,
      items: [
        { id: 'power_elixir', name: 'Power Elixir', type: 'consumable', quantity: 1, maxStack: 99, description: 'Fully restores HP and MP.', icon: '⚡', stats: { hp: 9999, mp: 9999 } },
      ],
    },
    startNpc: 'wastes_ashwarden',
    endNpc: 'wastes_ashwarden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"wastes_ashwarden","location":{"mapId":"smoldering_wastes","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"magma_golem","location":{"mapId":"smoldering_wastes","points":[{"x":2680,"y":840}]}}]}') as QuestGuidance,
  },
  'wastes_infernal': {
    id: 'wastes_infernal',
    name: 'The Imps\' Master',
    description: 'The imps call it their master: an Infernal, a burning giant of stone at the east end of the wastes, where the ground runs hottest. Everything here crawls out of its fire. End it, and the wastes might cool.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 19,
    requiredQuests: ['wastes_magma_golem'],
    objectives: [
    { type: 'kill' as const, targetId: 'infernal', targetCount: 1,
      description: 'Defeat the Infernal at the east end of the wastes', },
    ],
    rewards: {
      xp: 2800,
      gold: 760,
      items: [
        { id: 'frostborn_staff_epic', name: 'Frostborn Staff', type: 'weapon', quantity: 1, maxStack: 1, description: 'Cut from the permafrost of the far north, older than several kingdoms, the Frostborn Staff refuses warmth with near-personal contempt. A frozen tear from a water elemental hangs at the crown, and every spell cast through it lands with the hush that falls just before a lake seals over.', icon: 'sprites/equipment/frostborn_staff_epic.png', stats: { magicAttack: 170, intelligence: 35 } },
      ],
    },
    startNpc: 'wastes_ashwarden',
    endNpc: 'wastes_ashwarden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"wastes_ashwarden","location":{"mapId":"smoldering_wastes","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"infernal","location":{"mapId":"smoldering_wastes","points":[{"x":2650,"y":1180}]}}]}') as QuestGuidance,
  },
  'dunes_scarabs': {
    id: 'dunes_scarabs',
    name: 'Out of the Sand',
    description: 'Tomb scarabs boil up out of the dunes wherever the buried temple breathes, and they strip anything they find to the bone. Sandwarden Tova wants them thinned before they reach the wastes.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 22,
    objectives: [
    { type: 'kill' as const, targetId: 'tomb_scarab', targetCount: 12,
      description: 'Defeat Tomb Scarabs on the dune floor and the first mesa', },
    ],
    rewards: {
      xp: 1900,
      gold: 520,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 5, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'dunes_sandwarden',
    endNpc: 'dunes_sandwarden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"dunes_sandwarden","location":{"mapId":"scorched_dunes","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"tomb_scarab","location":{"mapId":"scorched_dunes","points":[{"x":1300,"y":1245},{"x":1190,"y":935},{"x":1700,"y":1245}]}}]}') as QuestGuidance,
  },
  'dunes_centaurs': {
    id: 'dunes_centaurs',
    name: 'Riders on the Mesa',
    description: 'Centaur scouts ride the dunes around the oasis rock and run down anyone who comes near the temple. Tova thinks someone is paying them to keep it that way. Break their patrols.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 23,
    objectives: [
    { type: 'kill' as const, targetId: 'centaur_scout', targetCount: 8,
      description: 'Defeat Centaur Scouts around the oasis rock', },
    ],
    rewards: {
      xp: 2000,
      gold: 540,
      items: [
        { id: 'orange_potion', name: 'Orange Potion', type: 'consumable', quantity: 5, maxStack: 99, description: 'A stronger potion that restores 150 HP.', icon: '🍊', stats: { hp: 150 } },
      ],
    },
    startNpc: 'dunes_sandwarden',
    endNpc: 'dunes_sandwarden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"dunes_sandwarden","location":{"mapId":"scorched_dunes","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"centaur_scout","location":{"mapId":"scorched_dunes","points":[{"x":2100,"y":1235},{"x":2140,"y":1015}]}}]}') as QuestGuidance,
  },
  'dunes_naga': {
    id: 'dunes_naga',
    name: 'The Singing Steps',
    description: 'Naga sirens have come up out of the temple\'s flooded halls to sing from the mesa and the sand step, and travellers who listen walk off the edge. Tova asks you to silence them.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 24,
    objectives: [
    { type: 'kill' as const, targetId: 'naga_siren', targetCount: 6,
      description: 'Defeat Naga Sirens on the mesa shelf and the sand step', },
    ],
    rewards: {
      xp: 2100,
      gold: 560,
      items: [
        { id: 'power_elixir', name: 'Power Elixir', type: 'consumable', quantity: 1, maxStack: 99, description: 'Fully restores HP and MP.', icon: '⚡', stats: { hp: 9999, mp: 9999 } },
      ],
    },
    startNpc: 'dunes_sandwarden',
    endNpc: 'dunes_sandwarden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"dunes_sandwarden","location":{"mapId":"scorched_dunes","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"naga_siren","location":{"mapId":"scorched_dunes","points":[{"x":1560,"y":1035},{"x":2460,"y":905}]}}]}') as QuestGuidance,
  },
  'dunes_guardian_trial': {
    id: 'dunes_guardian_trial',
    name: 'The Temple\'s Keeper',
    description: 'The archaeologist who dug the temple open went down alone and came back as its keeper, cursed and certain the temple is his. He waits at the east end of the dunes where the stair goes down. Tova calls it a trial; she means it is the last one.',
    type: 'kill' as QuestType,
    questType: 'side',
    requiredLevel: 25,
    requiredQuests: ['dunes_naga'],
    objectives: [
    { type: 'kill' as const, targetId: 'cursed_archaeologist', targetCount: 1,
      description: 'Defeat Keeper Halloran, the cursed archaeologist, at the temple stair', },
    ],
    rewards: {
      xp: 3000,
      gold: 800,
      items: [
        { id: 'bastard_sword_rare', name: 'Bastard Sword', type: 'weapon', quantity: 1, maxStack: 1, description: 'A versatile blade for one or two hands.', icon: 'sprites/items/bastard_sword_rare.png', stats: { attack: 42, strength: 8, hp: 5 } },
      ],
    },
    startNpc: 'dunes_sandwarden',
    endNpc: 'dunes_sandwarden',
    repeatable: false,
    guidance: JSON.parse('{"turnIn":{"npcId":"dunes_sandwarden","location":{"mapId":"scorched_dunes","points":[{"x":600,"y":1250}]}},"objectives":[{"kind":"kill","targetId":"cursed_archaeologist","location":{"mapId":"scorched_dunes","points":[{"x":3060,"y":1202}]}}]}') as QuestGuidance,
  },
};

export function getQuest(questId: string): QuestDefinition | null {
  return QUEST_DATABASE[questId] || null;
}

export function getAllQuests(): QuestDefinition[] {
  return Object.values(QUEST_DATABASE);
}

export function getAvailableQuests(playerLevel: number, completedQuests: string[]): QuestDefinition[] {
  return getAllQuests().filter(quest => {
    if (quest.offered === false) return false;
    if (quest.requiredLevel > playerLevel) return false;
    if (completedQuests.includes(quest.id)) return false;
    if (quest.requiredQuests?.some(id => !completedQuests.includes(id))) return false;
    return true;
  });
}

export function getQuestsByNpc(npcId: string): QuestDefinition[] {
  return getAllQuests().filter(quest => quest.startNpc === npcId);
}

export const QUEST_ITEM_DROPS: Record<string, {
  itemId: string; itemName: string; dropRate: number; requiredForQuests: string[];
}> = {
  pig: { itemId: 'pig_foot', itemName: 'Pig Foot', dropRate: 0.5, requiredForQuests: ['pig_feet_collector'] },
};

/** NPC line shown after the objectives are met, before rewards are claimed. */
export const QUEST_TURN_IN_MESSAGES: Record<string, string> = {
  'first_hunt': 'Eight marks in the ledger and not one pig followed you here. Tell me how the west fence held.',
  'pig_feet_collector': 'Set the samples on the dry cloth. Six is enough to tell me what has changed in the herd.',
  'the_fog_inland': 'You made it through the drowned highway and the wood? Then Sophia\'s judgment holds. Ranger Cole at your service.',
  'relic_collector': 'Three stones, all bearing Aislin\'s mark. Set them in the courier case and I will seal it eastbound.',
  'a_qualified_soul': 'Lark sent you? Then Lark\'s eyes are still good. Sit a moment. The wind up here carries the hollow\'s noise away.',
  'never_where_it_lands': 'You climbed back on your own legs, and there is dust on them that was not there before. Sit. Tell me where you were standing when the ground broke.',
  'somewhere_the_road_is_quiet': 'Pip told you about the ribbon, didn\'t he? He is very good at keeping secrets that have directions. Come in. The road is loud up there; down here you can hear the little things.',
  'moonfen_last_lantern': 'The same hand, on all three. He counted the animals first, then the families, then the lamps still burning. I wondered whether anyone would notice.',
};

export const QUEST_COMPLETION_MESSAGES: Record<string, string> = {
  'first_hunt': 'Warden Lark signs off on the hunt and opens the road to Tidewend. Open your bag {key:inventory}, right-click the {item:cloth_gloves} to put them on, then drag a {item:red_potion} to an empty hotbar slot and press that slot\'s key {key:hotbar} when you\'re hurt.',
  'pig_feet_collector': 'Naturalist Nessa records the healthy samples and the strange shore forage.',
  'explorer_first_steps': 'The world awaits! You\'re now an official explorer.',
  'mighty_warrior': 'Your power grows! You\'re becoming a true warrior.',
  'keep_the_peace': 'The streets are safe once more. You have my thanks.',
  'slime_samples': 'Excellent samples! My research will benefit greatly.',
  'mushroom_forager': 'These spores are perfect for potions. Come back anytime for more!',
  'pig_champion': 'The herd is thinned. Return if they get rowdy again.',
  'talk_to_the_guard': 'Captain Elowen sent you? Good, I could use some help.',
  'learn_to_craft': 'A natural alchemist! The crafting station is always open to you.',
  'elite_slayer': 'The elite has fallen! You\'ve earned a warrior\'s respect.',
  'veteran_hunter': 'A true veteran! Captain Elowen salutes your dedication.',
  'explore_wickhaven': 'Welcome to Wickhaven. Warm yourself at the hearth: every road into the old world starts at our gate.',
  'supply_run': 'Supplies received. The guards are grateful for your help.',
  'ready_for_adventure': 'You\'ve mastered the basics! The real adventure begins!',
  'dark_forest_expedition': 'You\'ve proven yourself in Lanternwood. When the ferry runs, Wickhaven\'s warden and its scholar will want someone like you: trolls on the forest road, and caverns under it.',
  'shadow_menace': 'The skies are safer. For now.',
  'crystal_expedition': 'The Crystal Caverns... what wonders lie within?',
  'golem_threat': 'The golems have been pushed back. The path is clear.',
  'cursed_patrol': 'The cursed suits of armor have been silenced. You are truly a hero.',
  'frozen_frontier': 'The ice drakes are retreating. The lake is safer now.',
  'crystal_hunter': 'Excellent specimens! The crystals will be useful.',
  'volcano_ascent': 'You\'ve reached the summit! Few have stood where you stand now.',
  'fire_and_fury': 'You\'ve conquered the volcano\'s guardians. True power is yours.',
  'void_hunter': 'The Void Wraith has been vanquished! You are a legend among adventurers.',
  'daily_volcano_patrol': 'Another day, another patrol. The volcano thanks you.',
  'daily_frozen_harvest': 'These scales are magnificent! Come back whenever you have more.',
  'daily_elite_bounty': 'Bounty collected. Well done, hunter.',
  'champion_of_helix': 'You have defeated the Infernal! You are the Champion of Helix!',
  'master_alchemist': 'You\'ve mastered alchemy! Truly a prodigy. Scholar Merrow in Wickhaven has a recipe worthy of you.',
  'ice_fishing': 'Fascinating specimens! The ice preserves them perfectly.',
  'bee_problem': 'The buzzing has stopped. The forest thanks you.',
  'troll_trouble': 'The trolls have been pushed back. Safe travels, adventurer.',
  'phoenix_hunt': 'The Phoenix falls! Its feathers shimmer with eternal fire.',
  'material_collector': 'These materials are invaluable for my research!',
  'sunken_discovery': 'These ruins predate everything we know. What secrets do they hold?',
  'ruin_guardians': 'The guardians have been silenced. The treasure vault awaits.',
  'daily_ruin_sweep': 'The ruins are clear. For now.',
  'ancient_power': 'This energy is extraordinary. It could power entire cities.',
  'legend_of_helix': 'You are the Legend of Helix! Your name will be remembered forever.',
  'jellyfish_study': 'Their bioluminescence is remarkable! Thank you for the specimens.',
  'boar_hunt': 'The paths are clear. Travelers will be grateful.',
  'crystal_research': 'The crystalline structure is unlike anything I\'ve seen before!',
  'shadow_investigation': 'The shadow energy is growing. We must remain vigilant.',
  'void_containment': 'The dimensional rifts are closing. But for how long?',
  'first_armor': 'Much better! You look like a real adventurer now. Take this {item:leather_boots} to match — every ghost should leave a little light behind.',
  'craft_your_first_ring': 'A fine piece of jewelry! You\'re becoming quite the artisan.',
  'drake_scale_collector': 'These scales are perfect for advanced crafting!',
  'daily_material_run': 'Every material has its use. Keep gathering!',
  'ultimate_crafter': 'The Ring of Power! You are truly a master crafter. The world bows to your skill.',
  'enchanting_basics': 'This dust resonates with magical energy. Scholar Merrow in Wickhaven can teach you to use it!',
  'fire_crystal_quest': 'These crystals burn with eternal flame. Magnificent!',
  'frost_shard_quest': 'So cold, yet so beautiful. Perfect for frost enchantments.',
  'void_essence_quest': 'A Void Fragment! With this, we can create truly legendary items.',
  'phoenix_feather_quest': 'A Phoenix Feather! This is the rarest material in all of Helix. You are truly legendary.',
  'temple_discovery': 'The temple is older than any ruins we know. What civilization built this?',
  'temple_guardians': 'The golems are defeated. The altar awaits.',
  'daily_temple_clear': 'The temple is clear. For today.',
  'altar_mystery': 'The inscriptions speak of a great power sealed within. We must be careful.',
  'temple_treasures': 'The treasures of the ancients are yours. You\'ve earned them.',
  'weapon_training': 'Impressive! You\'ve earned this weapon. Use it wisely.',
  'potion_apprentice': 'Perfect ingredients! Let me brew this for you.',
  'forest_patrol': 'The forest is safer thanks to you. The travelers will be grateful.',
  'gear_up': 'You\'ve proven yourself. This helm will serve you well.',
  'elite_slime_threat': 'The Elite Slime is defeated! You\'re becoming quite the adventurer.',
  'frozen_frontier_prep': 'You\'re well-prepared now. The Frozen Lake awaits, over the sea: Warden Halden in Wickhaven keeps its road.',
  'ice_drake_menace': 'The drakes are retreating. The lake is safer now.',
  'scale_collector': 'Beautiful scales! Here\'s your payment.',
  'cavern_expedition_prep': 'You\'ve survived the cavern entrance. The deeper chambers await.',
  'welcome_to_helix': 'Welcome, adventurer! Let me teach you the basics.',
  'learn_to_fight': 'Well done! You\'re a natural. Here\'s your first reward.',
  'visit_the_merchant': 'Welcome! Take a look at my wares. You earned some gold from your adventures!',
  'equipped_for_adventure': 'Ah, a new adventurer! Let me show you some starter gear.',
  'prove_yourself': 'Excellent! You\'ve proved your mettle. Take this {item:leather_boots} — let the road see you coming.',
  'corruption_spreads_1': 'Warden Rowan nods grimly. \'Something stirs in the Dark Forest, over the sea. Take the ferry from Tidewend\'s dock to Wickhaven and find Warden Halden at its gate. He keeps the forest road, and he has work for you.\'',
  'corruption_spreads_2': 'The forest breathes easier, but the source of corruption remains.',
  'corruption_spreads_3': 'These crystals pulse with malevolent energy. Scholar Merrow will know what to make of them.',
  'corruption_spreads_4': 'Merrow studies the crystals. \'There\'s a powerful creature at the heart of this corruption... Tell Warden Halden.\'',
  'corruption_spreads_5': 'Blightroot falls! The corruption begins to recede from the forest.',
  'missing_supplies_1': 'The merchant fears the worst. The supplies were last seen crossing the Frozen Lake, over the sea. Take the ferry to Wickhaven and ask Provisioner Pell: the crates were bound for his stores.',
  'missing_supplies_2': 'You found the crates, but they\'re guarded by hostile creatures!',
  'missing_supplies_3': 'The area is clear. Now recover those supplies!',
  'missing_supplies_4': 'The merchant is overjoyed! She rewards you with a fine weapon.',
  'crystal_expedition_1': 'These crystals are beautiful! But the caverns hide dangers...',
  'crystal_expedition_2': 'The elementals crumble! Something larger stirs deeper in the caverns...',
  'crystal_expedition_3': 'The Gem Golem shatters! The caverns are safe for mining once more.',
  'crystal_expedition_4': 'Merrow is thrilled, and teaches you new crafting techniques.',
  'ancient_temple_1': 'The runes speak of an ancient guardian and a powerful artifact hidden within...',
  'ancient_temple_2': 'The guardians fall, but more await deeper in the temple...',
  'ancient_temple_3': 'The altar shifts and reveals a stairway descending into darkness...',
  'ancient_temple_4': 'The Void Wraith dissipates! The ancient artifact pulses with power.',
  'ancient_temple_5': 'You\'ve recovered the Ancient Artifact! Merrow bows in reverence.',
  'frozen_mystery_1': 'The frozen remains tell a grim story. Something powerful lurks on the lake...',
  'frozen_mystery_2': 'The ice shards contain traces of an ancient frost magic...',
  'frozen_mystery_3': 'The tracks lead to an ice cave... something massive lurks within.',
  'frozen_mystery_4': 'The Frost Elemental shatters! The lake begins to thaw at last.',
  'tidewend_welcome': 'A new face! Welcome to Tidewend, traveler. We could surely use the help.',
  'strayed_pigs': 'Bless you. The herd\'s grazing again — though snails don\'t climb out of the salt for nothing. Something in that fog is pushing them.',
  'lantern_oil': 'That\'ll keep the lamps lit a good while. Whatever\'s out in that fog, it can stay out there.',
  'the_fog_inland': 'You felt it too, then — that cold the moment you crossed the brambles. Good. Means you\'re paying attention.',
  'clear_the_brambleway': 'Path\'s open. Stay close to the lanterns from here — it gets dark fast.',
  'whats_in_the_mist': '...You\'re shaking. So am I. Whatever\'s calling them, it\'s down in the lighthouse undercroft. We end this there.',
  'the_hollow_keeper': 'It\'s done. The fog\'s already thinning. You gave that poor soul his rest — and gave us back our island.',
  'relight_the_coil': 'The Coil turns again — see it shine? You came to us a stranger and leave a hero. The mainland\'s waiting for someone like you. Safe travels, friend.',
  'beyond_the_coil': 'Warden Rowan clasps your arm. \'Elder Wynn sent you? Praise the Light. We have got our hands full with this corruption...\'',
  'relic_collector': 'Sealed, and on its way to Elder Aislin. Good eyes — most walk right past those stones. When you\'re ready, the road east is yours.',
  'a_qualified_soul': 'This world has lost its soul, so nothing in it will wait for you, and nothing will forgive standing still. Move before the blow lands, never where it lands. That is easy to say on a rim. Down by the old observatory a stone guardian still walks its rounds: learn it there, then climb back to me. If your legs are not ready yet, Lark and Tidewend are back down the road. The guardian will keep.',
  'never_where_it_lands': 'In the air, and then somewhere else. You moved before the blow landed, never where it landed; most people need a stone giant to learn that. Now your feet know the way. Here is the step that goes with it, {ability:reward}: you will find it on your hotbar {key:hotbar}. Take these {item:orange_potion} for the road, and keep your feet light.',
  'fresh_catch': 'A proper catch! The village will eat well tonight. You\'ve a gift for the quiet work — not everyone does, you know.',
  'keepers_legend': 'Forty years he kept that Light — and I sailed by it every one of them. He\'d trim the wick at dusk and stand the gallery till dawn, and no boat out of Tidewend was ever lost while the Coil turned. Then one winter the Light just... stopped. No storm. No wreck. Just dark. Some say he took the mainland ferry and never looked back. But I\'ve watched the fog walk UP that hill of an evening — against the wind, mind — like something down in the undercroft is still calling the roll. Just an old man\'s story, of course. ...Of course it is.',
  'keepers_journal': 'Three pages. You read them? ...Then you know. He wasn\'t a monster — he was a man who loved the Light, and it broke him when it went out. Thank you for carrying his story. Not enough people do, these days.',
  'keep_the_coil_lit': 'The Light holds. As long as someone keeps watch, the Coil stays lit. ...You did good today, friend. Come back when you can.',
  'somewhere_the_road_is_quiet': 'There. Two little steps for when one feels too ordinary. You can keep whatever other tricks you\'ve learned; this one\'s happy beside them. Take the arch when you\'re ready; the path leads right back up to the road.',
  'glowspore_light_that_lasts': 'Orla seals the living glow in glass. The Sporeglass Lantern is yours to carry.',
  'moonfen_last_lantern': 'The pasture was never abandoned: its keeper followed the herd through the floods and left a light for anyone still coming. Orren gives you a {item:fenwatch_lantern}. Equip it in your Lantern slot to carry Moonfen\'s green-gold light. The return trail beside Orren leads straight to the Tidewend Outskirts.',
  'forest_road_dispatch': 'Iven shares his supplies. Sawkeeper Hetta has gone back to the abandoned camp for the tools that once tended the old grove. Follow her east.',
  'forest_camp_recovery': 'Hetta unwraps a pruning saw and a grafting knife. The camp once cared for the old grove as well as cutting timber. She gives you provisions for the eastern road and asks you to help Grovekeeper Senn face what has taken root there.',
  'forest_old_root': 'Senn gives you the {item:foresters_mantle} and two {item:return_scroll}s. Equip the mantle in your Back slot. The grove still needs watching, but today someone answered when its keepers called.',
  'savanna_longleg_hunt': 'The road by the arrival is quiet. Kestrel marks it on her chart as passable.',
  'savanna_strider_feathers': 'Kestrel ties the feathers into a bundle for Wickhaven\'s fletchers and pays you their share.',
  'savanna_tuskmire_camp': 'With the raiders scattered, the middle of the plain is open. Kestrel moves her road marker past the termite mound.',
  'savanna_stripe_runners': 'The eastern grass is calmer. Kestrel can report the whole south road to Wickhaven as open.',
  'savanna_tuskmire_warchief': 'Gorrak\'s totem goes down with him. Kestrel plants her road marker where it stood.',
  'swamp_gilling_camp': 'The reed huts are empty. Tilly marks the first stretch of boardwalk as safe.',
  'swamp_gilling_raids': 'The nets stay full for another day.',
  'swamp_snapjaw_road': 'The boardwalk is clear. Tilly can tell the savanna the Lowlands road reaches the swamp.',
  'swamp_toadstool_creepers': 'The toadstools are bare again. Tilly hangs her nets out to dry on the near one.',
  'swamp_bogchief': 'Sloughmaw\'s trident sinks in the mud. Tilly says the nets will last a whole season now.',
  'shore_sandstinger_nests': 'The sand goes quiet. Marlo marks the beach as walkable again.',
  'shore_sandstinger_sweep': 'The beach is clear for the boats. Same again tomorrow.',
  'shore_basilisk_rocks': 'The rocks are clear. Marlo hands you a gull that is very slowly turning back into a gull.',
  'shore_basilisk_brood': 'Nothing stares down from the driftwood any more. Marlo sends word up the Lowlands road that the shore is open.',
  'shore_siren_song': 'The driftwood is quiet. Marlo lights the beacon again, and the next boat comes in straight.',
  'shore_leviathan': 'The Leviathan sinks back into the deep and the surf goes still. The road east is open.',
  'moor_cutpurse_road': 'The heath road is quiet. Brannock says that only means the Brigands are watching from further out.',
  'moor_footpad_patrol': 'The carts cross the moor today. Same again tomorrow.',
  'moor_thug_camp': 'The fire is cold. Brannock found a list in the ashes, signed by someone called Grix.',
  'moor_grix_the_cunning': 'Grix\'s list is in Brannock\'s hands now, and it names someone Grix answered to: Captain Morrow Vane.',
  'moor_raiders': 'The raiders scatter. Brannock follows their tracks east to the peat cuttings.',
  'moor_smugglers': 'The sacks are full of Wickhaven\'s missing goods. Brannock sends them home and turns to the far end of the moor.',
  'moor_lieutenants': 'The lieutenants are down. Only the Captain is left.',
  'moor_captain_vane': 'The Captain\'s tricorne hangs on Brannock\'s wall. The north road is open, as far as the cliffs.',
  'cliffs_drake_scree': 'The scree path is clear. Rook can carry oil up to the beacon again.',
  'cliffs_windcallers': 'The wind drops to an ordinary gale. The beacon stays lit.',
  'cliffs_wyvern_roosts': 'The roosts are empty. For the first time in a season, nothing dives on the cliff road.',
  'cliffs_wyvern_cull': 'The ledges are clear for today.',
  'cliffs_harpy_matriarch': 'The flock scatters along the coast. Rook hands you a longbow that was waiting for someone with a steady arm.',
  'peaks_rimecrest_camp': 'The tents are down and the snowfield is quiet. Isk marks the lower road open.',
  'peaks_wendigos': 'The ledges are only cold now, not watched. Isk breathes easier.',
  'peaks_ice_wraiths': 'The shelves are still. Isk says a few names into the wind.',
  'peaks_wraith_vigil': 'Another day held. Same again tomorrow.',
  'peaks_rimecrest_hexers': 'The caps fall silent. Isk says the mountain sounds like a mountain again.',
  'peaks_avalanche_golem': 'The golem breaks apart into ordinary snow. Isk plants a flag on the summit for Wickhaven.',
  'dusk_wolf_road': 'The road from the moor is quiet. Orrin trims the wicks a little shorter tonight.',
  'dusk_wolf_pelts': 'The lamps will burn all week. Orrin says it smells terrible and works perfectly.',
  'dusk_wolf_cull': 'Fewer wolves, and none foaming on the road. Orrin breathes out.',
  'dusk_thin_the_pack': 'The packs keep their distance tonight. Same again tomorrow.',
  'dusk_rabid_alphas': 'The sickness has nowhere left to run. Orrin burns the bedding the wolves slept on.',
  'dusk_dire_alpha': 'The hollow is silent. Orrin says the silence is somehow worse, then laughs.',
  'dusk_moonhowlers': 'The Moonhowlers pull back into the dark. Orrin lights one more lamp, just in case.',
  'dusk_grimfang': 'Grimfang is gone. For the first night in years, Orrin lets a lamp go out on its own.',
  'blood_risen_dead': 'The floor is still. Mira marks ten more graves as closed.',
  'blood_plague_rats': 'Fewer rats, and fewer of them sick. Mira hands you a meal from her own stores.',
  'blood_zealots': 'The Vigil\'s fires are out. Mira does not say she is glad, but she does not bury them either.',
  'blood_bone_wall': 'The ledges are open. Mira says the garrison would have wanted it that way, eventually.',
  'blood_cauldrons': 'The fog thins. For the first time, Mira can see the high ledge, and who stands on it.',
  'blood_malakar': 'Malakar falls, and across the reach the dead lie down. Mira closes her book of graves.',
  'amber_gearwright_loggers': 'The saws are quiet. Fenn scrapes a red mark off the nearest trunk with a thumbnail.',
  'amber_blighted_treants': 'The ledges creak and settle. Fenn says the blight will pass, given time and no more saws.',
  'amber_scarecrows': 'Straw on the wind, and the farm road clear. Fenn wonders aloud who woke them.',
  'amber_duchess': 'The tiara is tin after all. Fenn keeps it anyway, on a nail by the door.',
  'amber_elder_treant': 'The Elder settles into the log as if it had always grown there. Fenn stands with it a while before speaking.',
  'canopy_thornpaw': 'The floor trail is open. Ilse says the Thornpaw will remember, and that it can\'t be helped.',
  'canopy_spider_silk': 'Ilse tests a strand between her fists and grins. New ropes by nightfall.',
  'canopy_bears': 'The eastern floor is quiet. Ilse wonders what drove them up, and whether it is still down there.',
  'canopy_ursula': 'Ursula is gone. Ilse cuts a notch in the ranger post, the first in a long time.',
  'canopy_venomancer': 'The hollow falls silent and the webs go slack. Ilse coils her new rope and says nothing for a while.',
  'deep_kobold_raiders': 'The floor holds still for once. Bram unrolls the map and starts drawing.',
  'deep_tunnelers': 'No new tunnels today. Bram says that is the best news a delver ever gets.',
  'deep_kobold_miners': 'The alcove is empty, and the carts are heading nowhere. Bram notes where the tracks lead.',
  'deep_kobold_shaman': 'The chanting stops, and somewhere below the digging stops with it.',
  'deep_clodkin': 'The eastern floor is quiet. Bram can hear water somewhere ahead.',
  'deep_deepglow_ooze': 'The steps are dark again. Bram says he misses the light already, and not the ooze.',
  'deep_crystal_king': 'The crown shatters with the king. Bram draws the last chamber on the map and signs it.',
  'wastes_imps_and_slugs': 'The western ruins stop smoking. Kael kicks ash over the last of the embers.',
  'wastes_flame_imps': 'The imps are down for today.',
  'wastes_drake_brood': 'The cinder mound is quiet. Kael counts the shells and seems satisfied.',
  'wastes_magma_golem': 'The golem cools to rock where it fell. Kael says it makes a decent landmark now.',
  'wastes_infernal': 'The Infernal crumbles into the ash. For the first time in years, Kael says, the wind blowing west is cool.',
  'dunes_scarabs': 'The sand settles. Tova says it will not stay settled, but it is a start.',
  'dunes_centaurs': 'The scouts scatter into the dunes. Tova finds a temple map in one of their packs.',
  'dunes_naga': 'The steps are quiet. Tova unstops her ears and listens to the wind for a while.',
  'dunes_guardian_trial': 'The keeper falls, and the stair fills with sand behind him. Tova hands over the blade he carried down.',
};
